var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));

// ../../node_modules/@rocicorp/licensing/src/server/api-types.ts
var apiVersion = "1.0";
var apiVersionMinor = parseInt(apiVersion.split(".")[1], 10);
var apiPath = "/api/" + apiVersion;
var apiRoute = "/api/:apiMajor.:apiMinor";
var CUSTOMER_PATH = apiPath + "/customer";
var CUSTOMER_ROUTE = apiRoute + "/customer";
var LICENSE_STATUS_PATH = apiPath + "/license/status";
var LICENSE_STATUS_ROUTE = apiRoute + "/license/status";
var LICENSE_ACTIVE_PATH = apiPath + "/license/active";
var LICENSE_ACTIVE_ROUTE = apiRoute + "/license/active";
var ADMIN_PATH = "/admin";
var ADMIN_DOWNLOAD_PATH = ADMIN_PATH + "/download";
var ADMIN_LICENSE_PATH = ADMIN_PATH + "/license/:key";
var ADMIN_LICENSES_ACTIVE_PATH = ADMIN_PATH + "/licenses/active";
var ADMIN_SIGNUPS_PATH = ADMIN_PATH + "/signups";
var ADMIN_POPULATE_PATH = ADMIN_PATH + "/populate";

// ../../node_modules/@rocicorp/licensing/src/client/asserts.ts
function assertString(v2) {
  assertType(v2, "string");
}
function assertBoolean(v2) {
  assertType(v2, "boolean");
}
function assertType(v2, t) {
  if (typeof v2 !== t) {
    throwInvalidType(v2, t);
  }
}
function assertObject(v2) {
  if (v2 === null) {
    throwInvalidType(v2, "object");
  }
  assertType(v2, "object");
}
function invalidType(v2, t) {
  let s = "Invalid type: ";
  if (v2 === null || v2 === void 0) {
    s += v2;
  } else {
    s += `${typeof v2} \`${v2}\``;
  }
  return s + `, expected ${t}`;
}
function throwInvalidType(v2, t) {
  throw new Error(invalidType(v2, t));
}

// ../../node_modules/@rocicorp/licensing/src/client/customer.ts
var PROD_LICENSE_SERVER_URL = new URL(
  "https://replicache-license.herokuapp.com/"
);

// ../../node_modules/@rocicorp/licensing/src/client/license.ts
async function licenseActive(mustFetch, serverURL, key, profileID, lc) {
  lc = lc.withContext("licenseActive");
  const url = new URL(LICENSE_ACTIVE_PATH, serverURL);
  const req = {
    licenseKey: key,
    profileID
  };
  const reqString = JSON.stringify(req);
  lc.debug?.(`Sending ${url}`, reqString);
  const response = await mustFetch("post", url.toString(), reqString, {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    "Content-Type": "application/json",
    // eslint-disable-next-line @typescript-eslint/naming-convention
    "Accept": "application/json"
  });
  const responseBody = await response.text();
  lc.debug?.(`Got ${url}`, responseBody);
  const res = JSON.parse(responseBody);
  assertLicenseActiveResponse(res);
}
async function getLicenseStatus(mustFetch, serverURL, key, lc) {
  lc = lc.withContext("getLicenseStatus");
  const url = new URL(LICENSE_STATUS_PATH, serverURL);
  const req = {
    licenseKey: key
  };
  const reqString = JSON.stringify(req);
  lc.debug?.(`Sending ${url}`, reqString);
  const response = await mustFetch("post", url.toString(), reqString, {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    "Content-Type": "application/json",
    // eslint-disable-next-line @typescript-eslint/naming-convention
    "Accept": "application/json"
  });
  const responseBody = await response.text();
  lc.debug?.(`Got ${url}`, responseBody);
  const res = JSON.parse(responseBody);
  assertGetLicenseStatusResponse(res);
  return res;
}
function assertLicenseActiveResponse(v2) {
  assertObject(v2);
}
function assertGetLicenseStatusResponse(v2) {
  assertObject(v2);
  assertString(v2.status);
  assertBoolean(v2.disable);
  assertBoolean(v2.pleaseUpdate);
}

// ../../node_modules/@rocicorp/licensing/src/client/env.ts
var TEST_LICENSE_KEY = "This key only good for automated testing";
var LOCAL_LICENSE_SERVER_URL = new URL("http://localhost:8080/");
var PROD_LICENSE_SERVER_URL2 = new URL(
  "https://replicache-license.herokuapp.com/"
);
var STAGING_LICENSE_SERVER_URL = new URL(
  "https://replicache-license-staging.herokuapp.com/"
);

// src/mod.ts
import { consoleLogSink as consoleLogSink3 } from "@rocicorp/logger";

// src/filter-async-iterable.ts
async function* filterAsyncIterable(iter, predicate) {
  for await (const v2 of iter) {
    if (predicate(v2)) {
      yield v2;
    }
  }
}

// ../shared/src/asserts.ts
function assert(b, msg = "Assertion failed") {
  if (!b) {
    throw new Error(msg);
  }
}
function assertString2(v2) {
  assertType2(v2, "string");
}
function assertNumber(v2) {
  assertType2(v2, "number");
}
function assertBoolean2(v2) {
  assertType2(v2, "boolean");
}
function assertType2(v2, t) {
  if (typeof v2 !== t) {
    throwInvalidType2(v2, t);
  }
}
function assertObject2(v2) {
  if (v2 === null) {
    throwInvalidType2(v2, "object");
  }
  assertType2(v2, "object");
}
function assertArray(v2) {
  if (!Array.isArray(v2)) {
    throwInvalidType2(v2, "array");
  }
}
function invalidType2(v2, t) {
  let s = "Invalid type: ";
  if (v2 === null || v2 === void 0) {
    s += v2;
  } else {
    s += `${typeof v2} \`${v2}\``;
  }
  return s + `, expected ${t}`;
}
function throwInvalidType2(v2, t) {
  throw new Error(invalidType2(v2, t));
}
function assertNotNull(v2) {
  if (v2 === null) {
    throw new Error("Expected non-null value");
  }
}
function assertNotUndefined(v2) {
  if (v2 === void 0) {
    throw new Error("Expected non undefined value");
  }
}
function unreachable() {
  throw new Error("Unreachable");
}

// ../shared/src/config.ts
var isProd = process.env.NODE_ENV === "production";

// ../shared/src/has-own.ts
var objectPrototypeHasOwnProperty = Object.prototype.hasOwnProperty;
var hasOwn = Object.hasOwn || ((object3, key) => objectPrototypeHasOwnProperty.call(object3, key));

// ../shared/src/json.ts
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  switch (typeof a) {
    case "boolean":
    case "number":
    case "string":
      return false;
  }
  a = a;
  if (Array.isArray(a)) {
    if (!Array.isArray(b)) {
      return false;
    }
    if (a.length !== b.length) {
      return false;
    }
    for (let i = 0; i < a.length; i++) {
      if (!deepEqual(a[i], b[i])) {
        return false;
      }
    }
    return true;
  }
  if (a === null || b === null) {
    return false;
  }
  if (Array.isArray(b)) {
    return false;
  }
  a = a;
  b = b;
  let aSize = 0;
  for (const key in a) {
    if (hasOwn(a, key)) {
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
      aSize++;
    }
  }
  let bSize = 0;
  for (const key in b) {
    if (hasOwn(b, key)) {
      bSize++;
    }
  }
  return aSize === bSize;
}
function assertJSONValue(v2) {
  if (isProd) {
    return;
  }
  switch (typeof v2) {
    case "boolean":
    case "number":
    case "string":
      return;
    case "object":
      if (v2 === null) {
        return;
      }
      if (Array.isArray(v2)) {
        return assertJSONArray(v2);
      }
      return assertObjectIsJSONObject(v2);
  }
  throwInvalidType2(v2, "JSON value");
}
function assertJSONObject(v2) {
  assertObject2(v2);
  assertObjectIsJSONObject(v2);
}
function assertObjectIsJSONObject(v2) {
  for (const k in v2) {
    if (hasOwn(v2, k)) {
      const value = v2[k];
      if (value !== void 0) {
        assertJSONValue(value);
      }
    }
  }
}
function assertJSONArray(v2) {
  for (const item of v2) {
    assertJSONValue(item);
  }
}
function isJSONValue(v2, path2) {
  switch (typeof v2) {
    case "boolean":
    case "number":
    case "string":
      return true;
    case "object":
      if (v2 === null) {
        return true;
      }
      if (Array.isArray(v2)) {
        return isJSONArray(v2, path2);
      }
      return objectIsJSONObject(v2, path2);
  }
  return false;
}
function isJSONObject(v2, path2) {
  if (typeof v2 !== "object" || v2 === null) {
    return false;
  }
  return objectIsJSONObject(v2, path2);
}
function objectIsJSONObject(v2, path2) {
  for (const k in v2) {
    if (hasOwn(v2, k)) {
      path2.push(k);
      const value = v2[k];
      if (value !== void 0 && !isJSONValue(value, path2)) {
        return false;
      }
      path2.pop();
    }
  }
  return true;
}
function isJSONArray(v2, path2) {
  for (let i = 0; i < v2.length; i++) {
    path2.push(i);
    if (!isJSONValue(v2[i], path2)) {
      return false;
    }
    path2.pop();
  }
  return true;
}

// src/call-default-fetch.ts
async function callDefaultFetch(url, auth, requestID, requestBody) {
  const init = {
    headers: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "Content-type": "application/json",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "Authorization": auth,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "X-Replicache-RequestID": requestID
    },
    body: JSON.stringify(requestBody),
    method: "POST"
  };
  const request = new Request(url, init);
  const response = await fetch(request);
  const httpStatusCode = response.status;
  if (httpStatusCode !== 200) {
    return [
      void 0,
      {
        httpStatusCode,
        errorMessage: await response.text()
      }
    ];
  }
  return [
    response,
    {
      httpStatusCode,
      errorMessage: ""
    }
  ];
}

// src/string-compare.ts
function stringCompare(a, b) {
  if (a === b) {
    return 0;
  }
  if (a < b) {
    return -1;
  }
  return 1;
}

// src/cookies.ts
function compareCookies(a, b) {
  if (a === b) {
    return 0;
  }
  if (a === null) {
    return -1;
  }
  if (b === null) {
    return 1;
  }
  const cva = getCompareValue(a);
  const cvb = getCompareValue(b);
  if (typeof cva === "string" || typeof cvb === "string") {
    return stringCompare(String(cva), String(cvb));
  }
  return cva - cvb;
}
function getCompareValue(cookie) {
  if (typeof cookie === "string" || typeof cookie === "number") {
    return cookie;
  }
  return cookie.order;
}
function assertCookie(v2) {
  if (v2 === null || typeof v2 === "string" || typeof v2 === "number") {
    return;
  }
  assertJSONObject(v2);
  if (typeof v2.order === "string" || typeof v2.order === "number") {
    return;
  }
  throw new Error("Invalid cookie");
}

// src/error-responses.ts
function isError(obj, type) {
  return typeof obj === "object" && obj !== null && obj.error === type;
}
function isErrorResponse(obj) {
  return typeof obj.error === "string";
}
function isClientStateNotFoundResponse(v2) {
  return isError(v2, "ClientStateNotFound");
}
function isVersionNotSupportedResponse(v2) {
  if (!isError(v2, "VersionNotSupported")) {
    return false;
  }
  const { versionType } = v2;
  switch (versionType) {
    case void 0:
    case "pull":
    case "push":
    case "schema":
      return true;
  }
  return false;
}
function assertVersionNotSupportedResponse(v2) {
  assert(isVersionNotSupportedResponse(v2));
}

// src/http-request-info.ts
function assertHTTPRequestInfo(v2) {
  assertObject2(v2);
  assertNumber(v2.httpStatusCode);
  assertString2(v2.errorMessage);
}

// src/patch-operation.ts
function assertPatchOperations(p) {
  assertArray(p);
  for (const item of p) {
    assertPatchOperation(item);
  }
}
function assertPatchOperation(p) {
  assertObject2(p);
  switch (p.op) {
    case "put":
      assertString2(p.key);
      assertJSONValue(p.value);
      break;
    case "update":
      assertString2(p.key);
      if (p.merge !== void 0) {
        assertJSONObject(p.merge);
      }
      if (p.constrain !== void 0) {
        assertArray(p.constrain);
        for (const key of p.constrain) {
          assertString2(key);
        }
      }
      break;
    case "del":
      assertString2(p.key);
      break;
    case "clear":
      break;
    default:
      throw new Error(
        `unknown patch op \`${p.op}\`, expected one of \`put\`, \`del\`, \`clear\``
      );
  }
}

// src/get-default-puller.ts
function getDefaultPuller(rep) {
  async function puller(requestBody, requestID) {
    const [response, httpRequestInfo] = await callDefaultFetch(
      rep.pullURL,
      rep.auth,
      requestID,
      requestBody
    );
    if (!response) {
      return { httpRequestInfo };
    }
    return {
      response: await response.json(),
      httpRequestInfo
    };
  }
  defaultPullers.add(puller);
  return puller;
}
var defaultPullers = /* @__PURE__ */ new WeakSet();
function isDefaultPuller(puller) {
  return defaultPullers.has(puller);
}
function assertPullResponseV0(v2) {
  assertObject2(v2);
  if (isClientStateNotFoundResponse(v2) || isVersionNotSupportedResponse(v2)) {
    return;
  }
  const v22 = v2;
  if (v22.cookie !== void 0) {
    assertJSONValue(v22.cookie);
  }
  assertNumber(v22.lastMutationID);
  assertPatchOperations(v22.patch);
}
function assertPullResponseV1(v2) {
  assertObject2(v2);
  if (isClientStateNotFoundResponse(v2) || isVersionNotSupportedResponse(v2)) {
    return;
  }
  const v22 = v2;
  if (v22.cookie !== void 0) {
    assertCookie(v22.cookie);
  }
  assertLastMutationIDChanges(v22.lastMutationIDChanges);
  assertPatchOperations(v22.patch);
}
function assertLastMutationIDChanges(lastMutationIDChanges) {
  assertObject2(lastMutationIDChanges);
  for (const [key, value] of Object.entries(lastMutationIDChanges)) {
    assertString2(key);
    assertNumber(value);
  }
}
function assertPullerResultV1(v2) {
  assertObject2(v2);
  assertHTTPRequestInfo(v2.httpRequestInfo);
  if (v2.response !== void 0) {
    assertPullResponseV1(v2.response);
  }
}
function assertPullerResultV0(v2) {
  assertObject2(v2);
  assertHTTPRequestInfo(v2.httpRequestInfo);
  if (v2.response !== void 0) {
    assertPullResponseV0(v2.response);
  }
}

// src/kv/idb-store.ts
import { resolver } from "@rocicorp/resolver";

// ../shared/src/resolved-promises.ts
var promiseTrue = Promise.resolve(true);
var promiseFalse = Promise.resolve(false);
var promiseUndefined = Promise.resolve(void 0);
var promiseVoid = Promise.resolve();

// src/frozen-json.ts
var deepFrozenObjects = /* @__PURE__ */ new WeakSet();
function deepFreeze(v2) {
  if (isProd) {
    return v2;
  }
  deepFreezeInternal(v2, []);
  return v2;
}
function deepFreezeInternal(v2, seen) {
  switch (typeof v2) {
    case "undefined":
      throw new TypeError("Unexpected value undefined");
    case "boolean":
    case "number":
    case "string":
      return;
    case "object": {
      if (v2 === null) {
        return;
      }
      if (deepFrozenObjects.has(v2)) {
        return;
      }
      deepFrozenObjects.add(v2);
      if (seen.includes(v2)) {
        throwInvalidType2(v2, "Cyclic JSON object");
      }
      seen.push(v2);
      Object.freeze(v2);
      if (Array.isArray(v2)) {
        deepFreezeArray(v2, seen);
      } else {
        deepFreezeObject(v2, seen);
      }
      seen.pop();
      return;
    }
    default:
      throwInvalidType2(v2, "JSON value");
  }
}
function deepFreezeArray(v2, seen) {
  for (const item of v2) {
    deepFreezeInternal(item, seen);
  }
}
function deepFreezeObject(v2, seen) {
  for (const k in v2) {
    if (hasOwn(v2, k)) {
      const value = v2[k];
      if (value !== void 0) {
        deepFreezeInternal(value, seen);
      }
    }
  }
}
function assertDeepFrozen(v2) {
  if (isProd) {
    return;
  }
  if (!isDeepFrozen(v2, [])) {
    throw new Error("Expected frozen object");
  }
}
function isDeepFrozen(v2, seen) {
  switch (typeof v2) {
    case "boolean":
    case "number":
    case "string":
      return true;
    case "object":
      if (v2 === null) {
        return true;
      }
      if (deepFrozenObjects.has(v2)) {
        return true;
      }
      if (!Object.isFrozen(v2)) {
        return false;
      }
      if (seen.includes(v2)) {
        throwInvalidType2(v2, "Cyclic JSON object");
      }
      seen.push(v2);
      if (Array.isArray(v2)) {
        for (const item of v2) {
          if (!isDeepFrozen(item, seen)) {
            seen.pop();
            return false;
          }
        }
      } else {
        for (const k in v2) {
          if (hasOwn(v2, k)) {
            const value = v2[k];
            if (value !== void 0 && !isDeepFrozen(value, seen)) {
              seen.pop();
              return false;
            }
          }
        }
      }
      deepFrozenObjects.add(v2);
      seen.pop();
      return true;
    default:
      throwInvalidType2(v2, "JSON value");
  }
}
function deepFreezeAllowUndefined(v2) {
  if (v2 === void 0) {
    return void 0;
  }
  return deepFreeze(v2);
}

// src/kv/write-impl-base.ts
var deleteSentinel = Symbol();
var WriteImplBase = class {
  _pending = /* @__PURE__ */ new Map();
  #read;
  constructor(read) {
    this.#read = read;
  }
  has(key) {
    switch (this._pending.get(key)) {
      case void 0:
        return this.#read.has(key);
      case deleteSentinel:
        return promiseFalse;
      default:
        return promiseTrue;
    }
  }
  async get(key) {
    const v2 = this._pending.get(key);
    switch (v2) {
      case deleteSentinel:
        return void 0;
      case void 0: {
        const v3 = await this.#read.get(key);
        return deepFreezeAllowUndefined(v3);
      }
      default:
        return v2;
    }
  }
  put(key, value) {
    this._pending.set(key, deepFreeze(value));
    return promiseVoid;
  }
  del(key) {
    this._pending.set(key, deleteSentinel);
    return promiseVoid;
  }
  release() {
    this.#read.release();
  }
  get closed() {
    return this.#read.closed;
  }
};

// src/kv/idb-store.ts
var RELAXED = { durability: "relaxed" };
var OBJECT_STORE = "chunks";
var IDBStore = class {
  #db;
  #closed = false;
  #idbDeleted = false;
  constructor(name) {
    this.#db = openDatabase(name);
  }
  read() {
    return this.#withReopen(readImpl);
  }
  write() {
    return this.#withReopen(writeImpl);
  }
  async close() {
    if (!this.#idbDeleted) {
      const db = await this.#db;
      db.close();
    }
    this.#closed = true;
  }
  get closed() {
    return this.#closed;
  }
  async #withReopen(fn) {
    const reopenExistingDB = async (name) => {
      const { promise, resolve, reject } = resolver();
      const req = indexedDB.open(name);
      req.onupgradeneeded = () => {
        const tx = req.transaction;
        assertNotNull(tx);
        tx.abort();
        this.#idbDeleted = true;
        reject(new IDBNotFoundError(`Replicache IndexedDB not found: ${name}`));
      };
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
      const db2 = await promise;
      db2.onversionchange = () => db2.close();
      return db2;
    };
    const db = await this.#db;
    try {
      return fn(db);
    } catch (e) {
      if (!this.#closed && e instanceof DOMException) {
        if (e.name === "InvalidStateError") {
          this.#db = reopenExistingDB(db.name);
          const reopened = await this.#db;
          return fn(reopened);
        } else if (e.name === "NotFoundError") {
          this.#idbDeleted = true;
          indexedDB.deleteDatabase(db.name);
          throw new IDBNotFoundError(
            `Replicache IndexedDB ${db.name} missing object store. Deleting db.`
          );
        }
      }
      throw e;
    }
  }
};
var ReadImpl = class {
  #tx;
  #closed = false;
  constructor(tx) {
    this.#tx = tx;
  }
  has(key) {
    return new Promise((resolve, reject) => {
      const req = objectStore(this.#tx).count(key);
      req.onsuccess = () => resolve(req.result > 0);
      req.onerror = () => reject(req.error);
    });
  }
  get(key) {
    return new Promise((resolve, reject) => {
      const req = objectStore(this.#tx).get(key);
      req.onsuccess = () => resolve(deepFreezeAllowUndefined(req.result));
      req.onerror = () => reject(req.error);
    });
  }
  release() {
    this.#closed = true;
  }
  get closed() {
    return this.#closed;
  }
};
var WriteImpl = class extends WriteImplBase {
  #tx;
  #closed = false;
  constructor(tx) {
    super(new ReadImpl(tx));
    this.#tx = tx;
  }
  commit() {
    if (this._pending.size === 0) {
      return promiseVoid;
    }
    return new Promise((resolve, reject) => {
      const tx = this.#tx;
      const store = objectStore(tx);
      for (const [key, val] of this._pending) {
        if (val === deleteSentinel) {
          store.delete(key);
        } else {
          store.put(val, key);
        }
      }
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
    });
  }
  release() {
    this.#closed = true;
  }
  get closed() {
    return this.#closed;
  }
};
function writeImpl(db) {
  const tx = db.transaction(OBJECT_STORE, "readwrite", RELAXED);
  return new WriteImpl(tx);
}
function readImpl(db) {
  const tx = db.transaction(OBJECT_STORE, "readonly");
  return new ReadImpl(tx);
}
function objectStore(tx) {
  return tx.objectStore(OBJECT_STORE);
}
function openDatabase(name) {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(name);
    req.onupgradeneeded = () => {
      req.result.createObjectStore(OBJECT_STORE);
    };
    req.onsuccess = () => {
      const db = req.result;
      db.onversionchange = () => db.close();
      resolve(db);
    };
    req.onerror = () => reject(req.error);
  });
}
var IDBNotFoundError = class extends Error {
  name = "IDBNotFoundError";
};

// src/iterable-union.ts
function getIterator(it) {
  return it[Symbol.asyncIterator]?.() || it[Symbol.iterator]();
}

// src/merge-async-iterables.ts
async function* mergeAsyncIterables(iterableBase, iterableOverlay, compare) {
  const a = getIterator(iterableBase);
  const b = getIterator(iterableOverlay);
  try {
    let iterResultA = await a.next();
    let iterResultB = await b.next();
    while (true) {
      if (iterResultA.done) {
        if (iterResultB.done) {
          return;
        }
        yield iterResultB.value;
        iterResultB = await b.next();
        continue;
      }
      if (iterResultB.done) {
        yield iterResultA.value;
        iterResultA = await a.next();
        continue;
      }
      const ord = compare(iterResultA.value, iterResultB.value);
      if (ord === 0) {
        yield iterResultB.value;
        iterResultA = await a.next();
        iterResultB = await b.next();
      } else if (ord < 0) {
        yield iterResultA.value;
        iterResultA = await a.next();
      } else {
        yield iterResultB.value;
        iterResultB = await b.next();
      }
    }
  } finally {
    if (a.return) {
      await a.return();
    }
    if (b.return) {
      await b.return();
    }
  }
}

// ../shared/src/abort-error.ts
var AbortError = class extends Error {
  name = "AbortError";
};

// ../shared/src/sleep.ts
import { resolver as resolver2 } from "@rocicorp/resolver";
var promiseVoid2 = Promise.resolve();
var promiseNever = new Promise(() => void 0);
function sleep(ms, signal) {
  if (ms === 0) {
    return promiseVoid2;
  }
  return new Promise((resolve, reject) => {
    const id = setTimeout(() => {
      resolve();
    }, ms);
    if (signal) {
      signal.addEventListener("abort", () => {
        clearTimeout(id);
        reject(new AbortError("Aborted"));
      });
    }
  });
}

// src/bg-interval.ts
function initBgIntervalProcess(processName, process2, delayMs, lc, signal) {
  void runBgIntervalProcess(processName, process2, delayMs, lc, signal);
}
async function runBgIntervalProcess(processName, process2, delayMs, lc, signal) {
  if (signal.aborted) {
    return;
  }
  lc = lc.withContext("bgIntervalProcess", processName);
  lc.debug?.("Starting");
  while (!signal.aborted) {
    try {
      await sleep(delayMs(), signal);
    } catch (e) {
      if (!(e instanceof AbortError)) {
        throw e;
      }
    }
    if (!signal.aborted) {
      lc.debug?.("Running");
      try {
        await process2();
      } catch (e) {
        if (signal.aborted) {
          lc.debug?.("Error running most likely due to close.", e);
        } else {
          lc.error?.("Error running.", e);
        }
      }
    }
  }
  lc.debug?.("Stopping");
}

// ../shared/src/valita.ts
var valita_exports = {};
__export(valita_exports, {
  assert: () => assert2,
  is: () => is,
  parse: () => parse,
  readonly: () => readonly,
  readonlyArray: () => readonlyArray,
  readonlyObject: () => readonlyObject,
  readonlyRecord: () => readonlyRecord,
  test: () => test
});
__reExport(valita_exports, valita_star);
import * as v from "@badrap/valita";
import * as valita_star from "@badrap/valita";
function toDisplay(value) {
  switch (typeof value) {
    case "string":
    case "number":
    case "boolean":
      return JSON.stringify(value);
    case "undefined":
      return "undefined";
    case "bigint":
      return value.toString() + "n";
    default:
      if (value === null) {
        return "null";
      }
      if (Array.isArray(value)) {
        return "array";
      }
      return typeof value;
  }
}
function toDisplayAtPath(v2, path2) {
  if (!path2?.length) {
    return toDisplay(v2);
  }
  let cur = v2;
  for (const p of path2) {
    cur = cur[p];
  }
  return toDisplay(cur);
}
function displayList(word, expected, toDisplay2 = (x) => String(x)) {
  if (expected.length === 1) {
    return toDisplay2(expected[0]);
  }
  const suffix = `${toDisplay2(
    expected[expected.length - 2]
  )} ${word} ${toDisplay2(expected[expected.length - 1])}`;
  if (expected.length === 2) {
    return suffix;
  }
  return `${expected.slice(0, -2).map(toDisplay2).join(", ")}, ${suffix}`;
}
function getMessage(err2, v2) {
  const firstIssue = err2.issues[0];
  const { path: path2 } = firstIssue;
  const atPath = path2?.length ? ` at ${path2.join(".")}` : "";
  switch (firstIssue.code) {
    case "invalid_type":
      return `Expected ${displayList(
        "or",
        firstIssue.expected
      )}${atPath}. Got ${toDisplayAtPath(v2, path2)}`;
    case "missing_value": {
      const atPath2 = path2 && path2.length > 1 ? ` at ${path2.slice(0, -1).join(".")}` : "";
      if (firstIssue.path?.length) {
        return `Missing property ${firstIssue.path.at(-1)}${atPath2}`;
      }
      return `TODO Unknown missing property${atPath2}`;
    }
    case "invalid_literal":
      return `Expected literal value ${displayList(
        "or",
        firstIssue.expected,
        toDisplay
      )}${atPath} Got ${toDisplayAtPath(v2, path2)}`;
    case "invalid_length": {
      return `Expected array with length ${firstIssue.minLength === firstIssue.maxLength ? firstIssue.minLength : `between ${firstIssue.minLength} and ${firstIssue.maxLength}`}${atPath}. Got array with length ${v2.length}`;
    }
    case "unrecognized_keys":
      if (firstIssue.keys.length === 1) {
        return `Unexpected property ${firstIssue.keys[0]}${atPath}`;
      }
      return `Unexpected properties ${displayList(
        "and",
        firstIssue.keys
      )}${atPath}`;
    case "invalid_union":
      return `Invalid union value${atPath}`;
    case "custom_error": {
      const { error } = firstIssue;
      const message = !error ? "unknown" : typeof error === "string" ? error : error.message ?? "unknown";
      return `${message}${atPath}. Got ${toDisplayAtPath(v2, path2)}`;
    }
  }
}
function parse(value, schema, mode) {
  const res = test(value, schema, mode);
  if (!res.ok) {
    throw new TypeError(res.error);
  }
  return res.value;
}
function is(value, schema, mode) {
  return test(value, schema, mode).ok;
}
function assert2(value, schema, mode) {
  parse(value, schema, mode);
}
function test(value, schema, mode) {
  const res = schema.try(value, mode ? { mode } : void 0);
  if (!res.ok) {
    return { ok: false, error: getMessage(res, value) };
  }
  return res;
}
function readonly(t) {
  return t;
}
function readonlyObject(t) {
  return readonly(v.object(t));
}
function readonlyArray(t) {
  return readonly(v.array(t));
}
function readonlyRecord(t) {
  return readonly(v.record(t));
}

// src/uuid.ts
var uuid = typeof crypto !== "undefined" && typeof crypto.randomUUID !== "undefined" ? uuidNative : uuidNoNative;
function uuidNoNative() {
  return uuidFromNumbers(
    Uint8Array.from({ length: 36 }, () => Math.random() * 256)
  );
}
function uuidNative() {
  return crypto.randomUUID();
}
var UUID_V4_FORMAT = [
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  2 /* Hyphen */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  2 /* Hyphen */,
  3 /* Version */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  2 /* Hyphen */,
  1 /* Random89AB */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  2 /* Hyphen */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */,
  0 /* Random09AF */
];
function uuidFromNumbers(randomNumbers) {
  return UUID_V4_FORMAT.map((kind, i) => {
    switch (kind) {
      case 0 /* Random09AF */:
        return (randomNumbers[i] & 15).toString(16);
      case 1 /* Random89AB */:
        return ((randomNumbers[i] & 3) + 8).toString(16);
      case 3 /* Version */:
        return "4";
      case 2 /* Hyphen */:
        return "-";
    }
  }).join("");
}

// src/hash.ts
var hashRe = /^[0-9a-v-]+$/;
var emptyUUID = "00000000-0000-4000-8000-000000000000";
var emptyHash = emptyUUID;
var newUUIDHash = makeNewUUIDHashFunctionInternal("", uuid);
function makeNewUUIDHashFunctionInternal(hashPrefix, makeUUID) {
  let base;
  let tempHashCounter = 0;
  return () => {
    if (!base) {
      base = makeBase(hashPrefix, makeUUID());
    }
    const tail = String(tempHashCounter++);
    return makeHash(base, tail);
  };
}
function makeBase(hashPrefix, uuid2) {
  return hashPrefix + uuid2.replaceAll("-", "").slice(hashPrefix.length);
}
function makeHash(base, tail) {
  assert(tail.length <= 12);
  return base + tail.padStart(12, "0");
}
function isHash(value) {
  return typeof value === "string" && hashRe.test(value);
}
function assertHash(value) {
  assert2(value, hashSchema);
}
var hashSchema = valita_exports.string().assert(isHash, "Invalid hash");

// src/dag/chunk.ts
var Chunk = class {
  hash;
  data;
  /**
   * Meta is an array of refs. If there are no refs we do not write a meta
   * chunk.
   */
  meta;
  constructor(hash, data, meta) {
    assert(!meta.includes(hash), "Chunk cannot reference itself");
    assertDeepFrozen(data);
    this.hash = hash;
    this.data = data;
    this.meta = meta;
  }
};
function assertMeta(v2) {
  if (!Array.isArray(v2)) {
    throw new Error("Meta must be an array");
  }
  for (const e of v2) {
    assertString2(e);
  }
}
function createChunk(data, refs, chunkHasher) {
  const hash = chunkHasher();
  return new Chunk(hash, data, refs);
}
function throwChunkHasher() {
  throw new Error("unexpected call to compute chunk hash");
}

// src/dag/gc.ts
function computeRefCountUpdates(headChanges, putChunks, delegate) {
  return new RefCountUpdates(headChanges, putChunks, delegate).compute();
}
var RefCountUpdates = class {
  #newHeads;
  #oldHeads;
  #putChunks;
  #delegate;
  #refsCounted;
  #refCountUpdates;
  #loadedRefCountPromises;
  #isLazyDelegate;
  constructor(headChanges, putChunks, delegate) {
    const newHeads = [];
    const oldHeads = [];
    for (const changedHead of headChanges) {
      if (changedHead.old !== changedHead.new) {
        changedHead.old && oldHeads.push(changedHead.old);
        changedHead.new && newHeads.push(changedHead.new);
      }
    }
    this.#newHeads = newHeads;
    this.#oldHeads = oldHeads;
    this.#putChunks = putChunks;
    this.#delegate = delegate;
    this.#refCountUpdates = /* @__PURE__ */ new Map();
    this.#loadedRefCountPromises = /* @__PURE__ */ new Map();
    this.#isLazyDelegate = delegate.areRefsCounted !== void 0;
    this.#refsCounted = this.#isLazyDelegate ? /* @__PURE__ */ new Set() : null;
  }
  async compute() {
    for (const n of this.#newHeads) {
      await this.#changeRefCount(n, 1);
    }
    await Promise.all(
      Array.from(
        this.#putChunks.values(),
        (hash) => this.#ensureRefCountLoaded(hash)
      )
    );
    if (this.#isLazyDelegate) {
      assert(this.#delegate.areRefsCounted);
      assert(this.#refsCounted);
      let refCountsUpdated;
      do {
        refCountsUpdated = false;
        for (const hash of this.#putChunks.values()) {
          if (!this.#delegate.areRefsCounted(hash) && !this.#refsCounted.has(hash) && this.#refCountUpdates.get(hash) !== 0) {
            await this.#updateRefsCounts(hash, 1);
            refCountsUpdated = true;
            break;
          }
        }
      } while (refCountsUpdated);
    }
    for (const o of this.#oldHeads) {
      await this.#changeRefCount(o, -1);
    }
    if (!isProd) {
      for (const [hash, update] of this.#refCountUpdates) {
        assert(
          update >= 0,
          `ref count update must be non-negative. ${hash}:${update}`
        );
      }
    }
    return this.#refCountUpdates;
  }
  async #changeRefCount(hash, delta) {
    await this.#ensureRefCountLoaded(hash);
    if (this.#updateRefCount(hash, delta)) {
      await this.#updateRefsCounts(hash, delta);
    }
  }
  async #updateRefsCounts(hash, delta) {
    if (hash === emptyHash) {
      return;
    }
    const refs = await this.#delegate.getRefs(hash);
    if (!isProd) {
      assert(
        refs || this.#isLazyDelegate && !this.#putChunks.has(hash),
        "refs must be defined"
      );
    }
    if (refs !== void 0) {
      this.#refsCounted?.add(hash);
      const ps = refs.map((ref) => this.#changeRefCount(ref, delta));
      await Promise.all(ps);
    }
  }
  #ensureRefCountLoaded(hash) {
    let p = this.#loadedRefCountPromises.get(hash);
    if (p === void 0) {
      p = (async () => {
        const value = await this.#delegate.getRefCount(hash) || 0;
        this.#refCountUpdates.set(hash, value);
        return value;
      })();
      this.#loadedRefCountPromises.set(hash, p);
    }
    return p;
  }
  #updateRefCount(hash, delta) {
    const oldCount = this.#refCountUpdates.get(hash);
    assertNumber(oldCount);
    this.#refCountUpdates.set(hash, oldCount + delta);
    return oldCount === 0 && delta === 1 || oldCount === 1 && delta === -1;
  }
};

// src/dag/key.ts
function chunkDataKey(hash) {
  return `c/${hash}/d`;
}
function chunkMetaKey(hash) {
  return `c/${hash}/m`;
}
function chunkRefCountKey(hash) {
  return `c/${hash}/r`;
}
function headKey(name) {
  return `h/${name}`;
}

// src/dag/store.ts
var ChunkNotFoundError = class extends Error {
  name = "ChunkNotFoundError";
  hash;
  constructor(hash) {
    super(`Chunk not found ${hash}`);
    this.hash = hash;
  }
};
async function mustGetChunk(store, hash) {
  const chunk = await store.getChunk(hash);
  if (chunk) {
    return chunk;
  }
  throw new ChunkNotFoundError(hash);
}
async function mustGetHeadHash(name, store) {
  const hash = await store.getHead(name);
  assert(hash, `Missing head ${name}`);
  return hash;
}

// src/dag/store-impl.ts
var StoreImpl = class {
  #kv;
  #chunkHasher;
  #assertValidHash;
  constructor(kv, chunkHasher, assertValidHash) {
    this.#kv = kv;
    this.#chunkHasher = chunkHasher;
    this.#assertValidHash = assertValidHash;
  }
  async read() {
    return new ReadImpl2(await this.#kv.read(), this.#assertValidHash);
  }
  async write() {
    return new WriteImpl2(
      await this.#kv.write(),
      this.#chunkHasher,
      this.#assertValidHash
    );
  }
  close() {
    return this.#kv.close();
  }
};
var ReadImpl2 = class {
  _tx;
  assertValidHash;
  constructor(kv, assertValidHash) {
    this._tx = kv;
    this.assertValidHash = assertValidHash;
  }
  hasChunk(hash) {
    return this._tx.has(chunkDataKey(hash));
  }
  async getChunk(hash) {
    const data = await this._tx.get(chunkDataKey(hash));
    if (data === void 0) {
      return void 0;
    }
    const refsVal = await this._tx.get(chunkMetaKey(hash));
    let refs;
    if (refsVal !== void 0) {
      assertMeta(refsVal);
      refs = refsVal;
    } else {
      refs = [];
    }
    return new Chunk(hash, data, refs);
  }
  mustGetChunk(hash) {
    return mustGetChunk(this, hash);
  }
  async getHead(name) {
    const data = await this._tx.get(headKey(name));
    if (data === void 0) {
      return void 0;
    }
    assertHash(data);
    return data;
  }
  release() {
    this._tx.release();
  }
  get closed() {
    return this._tx.closed;
  }
};
var WriteImpl2 = class extends ReadImpl2 {
  #chunkHasher;
  #putChunks = /* @__PURE__ */ new Set();
  #changedHeads = /* @__PURE__ */ new Map();
  constructor(kvw, chunkHasher, assertValidHash) {
    super(kvw, assertValidHash);
    this.#chunkHasher = chunkHasher;
  }
  createChunk = (data, refs) => createChunk(data, refs, this.#chunkHasher);
  get kvWrite() {
    return this._tx;
  }
  async putChunk(c) {
    const { hash, data, meta } = c;
    this.assertValidHash(hash);
    const key = chunkDataKey(hash);
    const p1 = this._tx.put(key, data);
    let p2;
    if (meta.length > 0) {
      for (const h of meta) {
        this.assertValidHash(h);
      }
      p2 = this._tx.put(chunkMetaKey(hash), meta);
    }
    this.#putChunks.add(hash);
    await p1;
    await p2;
  }
  setHead(name, hash) {
    return this.#setHead(name, hash);
  }
  removeHead(name) {
    return this.#setHead(name, void 0);
  }
  async #setHead(name, hash) {
    const oldHash = await this.getHead(name);
    const hk = headKey(name);
    let p1;
    if (hash === void 0) {
      p1 = this._tx.del(hk);
    } else {
      p1 = this._tx.put(hk, hash);
    }
    const v2 = this.#changedHeads.get(name);
    if (v2 === void 0) {
      this.#changedHeads.set(name, { new: hash, old: oldHash });
    } else {
      v2.new = hash;
    }
    await p1;
  }
  async commit() {
    const refCountUpdates = await computeRefCountUpdates(
      this.#changedHeads.values(),
      this.#putChunks,
      this
    );
    await this.#applyRefCountUpdates(refCountUpdates);
    await this._tx.commit();
  }
  async getRefCount(hash) {
    const value = await this._tx.get(chunkRefCountKey(hash));
    if (value === void 0) {
      return void 0;
    }
    assertNumber(value);
    if (value < 0 || value > 65535 || value !== (value | 0)) {
      throw new Error(
        `Invalid ref count ${value}. We expect the value to be a Uint16`
      );
    }
    return value;
  }
  async getRefs(hash) {
    const meta = await this._tx.get(chunkMetaKey(hash));
    if (meta === void 0) {
      return [];
    }
    assertMeta(meta);
    return meta;
  }
  async #applyRefCountUpdates(refCountCache) {
    const ps = [];
    for (const [hash, count] of refCountCache) {
      if (count === 0) {
        ps.push(this.#removeAllRelatedKeys(hash));
      } else {
        const refCountKey = chunkRefCountKey(hash);
        ps.push(this._tx.put(refCountKey, count));
      }
    }
    await Promise.all(ps);
  }
  async #removeAllRelatedKeys(hash) {
    await Promise.all([
      this._tx.del(chunkDataKey(hash)),
      this._tx.del(chunkMetaKey(hash)),
      this._tx.del(chunkRefCountKey(hash))
    ]);
    this.#putChunks.delete(hash);
  }
  release() {
    this._tx.release();
  }
};

// src/format-version.ts
function parseReplicacheFormatVersion(v2) {
  if (v2 !== (v2 | 0) || v2 < 4 /* SDD */ || v2 > 7 /* Latest */) {
    throw new Error(`Unsupported format version: ${v2}`);
  }
  return v2;
}

// src/with-transactions.ts
function withRead(store, fn) {
  return using(store.read(), fn);
}
function withWriteNoImplicitCommit(store, fn) {
  return using(store.write(), fn);
}
function withWrite(store, fn) {
  return using(store.write(), async (write) => {
    const result = await fn(write);
    await write.commit();
    return result;
  });
}
async function using(x, fn) {
  const write = await x;
  try {
    return await fn(write);
  } finally {
    write.release();
  }
}

// src/index-defs.ts
var indexDefinitionSchema = readonlyObject({
  prefix: valita_exports.string().optional(),
  jsonPointer: valita_exports.string(),
  allowEmpty: valita_exports.boolean().optional()
});
var indexDefinitionsSchema = readonlyRecord(
  indexDefinitionSchema
);
function indexDefinitionEqual(a, b) {
  return a.jsonPointer === b.jsonPointer && (a.allowEmpty ?? false) === (b.allowEmpty ?? false) && (a.prefix ?? "") === (b.prefix ?? "");
}
function indexDefinitionsEqual(a, b) {
  if (Object.keys(a).length !== Object.keys(b).length) {
    return false;
  }
  for (const [aKey, aValue] of Object.entries(a)) {
    const bValue = b[aKey];
    if (!bValue || !indexDefinitionEqual(aValue, bValue)) {
      return false;
    }
  }
  return true;
}

// src/persist/client-groups.ts
var clientGroupSchema = readonlyObject({
  /**
   * The hash of the commit in the perdag last persisted to this client group.
   * Should only be updated by clients assigned to this client group.
   */
  headHash: hashSchema,
  /**
   * Set of mutator names common to all clients assigned to this client group.
   */
  mutatorNames: readonlyArray(valita_exports.string()),
  /**
   * Index definitions common to all clients assigned to this client group.
   */
  indexes: indexDefinitionsSchema,
  /**
   * The highest mutation ID of every client assigned to this client group.
   * Should only be updated by clients assigned to this client group. Read by
   * other clients to determine if there are unacknowledged pending mutations
   * for them to try to recover. This is redundant with information in the
   * commit graph at `headHash`, but allows other clients to determine if there
   * are unacknowledged pending mutations without having to load the commit
   * graph.
   */
  mutationIDs: readonlyRecord(valita_exports.number()),
  /**
   * The highest lastMutationID received from the server for every client
   * assigned to this client group.
   *
   * Should be updated by the clients assigned to this client group whenever
   * they persist to this client group. Read by other clients to determine if
   * there are unacknowledged pending mutations for them to recover and
   * *updated* by other clients upon successfully recovering pending mutations
   * to avoid redundant pushes of pending mutations.
   *
   * Note: This will be the same as the `lastMutationIDs` of the base snapshot
   * of the client group's commit graph when written by clients assigned to this
   * client group.  However, when written by another client recovering mutations
   * it may be different because the other client does not update the commit
   * graph.
   */
  lastServerAckdMutationIDs: valita_exports.record(valita_exports.number()),
  /**
   * If the server deletes this client group it can signal that the client group
   * was deleted. If that happens we mark this client group as disabled so that
   * we do not use it again when creating new clients.
   */
  disabled: valita_exports.boolean()
});
var CLIENT_GROUPS_HEAD_NAME = "client-groups";
function assertClientGroup(value) {
  assert2(value, clientGroupSchema);
}
function chunkDataToClientGroupMap(chunkData) {
  assertObject2(chunkData);
  const clientGroups = /* @__PURE__ */ new Map();
  for (const [key, value] of Object.entries(chunkData)) {
    if (value !== void 0) {
      assertClientGroup(value);
      clientGroups.set(key, value);
    }
  }
  return clientGroups;
}
function clientGroupMapToChunkData(clientGroups, dagWrite) {
  const chunkData = {};
  for (const [clientGroupID, clientGroup] of clientGroups.entries()) {
    dagWrite.assertValidHash(clientGroup.headHash);
    chunkData[clientGroupID] = {
      ...clientGroup,
      mutatorNames: [...clientGroup.mutatorNames.values()]
    };
  }
  return deepFreeze(chunkData);
}
async function getClientGroupsAtHash(hash, dagRead) {
  const chunk = await dagRead.getChunk(hash);
  return chunkDataToClientGroupMap(chunk?.data);
}
async function getClientGroups(dagRead) {
  const hash = await dagRead.getHead(CLIENT_GROUPS_HEAD_NAME);
  if (!hash) {
    return /* @__PURE__ */ new Map();
  }
  return getClientGroupsAtHash(hash, dagRead);
}
async function setClientGroups(clientGroups, dagWrite) {
  const currClientGroups = await getClientGroups(dagWrite);
  for (const [clientGroupID, clientGroup] of clientGroups) {
    const currClientGroup = currClientGroups.get(clientGroupID);
    validateClientGroupUpdate(clientGroup, currClientGroup);
  }
  return setValidatedClientGroups(clientGroups, dagWrite);
}
async function setClientGroup(clientGroupID, clientGroup, dagWrite) {
  const currClientGroups = await getClientGroups(dagWrite);
  const currClientGroup = currClientGroups.get(clientGroupID);
  validateClientGroupUpdate(clientGroup, currClientGroup);
  const newClientGroups = new Map(currClientGroups);
  newClientGroups.set(clientGroupID, clientGroup);
  return setValidatedClientGroups(newClientGroups, dagWrite);
}
function validateClientGroupUpdate(clientGroup, currClientGroup) {
  const mutatorNamesSet = new Set(clientGroup.mutatorNames);
  assert(
    mutatorNamesSet.size === clientGroup.mutatorNames.length,
    "A client group's mutatorNames must be a set."
  );
  if (currClientGroup !== void 0) {
    assert(
      indexDefinitionsEqual(currClientGroup.indexes, clientGroup.indexes),
      "A client group's index definitions must never change."
    );
    assert(
      mutatorNamesEqual(mutatorNamesSet, currClientGroup.mutatorNames),
      "A client group's mutatorNames must never change."
    );
  }
}
async function setValidatedClientGroups(clientGroups, dagWrite) {
  const chunkData = clientGroupMapToChunkData(clientGroups, dagWrite);
  const refs = Array.from(
    clientGroups.values(),
    (clientGroup) => clientGroup.headHash
  );
  const chunk = dagWrite.createChunk(chunkData, refs);
  await dagWrite.putChunk(chunk);
  await dagWrite.setHead(CLIENT_GROUPS_HEAD_NAME, chunk.hash);
  return clientGroups;
}
function mutatorNamesEqual(mutatorNamesSet, mutatorNames) {
  if (mutatorNames.length !== mutatorNamesSet.size) {
    return false;
  }
  for (const mutatorName of mutatorNames) {
    if (!mutatorNamesSet.has(mutatorName)) {
      return false;
    }
  }
  return true;
}
async function getClientGroup(id, dagRead) {
  const clientGroups = await getClientGroups(dagRead);
  return clientGroups.get(id);
}
function clientGroupHasPendingMutations(clientGroup) {
  for (const [clientID, mutationID] of Object.entries(
    clientGroup.mutationIDs
  )) {
    const lastServerAckdMutationID = clientGroup.lastServerAckdMutationIDs[clientID];
    if (lastServerAckdMutationID === void 0 && mutationID !== 0 || lastServerAckdMutationID < mutationID) {
      return true;
    }
  }
  return false;
}
async function disableClientGroup(clientGroupID, dagWrite) {
  const clientGroup = await getClientGroup(clientGroupID, dagWrite);
  if (!clientGroup) {
    return;
  }
  const disabledClientGroup = {
    ...clientGroup,
    disabled: true
  };
  await setClientGroup(clientGroupID, disabledClientGroup, dagWrite);
}

// ../../node_modules/compare-utf8/src/index.js
function compareUTF8(a, b) {
  const aLength = a.length;
  const bLength = b.length;
  const length = Math.min(aLength, bLength);
  for (let i = 0; i < length; ) {
    const aCodePoint = (
      /** @type {number} */
      a.codePointAt(i)
    );
    const bCodePoint = (
      /** @type {number} */
      b.codePointAt(i)
    );
    if (aCodePoint !== bCodePoint) {
      if (aCodePoint < 128 && bCodePoint < 128) {
        return aCodePoint - bCodePoint;
      }
      const aLength2 = utf8Bytes(aCodePoint, aBytes);
      const bLength2 = utf8Bytes(bCodePoint, bBytes);
      return compareArrays(aBytes, aLength2, bBytes, bLength2);
    }
    i += utf16LengthForCodePoint(aCodePoint);
  }
  return aLength - bLength;
}
function compareArrays(a, aLength, b, bLength) {
  const length = Math.min(aLength, bLength);
  for (let i = 0; i < length; i++) {
    const aValue = a[i];
    const bValue = b[i];
    if (aValue !== bValue) {
      return aValue - bValue;
    }
  }
  return aLength - bLength;
}
function utf16LengthForCodePoint(aCodePoint) {
  return aCodePoint > 65535 ? 2 : 1;
}
var arr = () => Array.from({ length: 4 }, () => 0);
var aBytes = arr();
var bBytes = arr();
function utf8Bytes(codePoint, bytes) {
  if (codePoint < 128) {
    bytes[0] = codePoint;
    return 1;
  }
  let count;
  let offset;
  if (codePoint <= 2047) {
    count = 1;
    offset = 192;
  } else if (codePoint <= 65535) {
    count = 2;
    offset = 224;
  } else if (codePoint <= 1114111) {
    count = 3;
    offset = 240;
  } else {
    throw new Error("Invalid code point");
  }
  bytes[0] = (codePoint >> 6 * count) + offset;
  let i = 1;
  for (; count > 0; count--) {
    const temp = codePoint >> 6 * (count - 1);
    bytes[i++] = 128 | temp & 63;
  }
  return i;
}
function greaterThan(a, b) {
  return compareUTF8(a, b) > 0;
}
function lessThan(a, b) {
  return compareUTF8(a, b) < 0;
}
function lessThanEq(a, b) {
  return compareUTF8(a, b) <= 0;
}

// ../shared/src/iterables.ts
function* joinIterables(...iters) {
  for (const iter of iters) {
    yield* iter;
  }
}

// src/binary-search.ts
function binarySearch(high, compare) {
  let low = 0;
  while (low < high) {
    const mid = low + (high - low >> 1);
    const i = compare(mid);
    if (i === 0) {
      return mid;
    }
    if (i > 0) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }
  return low;
}

// src/btree/node.ts
var NODE_LEVEL = 0;
var NODE_ENTRIES = 1;
function makeNodeChunkData(level, entries, formatVersion) {
  return deepFreeze([
    level,
    formatVersion >= 7 /* V7 */ ? entries : entries.map((e) => e.slice(0, 2))
  ]);
}
async function findLeaf(key, hash, source, expectedRootHash) {
  const node = await source.getNode(hash);
  if (expectedRootHash !== source.rootHash) {
    return findLeaf(key, source.rootHash, source, source.rootHash);
  }
  if (isDataNodeImpl(node)) {
    return node;
  }
  const { entries } = node;
  let i = binarySearch2(key, entries);
  if (i === entries.length) {
    i--;
  }
  const entry = entries[i];
  return findLeaf(key, entry[1], source, expectedRootHash);
}
function binarySearch2(key, entries) {
  return binarySearch(
    entries.length,
    (i) => compareUTF8(key, entries[i][0])
  );
}
function binarySearchFound(i, entries, key) {
  return i !== entries.length && entries[i][0] === key;
}
function parseBTreeNode(v2, formatVersion, getSizeOfEntry2) {
  if (isProd && formatVersion >= 7 /* V7 */) {
    return v2;
  }
  assertArray(v2);
  assertDeepFrozen(v2);
  assert(v2.length >= 2);
  const [level, entries] = v2;
  assertNumber(level);
  assertArray(entries);
  const f = level > 0 ? assertString2 : assertJSONValue;
  if (formatVersion >= 7 /* V7 */) {
    for (const e of entries) {
      assertEntry(e, f);
    }
    return v2;
  }
  const newEntries = entries.map((e) => convertNonV7Entry(e, f, getSizeOfEntry2));
  return [level, newEntries];
}
function assertEntry(entry, f) {
  assertArray(entry);
  assert(entry.length >= 3);
  assertString2(entry[0]);
  f(entry[1]);
  assertNumber(entry[2]);
}
function convertNonV7Entry(entry, f, getSizeOfEntry2) {
  assertArray(entry);
  assert(entry.length >= 2);
  assertString2(entry[0]);
  f(entry[1]);
  const entrySize = getSizeOfEntry2(entry[0], entry[1]);
  return [entry[0], entry[1], entrySize];
}
var NodeImpl = class {
  entries;
  hash;
  isMutable;
  #childNodeSize = -1;
  constructor(entries, hash, isMutable) {
    this.entries = entries;
    this.hash = hash;
    this.isMutable = isMutable;
  }
  maxKey() {
    return this.entries[this.entries.length - 1][0];
  }
  getChildNodeSize(tree) {
    if (this.#childNodeSize !== -1) {
      return this.#childNodeSize;
    }
    let sum = tree.chunkHeaderSize;
    for (const entry of this.entries) {
      sum += entry[2];
    }
    return this.#childNodeSize = sum;
  }
  _updateNode(tree) {
    this.#childNodeSize = -1;
    tree.updateNode(
      this
    );
  }
};
function toChunkData(node, formatVersion) {
  return makeNodeChunkData(node.level, node.entries, formatVersion);
}
var DataNodeImpl = class extends NodeImpl {
  level = 0;
  set(key, value, entrySize, tree) {
    let deleteCount;
    const i = binarySearch2(key, this.entries);
    if (!binarySearchFound(i, this.entries, key)) {
      deleteCount = 0;
    } else {
      deleteCount = 1;
    }
    return Promise.resolve(
      this.#splice(tree, i, deleteCount, [key, value, entrySize])
    );
  }
  #splice(tree, start, deleteCount, ...items) {
    if (this.isMutable) {
      this.entries.splice(start, deleteCount, ...items);
      this._updateNode(tree);
      return this;
    }
    const entries = readonlySplice(this.entries, start, deleteCount, ...items);
    return tree.newDataNodeImpl(entries);
  }
  del(key, tree) {
    const i = binarySearch2(key, this.entries);
    if (!binarySearchFound(i, this.entries, key)) {
      return Promise.resolve(this);
    }
    return Promise.resolve(this.#splice(tree, i, 1));
  }
  async *keys(_tree) {
    for (const entry of this.entries) {
      yield entry[0];
    }
  }
  async *entriesIter(_tree) {
    for (const entry of this.entries) {
      yield entry;
    }
  }
};
function readonlySplice(array3, start, deleteCount, ...items) {
  const arr2 = array3.slice(0, start);
  for (let i = 0; i < items.length; i++) {
    arr2.push(items[i]);
  }
  for (let i = start + deleteCount; i < array3.length; i++) {
    arr2.push(array3[i]);
  }
  return arr2;
}
var InternalNodeImpl = class _InternalNodeImpl extends NodeImpl {
  level;
  constructor(entries, hash, level, isMutable) {
    super(entries, hash, isMutable);
    this.level = level;
  }
  async set(key, value, entrySize, tree) {
    let i = binarySearch2(key, this.entries);
    if (i === this.entries.length) {
      i--;
    }
    const childHash = this.entries[i][1];
    const oldChildNode = await tree.getNode(childHash);
    const childNode = await oldChildNode.set(key, value, entrySize, tree);
    const childNodeSize = childNode.getChildNodeSize(tree);
    if (childNodeSize > tree.maxSize || childNodeSize < tree.minSize) {
      return this.#mergeAndPartition(tree, i, childNode);
    }
    const newEntry = createNewInternalEntryForNode(
      childNode,
      tree.getEntrySize
    );
    return this.#replaceChild(tree, i, newEntry);
  }
  /**
   * This merges the child node entries with previous or next sibling and then
   * partitions the merged entries.
   */
  async #mergeAndPartition(tree, i, childNode) {
    const level = this.level - 1;
    const thisEntries = this.entries;
    let values;
    let startIndex;
    let removeCount;
    if (i > 0) {
      const hash = thisEntries[i - 1][1];
      const previousSibling = await tree.getNode(hash);
      values = joinIterables(
        previousSibling.entries,
        childNode.entries
      );
      startIndex = i - 1;
      removeCount = 2;
    } else if (i < thisEntries.length - 1) {
      const hash = thisEntries[i + 1][1];
      const nextSibling = await tree.getNode(hash);
      values = joinIterables(
        childNode.entries,
        nextSibling.entries
      );
      startIndex = i;
      removeCount = 2;
    } else {
      values = childNode.entries;
      startIndex = i;
      removeCount = 1;
    }
    const partitions = partition(
      values,
      (value) => value[2],
      tree.minSize - tree.chunkHeaderSize,
      tree.maxSize - tree.chunkHeaderSize
    );
    const newEntries = [];
    for (const entries2 of partitions) {
      const node = tree.newNodeImpl(entries2, level);
      const newHashEntry = createNewInternalEntryForNode(
        node,
        tree.getEntrySize
      );
      newEntries.push(newHashEntry);
    }
    if (this.isMutable) {
      this.entries.splice(startIndex, removeCount, ...newEntries);
      this._updateNode(tree);
      return this;
    }
    const entries = readonlySplice(
      thisEntries,
      startIndex,
      removeCount,
      ...newEntries
    );
    return tree.newInternalNodeImpl(entries, this.level);
  }
  #replaceChild(tree, index, newEntry) {
    if (this.isMutable) {
      this.entries.splice(index, 1, newEntry);
      this._updateNode(tree);
      return this;
    }
    const entries = readonlySplice(this.entries, index, 1, newEntry);
    return tree.newInternalNodeImpl(entries, this.level);
  }
  async del(key, tree) {
    const i = binarySearch2(key, this.entries);
    if (i === this.entries.length) {
      return this;
    }
    const childHash = this.entries[i][1];
    const oldChildNode = await tree.getNode(childHash);
    const oldHash = oldChildNode.hash;
    const childNode = await oldChildNode.del(key, tree);
    if (childNode.hash === oldHash) {
      return this;
    }
    if (childNode.entries.length === 0) {
      const entries = readonlySplice(this.entries, i, 1);
      return tree.newInternalNodeImpl(entries, this.level);
    }
    if (i === 0 && this.entries.length === 1) {
      return childNode;
    }
    if (childNode.getChildNodeSize(tree) > tree.minSize) {
      const entry = createNewInternalEntryForNode(childNode, tree.getEntrySize);
      return this.#replaceChild(tree, i, entry);
    }
    return this.#mergeAndPartition(tree, i, childNode);
  }
  async *keys(tree) {
    for (const entry of this.entries) {
      const childNode = await tree.getNode(entry[1]);
      yield* childNode.keys(tree);
    }
  }
  async *entriesIter(tree) {
    for (const entry of this.entries) {
      const childNode = await tree.getNode(entry[1]);
      yield* childNode.entriesIter(tree);
    }
  }
  getChildren(start, length, tree) {
    const ps = [];
    for (let i = start; i < length && i < this.entries.length; i++) {
      ps.push(tree.getNode(this.entries[i][1]));
    }
    return Promise.all(ps);
  }
  async getCompositeChildren(start, length, tree) {
    const { level } = this;
    if (length === 0) {
      return new _InternalNodeImpl([], newUUIDHash(), level - 1, true);
    }
    const output = await this.getChildren(start, start + length, tree);
    if (level > 1) {
      const entries2 = [];
      for (const child of output) {
        entries2.push(...child.entries);
      }
      return new _InternalNodeImpl(entries2, newUUIDHash(), level - 1, true);
    }
    assert(level === 1);
    const entries = [];
    for (const child of output) {
      entries.push(...child.entries);
    }
    return new DataNodeImpl(entries, newUUIDHash(), true);
  }
};
function newNodeImpl(entries, hash, level, isMutable) {
  if (level === 0) {
    return new DataNodeImpl(
      entries,
      hash,
      isMutable
    );
  }
  return new InternalNodeImpl(entries, hash, level, isMutable);
}
function isDataNodeImpl(node) {
  return node.level === 0;
}
function partition(values, getSizeOfEntry2, min, max) {
  const partitions = [];
  const sizes = [];
  let sum = 0;
  let accum = [];
  for (const value of values) {
    const size = getSizeOfEntry2(value);
    if (size >= max) {
      if (accum.length > 0) {
        partitions.push(accum);
        sizes.push(sum);
      }
      partitions.push([value]);
      sizes.push(size);
      sum = 0;
      accum = [];
    } else if (sum + size >= min) {
      accum.push(value);
      partitions.push(accum);
      sizes.push(sum + size);
      sum = 0;
      accum = [];
    } else {
      sum += size;
      accum.push(value);
    }
  }
  if (sum > 0) {
    if (sizes.length > 0 && sum + sizes[sizes.length - 1] <= max) {
      partitions[partitions.length - 1].push(...accum);
    } else {
      partitions.push(accum);
    }
  }
  return partitions;
}
var emptyDataNode = makeNodeChunkData(
  0,
  [],
  7 /* Latest */
);
var emptyDataNodeImpl = new DataNodeImpl([], emptyHash, false);
function createNewInternalEntryForNode(node, getSizeOfEntry2) {
  const key = node.maxKey();
  const value = node.hash;
  const size = getSizeOfEntry2(key, value);
  return [key, value, size];
}

// src/size-of-value.ts
var SIZE_TAG = 1;
var SIZE_INT32 = 4;
var SIZE_SMI = 5;
var SIZE_DOUBLE = 8;
function getSizeOfValue(value) {
  switch (typeof value) {
    case "string":
      return SIZE_TAG + SIZE_INT32 + value.length;
    case "number":
      if (isSmi(value)) {
        if (value <= -(2 ** 30) || value >= 2 ** 30 - 1) {
          return SIZE_TAG + SIZE_SMI;
        }
        return SIZE_TAG + SIZE_INT32;
      }
      return SIZE_TAG + SIZE_DOUBLE;
    case "boolean":
      return SIZE_TAG;
    case "object":
      if (value === null) {
        return SIZE_TAG;
      }
      if (Array.isArray(value)) {
        let sum = 2 * SIZE_TAG + SIZE_INT32;
        for (const element of value) {
          sum += getSizeOfValue(element);
        }
        return sum;
      }
      {
        const val = value;
        let sum = 2 * SIZE_TAG + SIZE_INT32;
        for (const k in val) {
          if (hasOwn(val, k)) {
            const propertyValue = val[k];
            if (propertyValue !== void 0) {
              sum += getSizeOfValue(k) + getSizeOfValue(propertyValue);
            }
          }
        }
        return sum;
      }
  }
  throw new Error(`Invalid value. type: ${typeof value}, value: ${value}`);
}
function isSmi(value) {
  return value === (value | 0);
}
var entryFixed = 2 * SIZE_TAG + SIZE_INT32 + SIZE_TAG + SIZE_INT32;
function getSizeOfEntry(key, value) {
  return entryFixed + getSizeOfValue(key) + getSizeOfValue(value);
}

// src/btree/splice.ts
var SPLICE_UNASSIGNED = -1;
var SPLICE_AT = 0;
var SPLICE_REMOVED = 1;
var SPLICE_ADDED = 2;
var SPLICE_FROM = 3;
var KEY = 0;
var VALUE = 1;
function* computeSplices(previous, current) {
  let previousIndex = 0;
  let currentIndex = 0;
  let splice;
  function ensureAssigned(splice2, index) {
    if (splice2[SPLICE_FROM] === SPLICE_UNASSIGNED) {
      splice2[SPLICE_FROM] = index;
    }
  }
  function newSplice() {
    return [previousIndex, 0, 0, SPLICE_UNASSIGNED];
  }
  while (previousIndex < previous.length && currentIndex < current.length) {
    if (previous[previousIndex][KEY] === current[currentIndex][KEY]) {
      if (deepEqual(
        // These are really Hash | InternalValue
        previous[previousIndex][VALUE],
        current[currentIndex][VALUE]
      )) {
        if (splice) {
          ensureAssigned(splice, 0);
          yield splice;
          splice = void 0;
        }
      } else {
        if (!splice) {
          splice = newSplice();
        }
        splice[SPLICE_ADDED]++;
        splice[SPLICE_REMOVED]++;
        ensureAssigned(splice, currentIndex);
      }
      previousIndex++;
      currentIndex++;
    } else if (previous[previousIndex][KEY] < current[currentIndex][KEY]) {
      if (!splice) {
        splice = newSplice();
      }
      splice[SPLICE_REMOVED]++;
      previousIndex++;
    } else {
      if (!splice) {
        splice = newSplice();
      }
      splice[SPLICE_ADDED]++;
      ensureAssigned(splice, currentIndex);
      currentIndex++;
    }
  }
  if (currentIndex < current.length) {
    if (!splice) {
      splice = newSplice();
    }
    splice[SPLICE_ADDED] += current.length - currentIndex;
    ensureAssigned(splice, currentIndex);
  }
  if (previousIndex < previous.length) {
    if (!splice) {
      splice = newSplice();
    }
    splice[SPLICE_REMOVED] += previous.length - previousIndex;
  }
  if (splice) {
    ensureAssigned(splice, 0);
    yield splice;
  }
}

// src/btree/read.ts
var NODE_HEADER_SIZE = 11;
var BTreeRead = class {
  _cache = /* @__PURE__ */ new Map();
  _dagRead;
  _formatVersion;
  rootHash;
  getEntrySize;
  chunkHeaderSize;
  constructor(dagRead, formatVersion, root = emptyHash, getEntrySize = getSizeOfEntry, chunkHeaderSize = NODE_HEADER_SIZE) {
    this._dagRead = dagRead;
    this._formatVersion = formatVersion;
    this.rootHash = root;
    this.getEntrySize = getEntrySize;
    this.chunkHeaderSize = chunkHeaderSize;
  }
  async getNode(hash) {
    if (hash === emptyHash) {
      return emptyDataNodeImpl;
    }
    const cached = this._cache.get(hash);
    if (cached) {
      return cached;
    }
    const chunk = await this._dagRead.mustGetChunk(hash);
    const data = parseBTreeNode(
      chunk.data,
      this._formatVersion,
      this.getEntrySize
    );
    const impl = newNodeImpl(
      data[NODE_ENTRIES],
      hash,
      data[NODE_LEVEL],
      false
    );
    this._cache.set(hash, impl);
    return impl;
  }
  async get(key) {
    const leaf = await findLeaf(key, this.rootHash, this, this.rootHash);
    const index = binarySearch2(key, leaf.entries);
    if (!binarySearchFound(index, leaf.entries, key)) {
      return void 0;
    }
    return leaf.entries[index][1];
  }
  async has(key) {
    const leaf = await findLeaf(key, this.rootHash, this, this.rootHash);
    const index = binarySearch2(key, leaf.entries);
    return binarySearchFound(index, leaf.entries, key);
  }
  async isEmpty() {
    const { rootHash } = this;
    const node = await this.getNode(this.rootHash);
    if (this.rootHash !== rootHash) {
      return this.isEmpty();
    }
    return node.entries.length === 0;
  }
  // We don't do any encoding of the key in the map, so we have no way of
  // determining from an entry.key alone whether it is a regular key or an
  // encoded IndexKey in an index map. Without encoding regular map keys the
  // caller has to deal with encoding and decoding the keys for the index map.
  scan(fromKey) {
    return scanForHash(
      this.rootHash,
      () => this.rootHash,
      this.rootHash,
      fromKey,
      async (hash) => {
        const cached = await this.getNode(hash);
        if (cached) {
          return [
            cached.level,
            cached.isMutable ? cached.entries.slice() : cached.entries
          ];
        }
        const chunk = await this._dagRead.mustGetChunk(hash);
        return parseBTreeNode(
          chunk.data,
          this._formatVersion,
          this.getEntrySize
        );
      }
    );
  }
  async *keys() {
    const node = await this.getNode(this.rootHash);
    yield* node.keys(this);
  }
  async *entries() {
    const node = await this.getNode(this.rootHash);
    yield* node.entriesIter(this);
  }
  [Symbol.asyncIterator]() {
    return this.entries();
  }
  async *diff(last) {
    const [currentNode, lastNode] = await Promise.all([
      this.getNode(this.rootHash),
      last.getNode(last.rootHash)
    ]);
    yield* diffNodes(lastNode, currentNode, last, this);
  }
};
async function* diffNodes(last, current, lastTree, currentTree) {
  if (last.level > current.level) {
    const lastChild = await last.getCompositeChildren(
      0,
      last.entries.length,
      lastTree
    );
    yield* diffNodes(lastChild, current, lastTree, currentTree);
    return;
  }
  if (current.level > last.level) {
    const currentChild = await current.getCompositeChildren(
      0,
      current.entries.length,
      currentTree
    );
    yield* diffNodes(last, currentChild, lastTree, currentTree);
    return;
  }
  if (isDataNodeImpl(last) && isDataNodeImpl(current)) {
    yield* diffEntries(
      last.entries,
      current.entries
    );
    return;
  }
  const initialSplices = computeSplices(
    last.entries,
    current.entries
  );
  for (const splice of initialSplices) {
    const [lastChild, currentChild] = await Promise.all([
      last.getCompositeChildren(
        splice[SPLICE_AT],
        splice[SPLICE_REMOVED],
        lastTree
      ),
      current.getCompositeChildren(
        splice[SPLICE_FROM],
        splice[SPLICE_ADDED],
        currentTree
      )
    ]);
    yield* diffNodes(lastChild, currentChild, lastTree, currentTree);
  }
}
function* diffEntries(lastEntries, currentEntries) {
  const lastLength = lastEntries.length;
  const currentLength = currentEntries.length;
  let i = 0;
  let j = 0;
  while (i < lastLength && j < currentLength) {
    const lastKey = lastEntries[i][0];
    const currentKey = currentEntries[j][0];
    if (lastKey === currentKey) {
      if (!deepEqual(lastEntries[i][1], currentEntries[j][1])) {
        yield {
          op: "change",
          key: lastKey,
          oldValue: lastEntries[i][1],
          newValue: currentEntries[j][1]
        };
      }
      i++;
      j++;
    } else if (lastKey < currentKey) {
      yield {
        op: "del",
        key: lastKey,
        oldValue: lastEntries[i][1]
      };
      i++;
    } else {
      yield {
        op: "add",
        key: currentKey,
        newValue: currentEntries[j][1]
      };
      j++;
    }
  }
  for (; i < lastLength; i++) {
    yield {
      op: "del",
      key: lastEntries[i][0],
      oldValue: lastEntries[i][1]
    };
  }
  for (; j < currentLength; j++) {
    yield {
      op: "add",
      key: currentEntries[j][0],
      newValue: currentEntries[j][1]
    };
  }
}
async function* scanForHash(expectedRootHash, getRootHash, hash, fromKey, readNode) {
  if (hash === emptyHash) {
    return;
  }
  const data = await readNode(hash);
  const entries = data[NODE_ENTRIES];
  let i = 0;
  if (fromKey) {
    i = binarySearch2(fromKey, entries);
  }
  if (data[NODE_LEVEL] > 0) {
    for (; i < entries.length; i++) {
      yield* scanForHash(
        expectedRootHash,
        getRootHash,
        entries[i][1],
        fromKey,
        readNode
      );
      fromKey = "";
    }
  } else {
    for (; i < entries.length; i++) {
      const rootHash = getRootHash();
      if (expectedRootHash !== rootHash) {
        yield* scanForHash(
          rootHash,
          getRootHash,
          rootHash,
          entries[i][0],
          readNode
        );
        return;
      }
      yield entries[i];
    }
  }
}
async function allEntriesAsDiff(map, op) {
  const diff2 = [];
  const make = op === "add" ? (entry) => ({
    op: "add",
    key: entry[0],
    newValue: entry[1]
  }) : (entry) => ({
    op: "del",
    key: entry[0],
    oldValue: entry[1]
  });
  for await (const entry of map.entries()) {
    diff2.push(make(entry));
  }
  return diff2;
}

// src/db/commit.ts
var DEFAULT_HEAD_NAME = "main";
function commitIsLocalSDD(commit) {
  return isLocalMetaSDD(commit.meta);
}
function commitIsLocalDD31(commit) {
  return isLocalMetaDD31(commit.meta);
}
function commitIsLocal(commit) {
  return commitIsLocalDD31(commit) || commitIsLocalSDD(commit);
}
function commitIsSnapshotDD31(commit) {
  return isSnapshotMetaDD31(commit.meta);
}
function commitIsSnapshotSDD(commit) {
  return isSnapshotMetaSDD(commit.meta);
}
function commitIsSnapshot(commit) {
  return commitIsSnapshotDD31(commit) || commitIsSnapshotSDD(commit);
}
var Commit = class {
  chunk;
  constructor(chunk) {
    this.chunk = chunk;
  }
  get meta() {
    return this.chunk.data.meta;
  }
  get valueHash() {
    return this.chunk.data.valueHash;
  }
  getMutationID(clientID, dagRead) {
    return getMutationID(clientID, dagRead, this.meta);
  }
  async getNextMutationID(clientID, dagRead) {
    return await this.getMutationID(clientID, dagRead) + 1;
  }
  get indexes() {
    return this.chunk.data.indexes;
  }
};
async function getMutationID(clientID, dagRead, meta) {
  switch (meta.type) {
    case 1 /* IndexChangeSDD */:
      return meta.lastMutationID;
    case 3 /* SnapshotSDD */:
      return meta.lastMutationID;
    case 5 /* SnapshotDD31 */:
      return meta.lastMutationIDs[clientID] ?? 0;
    case 2 /* LocalSDD */:
      return meta.mutationID;
    case 4 /* LocalDD31 */: {
      if (meta.clientID === clientID) {
        return meta.mutationID;
      }
      const { basisHash } = meta;
      const basisCommit = await commitFromHash(basisHash, dagRead);
      return getMutationID(clientID, dagRead, basisCommit.meta);
    }
    default:
      unreachable();
  }
}
async function localMutations(fromCommitHash, dagRead) {
  const commits = await commitChain(fromCommitHash, dagRead);
  return commits.filter((c) => commitIsLocal(c));
}
async function localMutationsDD31(fromCommitHash, dagRead) {
  const commits = await commitChain(fromCommitHash, dagRead);
  return commits.filter((c) => commitIsLocalDD31(c));
}
async function localMutationsGreaterThan(commit, mutationIDLimits, dagRead) {
  const commits = [];
  const remainingMutationIDLimits = new Map(Object.entries(mutationIDLimits));
  while (!commitIsSnapshot(commit) && remainingMutationIDLimits.size > 0) {
    if (commitIsLocalDD31(commit)) {
      const { meta } = commit;
      const mutationIDLowerLimit = remainingMutationIDLimits.get(meta.clientID);
      if (mutationIDLowerLimit !== void 0) {
        if (meta.mutationID <= mutationIDLowerLimit) {
          remainingMutationIDLimits.delete(meta.clientID);
        } else {
          commits.push(commit);
        }
      }
    }
    const { basisHash } = commit.meta;
    if (basisHash === null) {
      throw new Error(`Commit ${commit.chunk.hash} has no basis`);
    }
    commit = await commitFromHash(basisHash, dagRead);
  }
  return commits;
}
async function baseSnapshotFromHead(name, dagRead) {
  const hash = await dagRead.getHead(name);
  assert(hash, `Missing head ${name}`);
  return baseSnapshotFromHash(hash, dagRead);
}
async function baseSnapshotHashFromHash(hash, dagRead) {
  return (await baseSnapshotFromHash(hash, dagRead)).chunk.hash;
}
async function baseSnapshotFromHash(hash, dagRead) {
  const commit = await commitFromHash(hash, dagRead);
  return baseSnapshotFromCommit(commit, dagRead);
}
async function baseSnapshotFromCommit(commit, dagRead) {
  while (!commitIsSnapshot(commit)) {
    const { meta } = commit;
    if (isLocalMetaDD31(meta)) {
      commit = await commitFromHash(meta.baseSnapshotHash, dagRead);
    } else {
      const { basisHash } = meta;
      if (basisHash === null) {
        throw new Error(`Commit ${commit.chunk.hash} has no basis`);
      }
      commit = await commitFromHash(basisHash, dagRead);
    }
  }
  return commit;
}
function snapshotMetaParts(c, clientID) {
  const m = c.meta;
  if (isSnapshotMetaDD31(m)) {
    const lmid = m.lastMutationIDs[clientID] ?? 0;
    return [lmid, m.cookieJSON];
  }
  return [m.lastMutationID, m.cookieJSON];
}
function compareCookiesForSnapshots(a, b) {
  return compareCookies(a.meta.cookieJSON, b.meta.cookieJSON);
}
async function commitChain(fromCommitHash, dagRead) {
  let commit = await commitFromHash(fromCommitHash, dagRead);
  const commits = [];
  while (!commitIsSnapshot(commit)) {
    const { meta } = commit;
    const { basisHash } = meta;
    if (basisHash === null) {
      throw new Error(`Commit ${commit.chunk.hash} has no basis`);
    }
    commits.push(commit);
    commit = await commitFromHash(basisHash, dagRead);
  }
  commits.push(commit);
  return commits;
}
async function commitFromHash(hash, dagRead) {
  const chunk = await dagRead.mustGetChunk(hash);
  return fromChunk(chunk);
}
async function commitFromHead(name, dagRead) {
  const hash = await mustGetHeadHash(name, dagRead);
  return commitFromHash(hash, dagRead);
}
function assertIndexChangeMeta(v2) {
  assertNumber(v2.lastMutationID);
}
function assertLocalMetaSDD(v2) {
  assertNumber(v2.mutationID);
  assertString2(v2.mutatorName);
  if (!v2.mutatorName) {
    throw new Error("Missing mutator name");
  }
  assertJSONValue(v2.mutatorArgsJSON);
  if (v2.originalHash !== null) {
    assertHash(v2.originalHash);
  }
  assertNumber(v2.timestamp);
}
function assertLocalMetaDD31(v2) {
  assertString2(v2.clientID);
  assertLocalMetaSDD(v2);
}
function isLocalMetaDD31(meta) {
  return meta.type === 4 /* LocalDD31 */;
}
function isLocalMetaSDD(meta) {
  return meta.type === 2 /* LocalSDD */;
}
function assertSnapshotMetaBase(v2) {
  if (v2.basisHash !== null) {
    assertHash(v2.basisHash);
  }
  assertJSONValue(v2.cookieJSON);
}
function assertSnapshotMetaSDD(v2) {
  assertSnapshotMetaBase(v2);
  assertNumber(v2.lastMutationID);
}
function assertSnapshotMetaDD31(v2) {
  assertSnapshotMetaBase(v2);
  assertLastMutationIDs(v2.lastMutationIDs);
}
function assertLastMutationIDs(v2) {
  assertObject2(v2);
  for (const e of Object.values(v2)) {
    assertNumber(e);
  }
}
function assertSnapshotCommitDD31(c) {
  assertSnapshotMetaDD31(c.meta);
}
function isSnapshotMetaDD31(meta) {
  return meta.type === 5 /* SnapshotDD31 */;
}
function isSnapshotMetaSDD(meta) {
  return meta.type === 3 /* SnapshotSDD */;
}
function assertMeta2(v2) {
  assertObject2(v2);
  assertDeepFrozen(v2);
  if (v2.basisHash !== null) {
    assertString2(v2.basisHash);
  }
  assertNumber(v2.type);
  switch (v2.type) {
    case 1 /* IndexChangeSDD */:
      assertIndexChangeMeta(v2);
      break;
    case 2 /* LocalSDD */:
      assertLocalMetaSDD(v2);
      break;
    case 4 /* LocalDD31 */:
      assertLocalMetaDD31(v2);
      break;
    case 3 /* SnapshotSDD */:
      assertSnapshotMetaSDD(v2);
      break;
    case 5 /* SnapshotDD31 */:
      assertSnapshotMetaDD31(v2);
      break;
    default:
      throw new Error(`Invalid enum value ${v2.type}`);
  }
}
function chunkIndexDefinitionEqualIgnoreName(a, b) {
  return a.jsonPointer === b.jsonPointer && (a.allowEmpty ?? false) === (b.allowEmpty ?? false) && a.keyPrefix === b.keyPrefix;
}
function assertChunkIndexDefinition(v2) {
  assertObject2(v2);
  assertDeepFrozen(v2);
  assertString2(v2.name);
  assertString2(v2.keyPrefix);
  assertString2(v2.jsonPointer);
  if (v2.allowEmpty !== void 0) {
    assertBoolean2(v2.allowEmpty);
  }
}
function toChunkIndexDefinition(name, indexDefinition) {
  return {
    name,
    keyPrefix: indexDefinition.prefix ?? "",
    jsonPointer: indexDefinition.jsonPointer,
    allowEmpty: indexDefinition.allowEmpty ?? false
  };
}
function assertIndexRecord(v2) {
  assertObject2(v2);
  assertDeepFrozen(v2);
  assertChunkIndexDefinition(v2.definition);
  assertString2(v2.valueHash);
}
function assertIndexRecords(v2) {
  assertArray(v2);
  assertDeepFrozen(v2);
  for (const ir of v2) {
    assertIndexRecord(ir);
  }
}
function newLocalSDD(createChunk2, basisHash, mutationID, mutatorName, mutatorArgsJSON, originalHash, valueHash, indexes, timestamp) {
  const meta = {
    type: 2 /* LocalSDD */,
    basisHash,
    mutationID,
    mutatorName,
    mutatorArgsJSON,
    originalHash,
    timestamp
  };
  return commitFromCommitData(
    createChunk2,
    makeCommitData(meta, valueHash, indexes)
  );
}
function newLocalDD31(createChunk2, basisHash, baseSnapshotHash, mutationID, mutatorName, mutatorArgsJSON, originalHash, valueHash, indexes, timestamp, clientID) {
  const meta = {
    type: 4 /* LocalDD31 */,
    basisHash,
    baseSnapshotHash,
    mutationID,
    mutatorName,
    mutatorArgsJSON,
    originalHash,
    timestamp,
    clientID
  };
  return commitFromCommitData(
    createChunk2,
    makeCommitData(meta, valueHash, indexes)
  );
}
function newSnapshotSDD(createChunk2, basisHash, lastMutationID, cookieJSON, valueHash, indexes) {
  return commitFromCommitData(
    createChunk2,
    newSnapshotCommitDataSDD(
      basisHash,
      lastMutationID,
      cookieJSON,
      valueHash,
      indexes
    )
  );
}
function newSnapshotDD31(createChunk2, basisHash, lastMutationIDs, cookieJSON, valueHash, indexes) {
  return commitFromCommitData(
    createChunk2,
    newSnapshotCommitDataDD31(
      basisHash,
      lastMutationIDs,
      cookieJSON,
      valueHash,
      indexes
    )
  );
}
function newSnapshotCommitDataSDD(basisHash, lastMutationID, cookieJSON, valueHash, indexes) {
  const meta = {
    type: 3 /* SnapshotSDD */,
    basisHash,
    lastMutationID,
    cookieJSON
  };
  return makeCommitData(meta, valueHash, indexes);
}
function newSnapshotCommitDataDD31(basisHash, lastMutationIDs, cookieJSON, valueHash, indexes) {
  const meta = {
    type: 5 /* SnapshotDD31 */,
    basisHash,
    lastMutationIDs,
    cookieJSON
  };
  return makeCommitData(meta, valueHash, indexes);
}
function newIndexChange(createChunk2, basisHash, lastMutationID, valueHash, indexes) {
  const meta = {
    type: 1 /* IndexChangeSDD */,
    basisHash,
    lastMutationID
  };
  return commitFromCommitData(
    createChunk2,
    makeCommitData(meta, valueHash, indexes)
  );
}
function fromChunk(chunk) {
  validateChunk(chunk);
  return new Commit(chunk);
}
function commitFromCommitData(createChunk2, data) {
  return new Commit(createChunk2(data, getRefs(data)));
}
function getRefs(data) {
  const refs = [data.valueHash];
  const { meta } = data;
  switch (meta.type) {
    case 1 /* IndexChangeSDD */:
      meta.basisHash && refs.push(meta.basisHash);
      break;
    case 2 /* LocalSDD */:
    case 4 /* LocalDD31 */:
      meta.basisHash && refs.push(meta.basisHash);
      break;
    case 3 /* SnapshotSDD */:
    case 5 /* SnapshotDD31 */:
      break;
    default:
      unreachable();
  }
  for (const index of data.indexes) {
    refs.push(index.valueHash);
  }
  return refs;
}
function makeCommitData(meta, valueHash, indexes) {
  return deepFreeze({
    meta,
    valueHash,
    indexes
  });
}
function assertCommitData(v2) {
  if (isProd) {
    return;
  }
  assertObject2(v2);
  assertDeepFrozen(v2);
  assertMeta2(v2.meta);
  assertString2(v2.valueHash);
  assertIndexRecords(v2.indexes);
}
function validateChunk(chunk) {
  const { data } = chunk;
  assertCommitData(data);
  const seen = /* @__PURE__ */ new Set();
  for (const index of data.indexes) {
    const { name } = index.definition;
    if (seen.has(name)) {
      throw new Error(`Duplicate index ${name}`);
    }
    seen.add(name);
  }
}

// src/async-iterable-to-array.ts
async function asyncIterableToArray(it) {
  const arr2 = [];
  for await (const v2 of it) {
    arr2.push(v2);
  }
  return arr2;
}

// src/btree/diff.ts
function diff(oldMap, newMap) {
  return asyncIterableToArray(newMap.diff(oldMap));
}

// src/btree/write.ts
import { Lock } from "@rocicorp/lock";
var BTreeWrite = class extends BTreeRead {
  /**
   * This rw lock is used to ensure we do not mutate the btree in parallel. It
   * would be a problem if we didn't have the lock in cases like this:
   *
   * ```ts
   * const p1 = tree.put('a', 0);
   * const p2 = tree.put('b', 1);
   * await p1;
   * await p2;
   * ```
   *
   * because both `p1` and `p2` would start from the old root hash but a put
   * changes the root hash so the two concurrent puts would lead to only one of
   * them actually working, and it is not deterministic which one would finish
   * last.
   */
  #lock = new Lock();
  #modified = /* @__PURE__ */ new Map();
  minSize;
  maxSize;
  constructor(dagWrite, formatVersion, root = emptyHash, minSize = 8 * 1024, maxSize = 16 * 1024, getEntrySize = getSizeOfEntry, chunkHeaderSize) {
    super(dagWrite, formatVersion, root, getEntrySize, chunkHeaderSize);
    this.minSize = minSize;
    this.maxSize = maxSize;
  }
  #addToModified(node) {
    assert(node.isMutable);
    this.#modified.set(node.hash, node);
    this._cache.set(node.hash, node);
  }
  updateNode(node) {
    assert(node.isMutable);
    this.#modified.delete(node.hash);
    node.hash = newUUIDHash();
    this.#addToModified(node);
  }
  newInternalNodeImpl(entries, level) {
    const n = new InternalNodeImpl(entries, newUUIDHash(), level, true);
    this.#addToModified(n);
    return n;
  }
  newDataNodeImpl(entries) {
    const n = new DataNodeImpl(entries, newUUIDHash(), true);
    this.#addToModified(n);
    return n;
  }
  newNodeImpl(entries, level) {
    const n = newNodeImpl(entries, newUUIDHash(), level, true);
    this.#addToModified(n);
    return n;
  }
  put(key, value) {
    return this.#lock.withLock(async () => {
      const oldRootNode = await this.getNode(this.rootHash);
      const entrySize = this.getEntrySize(key, value);
      const rootNode = await oldRootNode.set(key, value, entrySize, this);
      if (rootNode.getChildNodeSize(this) > this.maxSize) {
        const headerSize = this.chunkHeaderSize;
        const partitions = partition(
          rootNode.entries,
          (value2) => value2[2],
          this.minSize - headerSize,
          this.maxSize - headerSize
        );
        const { level } = rootNode;
        const entries = partitions.map((entries2) => {
          const node = this.newNodeImpl(entries2, level);
          return createNewInternalEntryForNode(node, this.getEntrySize);
        });
        const newRoot = this.newInternalNodeImpl(entries, level + 1);
        this.rootHash = newRoot.hash;
        return;
      }
      this.rootHash = rootNode.hash;
    });
  }
  del(key) {
    return this.#lock.withLock(async () => {
      const oldRootNode = await this.getNode(this.rootHash);
      const newRootNode = await oldRootNode.del(key, this);
      const found = this.rootHash !== newRootNode.hash;
      if (found) {
        if (newRootNode.level > 0 && newRootNode.entries.length === 1) {
          this.rootHash = newRootNode.entries[0][1];
        } else {
          this.rootHash = newRootNode.hash;
        }
      }
      return found;
    });
  }
  clear() {
    return this.#lock.withLock(() => {
      this.#modified.clear();
      this.rootHash = emptyHash;
    });
  }
  flush() {
    return this.#lock.withLock(async () => {
      const dagWrite = this._dagRead;
      if (this.rootHash === emptyHash) {
        const chunk = dagWrite.createChunk(emptyDataNode, []);
        await dagWrite.putChunk(chunk);
        return chunk.hash;
      }
      const newChunks = [];
      const newRoot = gatherNewChunks(
        this.rootHash,
        newChunks,
        dagWrite.createChunk,
        this.#modified,
        this._formatVersion
      );
      await Promise.all(newChunks.map((chunk) => dagWrite.putChunk(chunk)));
      this.#modified.clear();
      this.rootHash = newRoot;
      return newRoot;
    });
  }
};
function gatherNewChunks(hash, newChunks, createChunk2, modified, formatVersion) {
  const node = modified.get(hash);
  if (node === void 0) {
    return hash;
  }
  if (isDataNodeImpl(node)) {
    const chunk2 = createChunk2(toChunkData(node, formatVersion), []);
    newChunks.push(chunk2);
    return chunk2.hash;
  }
  const refs = [];
  const { entries } = node;
  for (let i = 0; i < entries.length; i++) {
    const entry = entries[i];
    const childHash = entry[1];
    const newChildHash = gatherNewChunks(
      childHash,
      newChunks,
      createChunk2,
      modified,
      formatVersion
    );
    if (newChildHash !== childHash) {
      entries[i] = [entry[0], newChildHash, entry[2]];
    }
    refs.push(newChildHash);
  }
  const chunk = createChunk2(toChunkData(node, formatVersion), refs);
  newChunks.push(chunk);
  return chunk.hash;
}

// src/lazy.ts
function lazy(factory) {
  let value;
  return () => {
    if (value === void 0) {
      value = factory();
    }
    return value;
  };
}

// src/db/index.ts
var IndexRead = class {
  meta;
  map;
  constructor(meta, map) {
    this.meta = meta;
    this.map = map;
  }
};
var IndexWrite = class extends IndexRead {
  // Note: does not update self.meta.valueHash (doesn't need to at this point as flush
  // is only called during commit.)
  flush() {
    return this.map.flush();
  }
  clear() {
    return this.map.clear();
  }
};
async function indexValue(lc, index, op, key, val, jsonPointer, allowEmpty) {
  try {
    for (const entry of getIndexKeys(key, val, jsonPointer, allowEmpty)) {
      switch (op) {
        case 0 /* Add */:
          await index.put(entry, val);
          break;
        case 1 /* Remove */:
          await index.del(entry);
          break;
      }
    }
  } catch (e) {
    lc.info?.("Not indexing value", val, ":", e);
  }
}
function getIndexKeys(primary, value, jsonPointer, allowEmpty) {
  const target = evaluateJSONPointer(value, jsonPointer);
  if (target === void 0) {
    if (allowEmpty) {
      return [];
    }
    throw new Error(`No value at path: ${jsonPointer}`);
  }
  const values = Array.isArray(target) ? target : [target];
  const indexKeys = [];
  for (const value2 of values) {
    if (typeof value2 === "string") {
      indexKeys.push(encodeIndexKey([value2, primary]));
    } else {
      throw new Error("Unsupported target type");
    }
  }
  return indexKeys;
}
var KEY_VERSION_0 = "\0";
var KEY_SEPARATOR = "\0";
function encodeIndexKey(indexKey) {
  const secondary = indexKey[0];
  const primary = indexKey[1];
  if (secondary.includes("\0")) {
    throw new Error("Secondary key cannot contain null byte");
  }
  return KEY_VERSION_0 + secondary + KEY_SEPARATOR + primary;
}
function encodeIndexScanKey(secondary, primary) {
  const k = encodeIndexKey([secondary, primary || ""]);
  if (primary === void 0) {
    return k.slice(0, k.length - 1);
  }
  return k;
}
function decodeIndexKey(encodedIndexKey) {
  if (encodedIndexKey[0] !== KEY_VERSION_0) {
    throw new Error("Invalid version");
  }
  const versionLen = KEY_VERSION_0.length;
  const separatorLen = KEY_SEPARATOR.length;
  const separatorOffset = encodedIndexKey.indexOf(KEY_SEPARATOR, versionLen);
  if (separatorOffset === -1) {
    throw new Error("Invalid formatting");
  }
  const secondary = encodedIndexKey.slice(versionLen, separatorOffset);
  const primary = encodedIndexKey.slice(separatorOffset + separatorLen);
  return [secondary, primary];
}
function evaluateJSONPointer(value, pointer) {
  function parseIndex(s) {
    if (s.startsWith("+") || s.startsWith("0") && s.length !== 1) {
      return void 0;
    }
    return parseInt(s, 10);
  }
  if (pointer === "") {
    return value;
  }
  if (!pointer.startsWith("/")) {
    throw new Error(`Invalid JSON pointer: ${pointer}`);
  }
  const tokens = pointer.split("/").slice(1).map((x) => x.replace(/~1/g, "/").replace(/~0/g, "~"));
  let target = value;
  for (const token of tokens) {
    let targetOpt;
    if (Array.isArray(target)) {
      const i = parseIndex(token);
      if (i === void 0) {
        return void 0;
      }
      targetOpt = target[i];
    } else if (target === null) {
      return void 0;
    } else if (typeof target === "object") {
      target = target;
      targetOpt = target[token];
    }
    if (targetOpt === void 0) {
      return void 0;
    }
    target = targetOpt;
  }
  return target;
}

// src/db/read.ts
var Read3 = class {
  #dagRead;
  map;
  indexes;
  constructor(dagRead, map, indexes) {
    this.#dagRead = dagRead;
    this.map = map;
    this.indexes = indexes;
  }
  has(key) {
    return this.map.has(key);
  }
  get(key) {
    return this.map.get(key);
  }
  isEmpty() {
    return this.map.isEmpty();
  }
  getMapForIndex(indexName) {
    const idx = this.indexes.get(indexName);
    if (idx === void 0) {
      throw new Error(`Unknown index name: ${indexName}`);
    }
    return idx.map;
  }
  get closed() {
    return this.#dagRead.closed;
  }
  close() {
    this.#dagRead.release();
  }
};
function readFromDefaultHead(dagRead, formatVersion) {
  return readFromHead(DEFAULT_HEAD_NAME, dagRead, formatVersion);
}
async function readFromHead(name, dagRead, formatVersion) {
  const commit = await commitFromHead(name, dagRead);
  return readFromCommit(commit, dagRead, formatVersion);
}
function readFromCommit(commit, dagRead, formatVersion) {
  const indexes = readIndexesForRead(commit, dagRead, formatVersion);
  const map = new BTreeRead(dagRead, formatVersion, commit.valueHash);
  return new Read3(dagRead, map, indexes);
}
function readIndexesForRead(commit, dagRead, formatVersion) {
  const m = /* @__PURE__ */ new Map();
  for (const index of commit.indexes) {
    m.set(
      index.definition.name,
      new IndexRead(
        index,
        new BTreeRead(dagRead, formatVersion, index.valueHash)
      )
    );
  }
  return m;
}

// src/sync/diff.ts
var DiffsMap = class extends Map {
  set(key, value) {
    if (value.length === 0) {
      return this;
    }
    return super.set(key, value);
  }
};
async function diffCommits(oldCommit, newCommit, read, diffConfig, formatVersion) {
  const diffsMap = new DiffsMap();
  if (!diffConfig.shouldComputeDiffs()) {
    return diffsMap;
  }
  const oldMap = new BTreeRead(read, formatVersion, oldCommit.valueHash);
  const newMap = new BTreeRead(read, formatVersion, newCommit.valueHash);
  const valueDiff = await diff(oldMap, newMap);
  diffsMap.set("", valueDiff);
  await addDiffsForIndexes(
    oldCommit,
    newCommit,
    read,
    diffsMap,
    diffConfig,
    formatVersion
  );
  return diffsMap;
}
async function addDiffsForIndexes(mainCommit, syncCommit, read, diffsMap, diffConfig, formatVersion) {
  const oldIndexes = readIndexesForRead(mainCommit, read, formatVersion);
  const newIndexes = readIndexesForRead(syncCommit, read, formatVersion);
  for (const [oldIndexName, oldIndex] of oldIndexes) {
    if (!diffConfig.shouldComputeDiffsForIndex(oldIndexName)) {
      continue;
    }
    const newIndex = newIndexes.get(oldIndexName);
    if (newIndex !== void 0) {
      assert(newIndex !== oldIndex);
      const diffs = await diff(oldIndex.map, newIndex.map);
      newIndexes.delete(oldIndexName);
      diffsMap.set(oldIndexName, diffs);
    } else {
      const diffs = await allEntriesAsDiff(oldIndex.map, "del");
      diffsMap.set(oldIndexName, diffs);
    }
  }
  for (const [newIndexName, newIndex] of newIndexes) {
    if (!diffConfig.shouldComputeDiffsForIndex(newIndexName)) {
      continue;
    }
    const diffs = await allEntriesAsDiff(newIndex.map, "add");
    diffsMap.set(newIndexName, diffs);
  }
}

// src/db/write.ts
var Write2 = class extends Read3 {
  #dagWrite;
  #basis;
  #meta;
  #clientID;
  #formatVersion;
  constructor(dagWrite, map, basis, meta, indexes, clientID, formatVersion) {
    super(dagWrite, map, indexes);
    this.#dagWrite = dagWrite;
    this.#basis = basis;
    this.#meta = meta;
    this.#clientID = clientID;
    this.#formatVersion = formatVersion;
    if (basis === void 0) {
      assert(meta.basisHash === emptyHash);
    } else {
      assert(meta.basisHash === basis.chunk.hash);
    }
  }
  /**
   * The value needs to be frozen since it is kept in memory and used later for
   * comparison as well as returned in `get`.
   */
  async put(lc, key, value) {
    if (this.#meta.type === 1 /* IndexChangeSDD */) {
      throw new Error("Not allowed");
    }
    const oldVal = lazy(() => this.map.get(key));
    await updateIndexes(lc, this.indexes, key, oldVal, value);
    await this.map.put(key, value);
  }
  getMutationID() {
    return getMutationID(this.#clientID, this.#dagWrite, this.#meta);
  }
  async del(lc, key) {
    if (this.#meta.type === 1 /* IndexChangeSDD */) {
      throw new Error("Not allowed");
    }
    const oldVal = lazy(() => this.map.get(key));
    if (oldVal !== void 0) {
      await updateIndexes(lc, this.indexes, key, oldVal, void 0);
    }
    return this.map.del(key);
  }
  async clear() {
    if (this.#meta.type === 1 /* IndexChangeSDD */) {
      throw new Error("Not allowed");
    }
    await this.map.clear();
    const ps = [];
    for (const idx of this.indexes.values()) {
      ps.push(idx.clear());
    }
    await Promise.all(ps);
  }
  async putCommit() {
    const valueHash = await this.map.flush();
    const indexRecords = [];
    for (const index of this.indexes.values()) {
      const valueHash2 = await index.flush();
      const indexRecord = {
        definition: index.meta.definition,
        valueHash: valueHash2
      };
      indexRecords.push(indexRecord);
    }
    let commit;
    const meta = this.#meta;
    switch (meta.type) {
      case 2 /* LocalSDD */: {
        const {
          basisHash,
          mutationID,
          mutatorName,
          mutatorArgsJSON,
          originalHash,
          timestamp
        } = meta;
        commit = newLocalSDD(
          this.#dagWrite.createChunk,
          basisHash,
          mutationID,
          mutatorName,
          mutatorArgsJSON,
          originalHash,
          valueHash,
          indexRecords,
          timestamp
        );
        break;
      }
      case 4 /* LocalDD31 */: {
        assert(this.#formatVersion >= 5 /* DD31 */);
        const {
          basisHash,
          mutationID,
          mutatorName,
          mutatorArgsJSON,
          originalHash,
          timestamp
        } = meta;
        commit = newLocalDD31(
          this.#dagWrite.createChunk,
          basisHash,
          await baseSnapshotHashFromHash(basisHash, this.#dagWrite),
          mutationID,
          mutatorName,
          mutatorArgsJSON,
          originalHash,
          valueHash,
          indexRecords,
          timestamp,
          this.#clientID
        );
        break;
      }
      case 3 /* SnapshotSDD */: {
        assert(this.#formatVersion <= 4 /* SDD */);
        const { basisHash, lastMutationID, cookieJSON } = meta;
        commit = newSnapshotSDD(
          this.#dagWrite.createChunk,
          basisHash,
          lastMutationID,
          cookieJSON,
          valueHash,
          indexRecords
        );
        break;
      }
      case 5 /* SnapshotDD31 */: {
        assert(this.#formatVersion > 5 /* DD31 */);
        const { basisHash, lastMutationIDs, cookieJSON } = meta;
        commit = newSnapshotDD31(
          this.#dagWrite.createChunk,
          basisHash,
          lastMutationIDs,
          cookieJSON,
          valueHash,
          indexRecords
        );
        break;
      }
      case 1 /* IndexChangeSDD */: {
        const { basisHash, lastMutationID } = meta;
        if (this.#basis !== void 0) {
          if (await this.#basis.getMutationID(
            this.#clientID,
            this.#dagWrite
          ) !== lastMutationID) {
            throw new Error("Index change must not change mutationID");
          }
          if (this.#basis.valueHash !== valueHash) {
            throw new Error("Index change must not change valueHash");
          }
        }
        commit = newIndexChange(
          this.#dagWrite.createChunk,
          basisHash,
          lastMutationID,
          valueHash,
          indexRecords
        );
        break;
      }
    }
    await this.#dagWrite.putChunk(commit.chunk);
    return commit;
  }
  // Return value is the hash of the new commit.
  async commit(headName) {
    const commit = await this.putCommit();
    const commitHash = commit.chunk.hash;
    await this.#dagWrite.setHead(headName, commitHash);
    await this.#dagWrite.commit();
    return commitHash;
  }
  async commitWithDiffs(headName, diffConfig) {
    const commit = this.putCommit();
    const diffMap = await this.#generateDiffs(diffConfig);
    const commitHash = (await commit).chunk.hash;
    await this.#dagWrite.setHead(headName, commitHash);
    await this.#dagWrite.commit();
    return diffMap;
  }
  async #generateDiffs(diffConfig) {
    const diffsMap = new DiffsMap();
    if (!diffConfig.shouldComputeDiffs()) {
      return diffsMap;
    }
    let valueDiff = [];
    if (this.#basis) {
      const basisMap = new BTreeRead(
        this.#dagWrite,
        this.#formatVersion,
        this.#basis.valueHash
      );
      valueDiff = await diff(basisMap, this.map);
    }
    diffsMap.set("", valueDiff);
    let basisIndexes;
    if (this.#basis) {
      basisIndexes = readIndexesForRead(
        this.#basis,
        this.#dagWrite,
        this.#formatVersion
      );
    } else {
      basisIndexes = /* @__PURE__ */ new Map();
    }
    for (const [name, index] of this.indexes) {
      if (!diffConfig.shouldComputeDiffsForIndex(name)) {
        continue;
      }
      const basisIndex = basisIndexes.get(name);
      assert(index !== basisIndex);
      const indexDiffResult = await (basisIndex ? diff(basisIndex.map, index.map) : (
        // No basis. All keys are new.
        allEntriesAsDiff(index.map, "add")
      ));
      diffsMap.set(name, indexDiffResult);
    }
    for (const [name, basisIndex] of basisIndexes) {
      if (!this.indexes.has(name) && diffConfig.shouldComputeDiffsForIndex(name)) {
        const indexDiffResult = await allEntriesAsDiff(basisIndex.map, "del");
        diffsMap.set(name, indexDiffResult);
      }
    }
    return diffsMap;
  }
  close() {
    this.#dagWrite.release();
  }
};
async function newWriteLocal(basisHash, mutatorName, mutatorArgsJSON, originalHash, dagWrite, timestamp, clientID, formatVersion) {
  const basis = await commitFromHash(basisHash, dagWrite);
  const bTreeWrite = new BTreeWrite(dagWrite, formatVersion, basis.valueHash);
  const mutationID = await basis.getNextMutationID(clientID, dagWrite);
  const indexes = readIndexesForWrite(basis, dagWrite, formatVersion);
  return new Write2(
    dagWrite,
    bTreeWrite,
    basis,
    formatVersion >= 5 /* DD31 */ ? {
      type: 4 /* LocalDD31 */,
      basisHash,
      baseSnapshotHash: await baseSnapshotHashFromHash(basisHash, dagWrite),
      mutatorName,
      mutatorArgsJSON,
      mutationID,
      originalHash,
      timestamp,
      clientID
    } : {
      type: 2 /* LocalSDD */,
      basisHash,
      mutatorName,
      mutatorArgsJSON,
      mutationID,
      originalHash,
      timestamp
    },
    indexes,
    clientID,
    formatVersion
  );
}
async function newWriteSnapshotSDD(basisHash, lastMutationID, cookieJSON, dagWrite, indexes, clientID, formatVersion) {
  assert(formatVersion <= 4 /* SDD */);
  const basis = await commitFromHash(basisHash, dagWrite);
  const bTreeWrite = new BTreeWrite(dagWrite, formatVersion, basis.valueHash);
  return new Write2(
    dagWrite,
    bTreeWrite,
    basis,
    { basisHash, type: 3 /* SnapshotSDD */, lastMutationID, cookieJSON },
    indexes,
    clientID,
    formatVersion
  );
}
async function newWriteSnapshotDD31(basisHash, lastMutationIDs, cookieJSON, dagWrite, clientID, formatVersion) {
  const basis = await commitFromHash(basisHash, dagWrite);
  const bTreeWrite = new BTreeWrite(dagWrite, formatVersion, basis.valueHash);
  return new Write2(
    dagWrite,
    bTreeWrite,
    basis,
    { basisHash, type: 5 /* SnapshotDD31 */, lastMutationIDs, cookieJSON },
    readIndexesForWrite(basis, dagWrite, formatVersion),
    clientID,
    formatVersion
  );
}
async function updateIndexes(lc, indexes, key, oldValGetter, newVal) {
  const ps = [];
  for (const idx of indexes.values()) {
    const { keyPrefix } = idx.meta.definition;
    if (!keyPrefix || key.startsWith(keyPrefix)) {
      const oldVal = await oldValGetter();
      if (oldVal !== void 0) {
        ps.push(
          indexValue(
            lc,
            idx.map,
            1 /* Remove */,
            key,
            oldVal,
            idx.meta.definition.jsonPointer,
            idx.meta.definition.allowEmpty ?? false
          )
        );
      }
      if (newVal !== void 0) {
        ps.push(
          indexValue(
            lc,
            idx.map,
            0 /* Add */,
            key,
            newVal,
            idx.meta.definition.jsonPointer,
            idx.meta.definition.allowEmpty ?? false
          )
        );
      }
    }
  }
  await Promise.all(ps);
}
function readIndexesForWrite(commit, dagWrite, formatVersion) {
  const m = /* @__PURE__ */ new Map();
  for (const index of commit.indexes) {
    m.set(
      index.definition.name,
      new IndexWrite(
        index,
        new BTreeWrite(dagWrite, formatVersion, index.valueHash)
      )
    );
  }
  return m;
}
async function createIndexBTree(lc, dagWrite, valueMap, prefix, jsonPointer, allowEmpty, formatVersion) {
  const indexMap = new BTreeWrite(dagWrite, formatVersion);
  for await (const entry of valueMap.scan(prefix)) {
    const key = entry[0];
    if (!key.startsWith(prefix)) {
      break;
    }
    await indexValue(
      lc,
      indexMap,
      0 /* Add */,
      key,
      entry[1],
      jsonPointer,
      allowEmpty
    );
  }
  return indexMap;
}

// src/sync/ids.ts
var clientGroupIDSchema = valita_exports.string();
var clientIDSchema = valita_exports.string();

// src/persist/clients.ts
var clientV4Schema = readonlyObject({
  /**
   * A UNIX timestamp in milliseconds updated by the client once a minute
   * while it is active and every time the client persists its state to
   * the perdag.
   * Should only be updated by the client represented by this structure.
   */
  heartbeatTimestampMs: valita_exports.number(),
  /**
   * The hash of the commit in the perdag this client last persisted.
   * Should only be updated by the client represented by this structure.
   */
  headHash: hashSchema,
  /**
   * The mutationID of the commit at headHash (mutationID if it is a
   * local commit, lastMutationID if it is an index change or snapshot commit).
   * Should only be updated by the client represented by this structure.
   * Read by other clients to determine if there are unacknowledged pending
   * mutations for them to push on behalf of the client represented by this
   * structure.
   * This is redundant with information in the commit graph at headHash,
   * but allows other clients to determine if there are unacknowledged pending
   * mutations without having to load the commit graph at headHash.
   */
  mutationID: valita_exports.number(),
  /**
   * The highest lastMutationID received from the server for this client.
   *
   * Should be updated by the client represented by this structure whenever
   * it persists its state to the perdag.
   * Read by other clients to determine if there are unacknowledged pending
   * mutations for them to push on behalf of the client represented by this
   * structure, and *updated* by other clients upon successfully pushing
   * pending mutations to avoid redundant pushes of those mutations.
   *
   * Note: This will be the same as the lastMutationID of the base snapshot of
   * the commit graph at headHash when written by the client represented by this
   * structure.  However, when written by another client pushing pending
   * mutations on this client's behalf it will be different.  This is because
   * the other client does not update the commit graph (it is unsafe to update
   * another client's commit graph).
   */
  lastServerAckdMutationID: valita_exports.number()
});
var clientV5Schema = readonlyObject({
  heartbeatTimestampMs: valita_exports.number(),
  headHash: hashSchema,
  /**
   * The hash of a commit we are in the middle of refreshing into this client's
   * memdag.
   */
  tempRefreshHash: hashSchema.nullable(),
  /**
   * ID of this client's perdag client group. This needs to be sent in pull
   * request (to enable syncing all last mutation ids in the client group).
   */
  clientGroupID: clientGroupIDSchema
});
var clientV6Schema = readonlyObject({
  heartbeatTimestampMs: valita_exports.number(),
  /**
   * A set of hashes, which contains:
   * 1. The hash of the last commit this client refreshed from its client group
   *    (this is the commit it bootstrapped from until it completes its first
   *    refresh).
   * 2. One or more hashes that were added to retain chunks of a commit while it
   *    was being refreshed into this client's memdag. (This can be one or more
   *    because refresh's cleanup step is a separate transaction and can fail).
   * Upon refresh completing and successfully running its clean up step, this
   * set will contain a single hash: the hash of the last commit this client
   * refreshed.
   */
  refreshHashes: readonlyArray(hashSchema),
  /**
   * The hash of the last snapshot commit persisted by this client to this
   * client's client group, or null if has never persisted a snapshot.
   */
  persistHash: hashSchema.nullable(),
  /**
   * ID of this client's perdag client group. This needs to be sent in pull
   * request (to enable syncing all last mutation ids in the client group).
   */
  clientGroupID: clientGroupIDSchema
});
function isClientV6(client) {
  return client.refreshHashes !== void 0;
}
function isClientV5(client) {
  return client.clientGroupID !== void 0;
}
var CLIENTS_HEAD_NAME = "clients";
var clientSchema = valita_exports.union(
  clientV4Schema,
  clientV5Schema,
  clientV6Schema
);
function assertClient(value) {
  assert2(value, clientSchema);
}
function assertClientV4(value) {
  assert2(value, clientV4Schema);
}
function assertClientV6(value) {
  assert2(value, clientV6Schema);
}
function chunkDataToClientMap(chunkData) {
  assertObject2(chunkData);
  const clients = /* @__PURE__ */ new Map();
  for (const key in chunkData) {
    if (hasOwn(chunkData, key)) {
      const value = chunkData[key];
      if (value !== void 0) {
        assertClient(value);
        clients.set(key, value);
      }
    }
  }
  return clients;
}
function clientMapToChunkData(clients, dagWrite) {
  for (const client of clients.values()) {
    if (isClientV6(client)) {
      client.refreshHashes.forEach(dagWrite.assertValidHash);
      if (client.persistHash) {
        dagWrite.assertValidHash(client.persistHash);
      }
    } else {
      dagWrite.assertValidHash(client.headHash);
      if (isClientV5(client) && client.tempRefreshHash) {
        dagWrite.assertValidHash(client.tempRefreshHash);
      }
    }
  }
  return deepFreeze(Object.fromEntries(clients));
}
async function getClients(dagRead) {
  const hash = await dagRead.getHead(CLIENTS_HEAD_NAME);
  return getClientsAtHash(hash, dagRead);
}
async function getClientsAtHash(hash, dagRead) {
  if (!hash) {
    return /* @__PURE__ */ new Map();
  }
  const chunk = await dagRead.getChunk(hash);
  return chunkDataToClientMap(chunk?.data);
}
var ClientStateNotFoundError = class extends Error {
  name = "ClientStateNotFoundError";
  id;
  constructor(id) {
    super(`Client state not found, id: ${id}`);
    this.id = id;
  }
};
async function assertHasClientState(id, dagRead) {
  if (!await hasClientState(id, dagRead)) {
    throw new ClientStateNotFoundError(id);
  }
}
async function hasClientState(id, dagRead) {
  return !!await getClient(id, dagRead);
}
async function getClient(id, dagRead) {
  const clients = await getClients(dagRead);
  return clients.get(id);
}
async function mustGetClient(id, dagRead) {
  const client = await getClient(id, dagRead);
  if (!client) {
    throw new ClientStateNotFoundError(id);
  }
  return client;
}
function initClientV6(newClientID, lc, perdag, mutatorNames, indexes, formatVersion, enableClientGroupForking) {
  return withWriteNoImplicitCommit(perdag, async (dagWrite) => {
    async function setClientsAndClientGroupAndCommit(basisHash, cookieJSON, valueHash2, indexRecords2) {
      const newSnapshotData = newSnapshotCommitDataDD31(
        basisHash,
        {},
        cookieJSON,
        valueHash2,
        indexRecords2
      );
      const chunk = dagWrite.createChunk(
        newSnapshotData,
        getRefs(newSnapshotData)
      );
      const newClientGroupID = uuid();
      const newClient = {
        heartbeatTimestampMs: Date.now(),
        refreshHashes: [chunk.hash],
        persistHash: null,
        clientGroupID: newClientGroupID
      };
      const newClients = new Map(clients).set(newClientID, newClient);
      const clientGroup = {
        headHash: chunk.hash,
        mutatorNames,
        indexes,
        mutationIDs: {},
        lastServerAckdMutationIDs: {},
        disabled: false
      };
      await Promise.all([
        dagWrite.putChunk(chunk),
        setClients(newClients, dagWrite),
        setClientGroup(newClientGroupID, clientGroup, dagWrite)
      ]);
      await dagWrite.commit();
      return [newClient, chunk.hash, newClients, true];
    }
    const clients = await getClients(dagWrite);
    const res = await findMatchingClient(dagWrite, mutatorNames, indexes);
    if (res.type === FIND_MATCHING_CLIENT_TYPE_HEAD) {
      const { clientGroupID, headHash } = res;
      const newClient = {
        clientGroupID,
        refreshHashes: [headHash],
        heartbeatTimestampMs: Date.now(),
        persistHash: null
      };
      const newClients = new Map(clients).set(newClientID, newClient);
      await setClients(newClients, dagWrite);
      await dagWrite.commit();
      return [newClient, headHash, newClients, false];
    }
    if (!enableClientGroupForking || res.type === FIND_MATCHING_CLIENT_TYPE_NEW) {
      const emptyBTreeChunk = dagWrite.createChunk(emptyDataNode, []);
      await dagWrite.putChunk(emptyBTreeChunk);
      const indexRecords2 = [];
      for (const [name, indexDefinition] of Object.entries(indexes)) {
        const chunkIndexDefinition = toChunkIndexDefinition(
          name,
          indexDefinition
        );
        indexRecords2.push({
          definition: chunkIndexDefinition,
          valueHash: emptyBTreeChunk.hash
        });
      }
      return setClientsAndClientGroupAndCommit(
        null,
        null,
        emptyBTreeChunk.hash,
        indexRecords2
      );
    }
    assert(res.type === FIND_MATCHING_CLIENT_TYPE_FORK);
    const { snapshot } = res;
    const indexRecords = [];
    const { valueHash, indexes: oldIndexes } = snapshot;
    const map = new BTreeRead(dagWrite, formatVersion, valueHash);
    for (const [name, indexDefinition] of Object.entries(indexes)) {
      const { prefix = "", jsonPointer, allowEmpty = false } = indexDefinition;
      const chunkIndexDefinition = {
        name,
        keyPrefix: prefix,
        jsonPointer,
        allowEmpty
      };
      const oldIndex = findMatchingOldIndex(oldIndexes, chunkIndexDefinition);
      if (oldIndex) {
        indexRecords.push({
          definition: chunkIndexDefinition,
          valueHash: oldIndex.valueHash
        });
      } else {
        const indexBTree = await createIndexBTree(
          lc,
          dagWrite,
          map,
          prefix,
          jsonPointer,
          allowEmpty,
          formatVersion
        );
        indexRecords.push({
          definition: chunkIndexDefinition,
          valueHash: await indexBTree.flush()
        });
      }
    }
    return setClientsAndClientGroupAndCommit(
      snapshot.meta.basisHash,
      snapshot.meta.cookieJSON,
      snapshot.valueHash,
      indexRecords
    );
  });
}
function findMatchingOldIndex(oldIndexes, chunkIndexDefinition) {
  return oldIndexes.find(
    (index) => chunkIndexDefinitionEqualIgnoreName(index.definition, chunkIndexDefinition)
  );
}
var FIND_MATCHING_CLIENT_TYPE_NEW = 0;
var FIND_MATCHING_CLIENT_TYPE_FORK = 1;
var FIND_MATCHING_CLIENT_TYPE_HEAD = 2;
async function findMatchingClient(dagRead, mutatorNames, indexes) {
  let newestCookie;
  let bestSnapshot;
  const mutatorNamesSet = new Set(mutatorNames);
  const clientGroups = await getClientGroups(dagRead);
  for (const [clientGroupID, clientGroup] of clientGroups) {
    if (!clientGroup.disabled && mutatorNamesEqual(mutatorNamesSet, clientGroup.mutatorNames) && indexDefinitionsEqual(indexes, clientGroup.indexes)) {
      return {
        type: FIND_MATCHING_CLIENT_TYPE_HEAD,
        clientGroupID,
        headHash: clientGroup.headHash
      };
    }
    const clientGroupSnapshotCommit = await baseSnapshotFromHash(
      clientGroup.headHash,
      dagRead
    );
    assertSnapshotCommitDD31(clientGroupSnapshotCommit);
    const { cookieJSON } = clientGroupSnapshotCommit.meta;
    if (newestCookie === void 0 || compareCookies(cookieJSON, newestCookie) > 0) {
      newestCookie = cookieJSON;
      bestSnapshot = clientGroupSnapshotCommit;
    }
  }
  if (bestSnapshot) {
    return {
      type: FIND_MATCHING_CLIENT_TYPE_FORK,
      snapshot: bestSnapshot
    };
  }
  return { type: FIND_MATCHING_CLIENT_TYPE_NEW };
}
function getRefsForClients(clients) {
  const refs = [];
  for (const client of clients.values()) {
    if (isClientV6(client)) {
      refs.push(...client.refreshHashes);
      if (client.persistHash) {
        refs.push(client.persistHash);
      }
    } else {
      refs.push(client.headHash);
      if (isClientV5(client) && client.tempRefreshHash) {
        refs.push(client.tempRefreshHash);
      }
    }
  }
  return refs;
}
async function getClientGroupForClient(clientID, read) {
  const clientGroupID = await getClientGroupIDForClient(clientID, read);
  if (!clientGroupID) {
    return void 0;
  }
  return getClientGroup(clientGroupID, read);
}
async function getClientGroupIDForClient(clientID, read) {
  const client = await getClient(clientID, read);
  if (!client || !isClientV5(client)) {
    return void 0;
  }
  return client.clientGroupID;
}
async function setClient(clientID, client, dagWrite) {
  const clients = await getClients(dagWrite);
  const newClients = new Map(clients).set(clientID, client);
  return setClients(newClients, dagWrite);
}
async function setClients(clients, dagWrite) {
  const chunkData = clientMapToChunkData(clients, dagWrite);
  const chunk = dagWrite.createChunk(chunkData, getRefsForClients(clients));
  await dagWrite.putChunk(chunk);
  await dagWrite.setHead(CLIENTS_HEAD_NAME, chunk.hash);
  return chunk.hash;
}

// ../shared/src/navigator.ts
var localNavigator = typeof navigator !== "undefined" ? navigator : void 0;

// src/kv/mem-store.ts
import { RWLock } from "@rocicorp/lock";

// src/kv/read-impl.ts
var ReadImpl3 = class {
  #map;
  #release;
  #closed = false;
  constructor(map, release) {
    this.#map = map;
    this.#release = release;
  }
  release() {
    this.#release();
    this.#closed = true;
  }
  get closed() {
    return this.#closed;
  }
  has(key) {
    return Promise.resolve(this.#map.has(key));
  }
  get(key) {
    return Promise.resolve(this.#map.get(key));
  }
};

// src/kv/write-impl.ts
var WriteImpl3 = class extends WriteImplBase {
  #map;
  constructor(map, release) {
    super(new ReadImpl3(map, release));
    this.#map = map;
  }
  commit() {
    this._pending.forEach((value, key) => {
      if (value === deleteSentinel) {
        this.#map.delete(key);
      } else {
        this.#map.set(key, value);
      }
    });
    this._pending.clear();
    this.release();
    return promiseVoid;
  }
};

// src/kv/mem-store.ts
var stores = /* @__PURE__ */ new Map();
function dropMemStore(name) {
  stores.delete(name);
  return promiseVoid;
}
var MemStore = class {
  #map;
  #rwLock;
  #closed = false;
  constructor(name) {
    const entry = stores.get(name);
    let lock;
    let map;
    if (entry) {
      ({ lock, map } = entry);
    } else {
      lock = new RWLock();
      map = /* @__PURE__ */ new Map();
      stores.set(name, { lock, map });
    }
    this.#rwLock = lock;
    this.#map = map;
  }
  async read() {
    const release = await this.#rwLock.read();
    return new ReadImpl3(this.#map, release);
  }
  async write() {
    const release = await this.#rwLock.write();
    return new WriteImpl3(this.#map, release);
  }
  close() {
    this.#closed = true;
    return promiseVoid;
  }
  get closed() {
    return this.#closed;
  }
};

// src/kv/idb-store-with-mem-fallback.ts
var IDBStoreWithMemFallback = class {
  #lc;
  #name;
  #store;
  constructor(lc, name) {
    this.#lc = lc;
    this.#name = name;
    this.#store = new IDBStore(name);
  }
  read() {
    return this.#withBrainTransplant((s) => s.read());
  }
  write() {
    return this.#withBrainTransplant((s) => s.write());
  }
  async #withBrainTransplant(f) {
    try {
      return await f(this.#store);
    } catch (e) {
      if (isFirefoxPrivateBrowsingError(e)) {
        if (this.#store instanceof IDBStore) {
          this.#lc.info?.(
            "Switching to MemStore because of Firefox private browsing error"
          );
          this.#store = new MemStore(this.#name);
        }
        return f(this.#store);
      }
      throw e;
    }
  }
  close() {
    return this.#store.close();
  }
  get closed() {
    return this.#store.closed;
  }
};
function isFirefoxPrivateBrowsingError(e) {
  return isFirefox() && e instanceof DOMException && e.name === "InvalidStateError" && e.message === "A mutation operation was attempted on a database that did not allow mutations.";
}
function isFirefox() {
  return localNavigator?.userAgent.includes("Firefox") ?? false;
}
function newIDBStoreWithMemFallback(lc, name) {
  if (isFirefox()) {
    return new IDBStoreWithMemFallback(lc, name);
  }
  return new IDBStore(name);
}
function dropIDBStoreWithMemFallback(name) {
  if (!isFirefox()) {
    return dropIDBStore(name);
  }
  try {
    return dropIDBStore(name);
  } catch (e) {
    if (isFirefoxPrivateBrowsingError(e)) {
      return dropMemStore(name);
    }
  }
  return promiseVoid;
}
function dropIDBStore(name) {
  return new Promise((resolve, reject) => {
    const req = indexedDB.deleteDatabase(name);
    req.onsuccess = () => resolve();
    req.onerror = () => reject(req.error);
  });
}

// src/persist/idb-databases-store-db-name.ts
var IDB_DATABASES_VERSION = 0;
var IDB_DATABASES_DB_NAME = "replicache-dbs-v" + IDB_DATABASES_VERSION;
var testNamespace = "";
function getIDBDatabasesDBName() {
  return testNamespace + IDB_DATABASES_DB_NAME;
}

// src/persist/idb-databases-store.ts
var DBS_KEY = "dbs";
var PROFILE_ID_KEY = "profileId";
function assertIndexedDBDatabaseRecord(value) {
  assertObject2(value);
  for (const [name, db] of Object.entries(value)) {
    assertString2(name);
    assertIndexedDBDatabase(db);
    assert(name === db.name);
  }
}
function assertIndexedDBDatabase(value) {
  assertObject2(value);
  assertString2(value.name);
  assertString2(value.replicacheName);
  assertNumber(value.replicacheFormatVersion);
  assertString2(value.schemaVersion);
  if (value.lastOpenedTimestampMS !== void 0) {
    assertNumber(value.lastOpenedTimestampMS);
  }
}
var IDBDatabasesStore = class {
  #kvStore;
  constructor(createKVStore) {
    this.#kvStore = createKVStore(getIDBDatabasesDBName());
  }
  putDatabase(db) {
    return this.#putDatabase({ ...db, lastOpenedTimestampMS: Date.now() });
  }
  putDatabaseForTesting(db) {
    return this.#putDatabase(db);
  }
  #putDatabase(db) {
    return withWrite(this.#kvStore, async (write) => {
      const oldDbRecord = await getDatabases(write);
      const dbRecord = {
        ...oldDbRecord,
        [db.name]: db
      };
      await write.put(DBS_KEY, dbRecord);
      return dbRecord;
    });
  }
  clearDatabases() {
    return withWrite(this.#kvStore, (write) => write.del(DBS_KEY));
  }
  deleteDatabases(names) {
    return withWrite(this.#kvStore, async (write) => {
      const oldDbRecord = await getDatabases(write);
      const dbRecord = {
        ...oldDbRecord
      };
      for (const name of names) {
        delete dbRecord[name];
      }
      await write.put(DBS_KEY, dbRecord);
    });
  }
  getDatabases() {
    return withRead(this.#kvStore, getDatabases);
  }
  close() {
    return this.#kvStore.close();
  }
  getProfileID() {
    return withWrite(this.#kvStore, async (write) => {
      let profileId = await write.get(PROFILE_ID_KEY);
      if (profileId === void 0) {
        profileId = `p${uuid().replace(/-/g, "")}`;
        await write.put(PROFILE_ID_KEY, profileId);
      }
      assertString2(profileId);
      return profileId;
    });
  }
};
async function getDatabases(read) {
  let dbRecord = await read.get(DBS_KEY);
  if (!dbRecord) {
    dbRecord = deepFreeze({});
  }
  assertIndexedDBDatabaseRecord(dbRecord);
  return dbRecord;
}

// src/replicache-impl.ts
import { consoleLogSink as consoleLogSink2 } from "@rocicorp/logger";
import { resolver as resolver6 } from "@rocicorp/resolver";

// ../shared/src/document-visible.ts
import { resolver as resolver3 } from "@rocicorp/resolver";
function getDocumentVisibilityWatcher(doc, hiddenIntervalMS, signal) {
  return doc ? new DocumentVisibilityWatcherImpl(doc, hiddenIntervalMS, signal) : new DocumentVisibilityWatcherNoDoc();
}
var DocumentVisibilityWatcherImpl = class {
  #doc;
  #hiddenIntervalMS;
  #timeoutID = 0;
  // This trails doc.visibilityState by hiddenIntervalMS when being hidden. This
  // is because we want to wait for the tab to be hidden for a while before
  // considering as hidden.
  visibilityState;
  #promises = /* @__PURE__ */ new Set();
  constructor(doc, hiddenIntervalMS, signal) {
    this.#doc = doc;
    this.#hiddenIntervalMS = hiddenIntervalMS;
    this.visibilityState = doc.visibilityState;
    this.#doc.addEventListener("visibilitychange", this.#onVisibilityChange, {
      signal
    });
  }
  #onVisibilityChange = () => {
    if (this.#doc.visibilityState === "visible") {
      clearTimeout(this.#timeoutID);
      this.#setVisibilityState("visible");
    } else {
      this.#timeoutID = setTimeout(() => {
        this.#setVisibilityState("hidden");
      }, this.#hiddenIntervalMS);
    }
  };
  #setVisibilityState(visibilityState) {
    if (visibilityState === this.visibilityState) {
      return;
    }
    this.visibilityState = visibilityState;
    for (const entry of this.#promises) {
      const { resolve, state } = entry;
      if (state === visibilityState) {
        resolve();
        this.#promises.delete(entry);
      }
    }
  }
  waitForVisible() {
    return this.#waitFor("visible");
  }
  waitForHidden() {
    return this.#waitFor("hidden");
  }
  #waitFor(state) {
    if (this.visibilityState === state) {
      return Promise.resolve();
    }
    const { promise, resolve } = resolver3();
    this.#promises.add({ resolve, state });
    return promise;
  }
};
var resolvedPromise = Promise.resolve();
var promiseThatNeverResolves = new Promise(() => void 0);
var DocumentVisibilityWatcherNoDoc = class {
  visibilityState = "visible";
  waitForVisible() {
    return resolvedPromise;
  }
  waitForHidden() {
    return promiseThatNeverResolves;
  }
};

// ../shared/src/get-document.ts
function getDocument() {
  return typeof document !== "undefined" ? document : void 0;
}

// src/connection-loop-delegates.ts
var ConnectionLoopDelegateImpl = class {
  rep;
  invokeSend;
  // TODO: Remove the ability to have more than one concurrent connection and update tests.
  // Bug: https://github.com/rocicorp/replicache-internal/issues/303
  maxConnections = 1;
  constructor(rep, invokeSend) {
    this.rep = rep;
    this.invokeSend = invokeSend;
  }
  get maxDelayMs() {
    return this.rep.requestOptions.maxDelayMs;
  }
  get minDelayMs() {
    return this.rep.requestOptions.minDelayMs;
  }
};
var PullDelegate = class extends ConnectionLoopDelegateImpl {
  debounceDelay = 0;
  get watchdogTimer() {
    return this.rep.pullInterval;
  }
};
var PushDelegate = class extends ConnectionLoopDelegateImpl {
  get debounceDelay() {
    return this.rep.pushDelay;
  }
  watchdogTimer = null;
};

// src/connection-loop.ts
import { resolver as resolver4 } from "@rocicorp/resolver";
var MIN_DELAY_MS = 30;
var MAX_DELAY_MS = 6e4;
var ConnectionLoop = class {
  // ConnectionLoop runs a loop sending network requests (either pushes or
  // pulls) to the server. Our goal, generally, is to send requests as fast as
  // we can, but to adjust in case of slowness, network errors, etc. We will
  // send requests in parallel if the server supports it. We also debounce
  // pushes since they frequently happen in series very near to one another
  // (e.g., during drag'n drops).
  //
  // The loop flows through the following states forever, until it is closed:
  //
  // Pending: Wait for event or watchdog
  //          |
  //          v
  // Debounce: Wait for more events (we debounce pushes)
  //          |
  //          v
  // Wait for available connection (we limit number of parallel requests
  // allowed)
  //          |
  //          v
  // Wait to send (if requests are taking too long, we will slow down)
  //          |
  //          v
  // Send (asynchronously, wrt the loop)
  //          |
  //          v
  // Back to the pending!
  // Controls whether the next iteration of the loop will wait at the pending
  // state.
  #pendingResolver = resolver4();
  /**
   * This resolver is used to allow us to skip sleeps when we do send(true)
   */
  #skipSleepsResolver = resolver4();
  /**
   * Resolver for the next send. Never rejects. Returns an error instead since
   * this resolver is used in cases where they might not be someone waiting,
   * and we don't want an unhandled promise rejection in that case.
   */
  #sendResolver = resolver4();
  #delegate;
  #closed = false;
  /**
   * Number of pending send calls.
   *
   * We keep track of this because if close happens while we are waiting for the
   * send to resolve we should reject the send promise.
   */
  #sendCounter = 0;
  #lc;
  #visibilityWatcher;
  constructor(lc, delegate, visibilityWatcher) {
    this.#lc = lc;
    this.#delegate = delegate;
    this.#visibilityWatcher = visibilityWatcher;
    void this.run();
  }
  close() {
    this.#closed = true;
    if (this.#sendCounter > 0) {
      this.#sendResolver.resolve({ error: closeError() });
    }
  }
  /**
   *
   * @returns Returns undefined if ok, otherwise it return the error that caused
   * the send to fail.
   */
  async send(now) {
    if (this.#closed) {
      return { error: closeError() };
    }
    this.#sendCounter++;
    this.#lc.debug?.("send", now);
    if (now) {
      this.#skipSleepsResolver.resolve();
    } else {
      await this.#visibilityWatcher?.waitForVisible();
    }
    this.#pendingResolver.resolve();
    const result = await this.#sendResolver.promise;
    this.#sendCounter--;
    return result;
  }
  async run() {
    const sendRecords = [];
    let recoverResolver = resolver4();
    let lastSendTime;
    let counter = 0;
    const delegate = this.#delegate;
    const { debug } = this.#lc;
    let delay = 0;
    debug?.("Starting connection loop");
    const sleepMaybeSkip = (ms) => Promise.race([this.#skipSleepsResolver.promise, sleep(ms)]);
    while (!this.#closed) {
      debug?.(
        didLastSendRequestFail(sendRecords) ? "Last request failed. Trying again" : "Waiting for a send"
      );
      const races = [this.#pendingResolver.promise];
      const t = delegate.watchdogTimer;
      if (t !== null) {
        races.push(sleep(t));
      }
      await Promise.race(races);
      if (this.#closed)
        break;
      debug?.("Waiting for debounce");
      await sleepMaybeSkip(delegate.debounceDelay);
      if (this.#closed)
        break;
      debug?.("debounced");
      this.#pendingResolver = resolver4();
      if (counter >= delegate.maxConnections) {
        debug?.("Too many request in flight. Waiting until one finishes...");
        await this.#waitUntilAvailableConnection();
        if (this.#closed)
          break;
        debug?.("...finished");
      }
      if (counter > 0 || didLastSendRequestFail(sendRecords)) {
        delay = computeDelayAndUpdateDurations(delay, delegate, sendRecords);
        debug?.(
          didLastSendRequestFail(sendRecords) ? "Last connection errored. Sleeping for" : "More than one outstanding connection (" + counter + "). Sleeping for",
          delay,
          "ms"
        );
      } else {
        delay = 0;
      }
      const clampedDelay = Math.min(
        delegate.maxDelayMs,
        Math.max(delegate.minDelayMs, delay)
      );
      if (lastSendTime !== void 0) {
        const timeSinceLastSend = Date.now() - lastSendTime;
        if (clampedDelay > timeSinceLastSend) {
          await Promise.race([
            sleepMaybeSkip(clampedDelay - timeSinceLastSend),
            recoverResolver.promise
          ]);
          if (this.#closed)
            break;
        }
      }
      counter++;
      (async () => {
        const start = Date.now();
        let ok2;
        let error;
        try {
          lastSendTime = start;
          debug?.("Sending request");
          this.#skipSleepsResolver = resolver4();
          ok2 = await delegate.invokeSend();
          debug?.("Send returned", ok2);
        } catch (e) {
          debug?.("Send failed", e);
          error = e;
          ok2 = false;
        }
        if (this.#closed) {
          debug?.("Closed after invokeSend");
          return;
        }
        debug?.("Request done", { duration: Date.now() - start, ok: ok2 });
        sendRecords.push({ duration: Date.now() - start, ok: ok2 });
        if (recovered(sendRecords)) {
          recoverResolver.resolve();
          recoverResolver = resolver4();
        }
        counter--;
        this.#connectionAvailable();
        const sendResolver = this.#sendResolver;
        this.#sendResolver = resolver4();
        if (error) {
          sendResolver.resolve({ error });
        } else {
          sendResolver.resolve(void 0);
        }
        if (!ok2) {
          this.#pendingResolver.resolve();
        }
      })();
    }
  }
  #waitingConnectionResolve = void 0;
  #connectionAvailable() {
    if (this.#waitingConnectionResolve) {
      const resolve = this.#waitingConnectionResolve;
      this.#waitingConnectionResolve = void 0;
      resolve();
    }
  }
  #waitUntilAvailableConnection() {
    const { promise, resolve } = resolver4();
    this.#waitingConnectionResolve = resolve;
    return promise;
  }
};
var CONNECTION_MEMORY_COUNT = 9;
function closeError() {
  return new Error("Closed");
}
function computeDelayAndUpdateDurations(delay, delegate, sendRecords) {
  const { length } = sendRecords;
  if (length === 0) {
    return delay;
  }
  const { ok: ok2 } = sendRecords[sendRecords.length - 1];
  const { maxConnections, minDelayMs } = delegate;
  if (!ok2) {
    return delay === 0 ? minDelayMs : delay * 2;
  }
  if (length > 1) {
    const previous = sendRecords[sendRecords.length - 2];
    while (sendRecords.length > CONNECTION_MEMORY_COUNT) {
      sendRecords.shift();
    }
    if (ok2 && !previous.ok) {
      return minDelayMs;
    }
  }
  const med = median(
    sendRecords.filter(({ ok: ok3 }) => ok3).map(({ duration }) => duration)
  );
  return med / maxConnections | 0;
}
function median(values) {
  values.sort();
  const { length } = values;
  const half = length >> 1;
  if (length % 2 === 1) {
    return values[half];
  }
  return (values[half - 1] + values[half]) / 2;
}
function didLastSendRequestFail(sendRecords) {
  return sendRecords.length > 0 && !sendRecords[sendRecords.length - 1].ok;
}
function recovered(sendRecords) {
  return sendRecords.length > 1 && !sendRecords[sendRecords.length - 2].ok && sendRecords[sendRecords.length - 1].ok;
}

// src/dag/lazy-store.ts
import { RWLock as RWLock2 } from "@rocicorp/lock";
var LazyStore = class {
  /**
   * This lock is used to ensure correct isolation of Reads and Writes.
   * Multiple Reads are allowed in parallel but only a single Write.  Reads and
   * Writes see an isolated view of the store (corresponding to the Serializable
   * level of transaction isolation defined in the SQL standard).
   *
   * To ensure these semantics the read lock must be acquired when a Read is
   * created and held til it is closed, and a Write lock must be acquired when a
   * Write is created and held til it is committed or closed.
   *
   * Code must have a read or write lock to
   * - read `_heads`
   * - read `_memOnlyChunks`
   * - read `_sourceStore`
   * - read and write `_sourceChunksCache`
   * - read and write `_refCounts`
   * - read and write `_refs`
   * and must have a write lock to
   * - write `_heads`
   * - write `_memOnlyChunks`
   */
  #rwLock = new RWLock2();
  #heads = /* @__PURE__ */ new Map();
  #sourceStore;
  #chunkHasher;
  #assertValidHash;
  /** The following are protected so testing subclass can access. */
  _memOnlyChunks = /* @__PURE__ */ new Map();
  _sourceChunksCache;
  /**
   * Ref counts are maintained so that chunks which are unreachable
   * from this stores heads can be eagerly and deterministically deleted from
   * `this._memOnlyChunks` and `this._sourceChunksCache`.
   *
   * These ref counts are independent from `this._sourceStore`'s ref counts.
   * These ref counts are based on reachability from `this._heads`.
   * A chunk is deleted from `this._memOnlyChunks` or
   * `this._sourceChunksCache` (which ever it is in) when its ref count becomes
   * zero.
   * These ref counts count the refs in `this._heads` and `this._refs`.
   *
   * Not all reachable chunk's refs are included in `this._refs`, because this
   * would require loading all chunks reachable in the source store in a
   * non-lazy manner. `this._refs` contains the refs of all currently reachable
   * chunks that were ever in `this._memOnlyChunks` or
   * `this._sourceChunksCache` (even if they have been evicted).  A
   * chunk's ref information is lazily discovered and stored in `this._refs` and
   * counted in `this._refCounts`. A chunk's entries in `this._refs` and
   * `this._refCounts` are only deleted when a chunk is deleted due to it
   * becoming unreachable (it is not deleted if the chunk is evicted from the
   * source-store cache).
   *
   * The major implication of this lazy discovery of source store refs, is that
   * a reachable source store chunk may not be cached when loaded, because it is
   * not known to be reachable because some of the pertinent refs have not been
   * discovered.  However, in practice chunks are read by traversing the graph
   * starting from a head, and all pertinent refs are discovered as part of the
   * traversal.
   *
   * These ref counts can be changed in two ways:
   * 1. A LazyRead has a cache miss and loads a chunk from the source store that
   * is reachable from this._heads.  If this chunk's refs are not currently
   * counted, it will not have an entry in `this._refs`.  In this case, the
   * chunks refs will be put in `this._refs` and `this._refCounts` will be
   * updated to count them.
   * 2. A LazyWrite commit updates a head (which can result in increasing or
   * decreasing ref count) or puts a reachable chunk (either a `memory-only` or
   * `source` chunk) that references this hash (increasing ref count).  The
   * computation of these ref count changes is delegated to the
   * `computeRefCountUpdates` shared with dag.StoreImpl.  In order to
   * delegate determining reachability to `computeRefCountUpdates` and defer
   * this determination until commit time, LazyWrite treats cache misses
   * as a 'put' of the lazily-loaded chunk.
   *
   * A chunk's hash may have an entry in `this._refCounts` without that
   * chunk have ever been in `this._memOnlyChunks` or `this._sourceChunksCache`.
   * This is the case when a head or a reachable chunk that was ever in
   * `this._memOnlyChunks` or `this._sourceChunksCache` references a chunk
   * which is not currently cached (either because it has not been read, or
   * because it has been evicted).
   */
  _refCounts = /* @__PURE__ */ new Map();
  _refs = /* @__PURE__ */ new Map();
  constructor(sourceStore, sourceCacheSizeLimit, chunkHasher, assertValidHash, getSizeOfChunk = getSizeOfValue) {
    this._sourceChunksCache = new ChunksCache(
      sourceCacheSizeLimit,
      getSizeOfChunk,
      this._refCounts,
      this._refs
    );
    this.#sourceStore = sourceStore;
    this.#chunkHasher = chunkHasher;
    this.#assertValidHash = assertValidHash;
  }
  async read() {
    const release = await this.#rwLock.read();
    return new LazyRead(
      this.#heads,
      this._memOnlyChunks,
      this._sourceChunksCache,
      this.#sourceStore,
      release,
      this.#assertValidHash
    );
  }
  async write() {
    const release = await this.#rwLock.write();
    return new LazyWrite(
      this.#heads,
      this._memOnlyChunks,
      this._sourceChunksCache,
      this.#sourceStore,
      this._refCounts,
      this._refs,
      release,
      this.#chunkHasher,
      this.#assertValidHash
    );
  }
  close() {
    return promiseVoid;
  }
  /**
   * Does not acquire any lock on the store.
   */
  isCached(chunkHash) {
    return this._sourceChunksCache.getWithoutUpdatingLRU(chunkHash) !== void 0;
  }
  withSuspendedSourceCacheEvictsAndDeletes(fn) {
    return this._sourceChunksCache.withSuspendedEvictsAndDeletes(fn);
  }
};
var LazyRead = class {
  _heads;
  _memOnlyChunks;
  _sourceChunksCache;
  _sourceStore;
  #sourceRead = void 0;
  #release;
  #closed = false;
  assertValidHash;
  constructor(heads, memOnlyChunks, sourceChunksCache, sourceStore, release, assertValidHash) {
    this._heads = heads;
    this._memOnlyChunks = memOnlyChunks;
    this._sourceChunksCache = sourceChunksCache;
    this._sourceStore = sourceStore;
    this.#release = release;
    this.assertValidHash = assertValidHash;
  }
  isMemOnlyChunkHash(hash) {
    return this._memOnlyChunks.has(hash);
  }
  async hasChunk(hash) {
    return await this.getChunk(hash) !== void 0;
  }
  async getChunk(hash) {
    const memOnlyChunk = this._memOnlyChunks.get(hash);
    if (memOnlyChunk !== void 0) {
      return memOnlyChunk;
    }
    let chunk = this._sourceChunksCache.get(hash);
    if (chunk === void 0) {
      chunk = await (await this._getSourceRead()).getChunk(hash);
      if (chunk !== void 0) {
        this._sourceChunksCache.put(chunk);
      }
    }
    return chunk;
  }
  mustGetChunk(hash) {
    return mustGetChunk(this, hash);
  }
  getHead(name) {
    return Promise.resolve(this._heads.get(name));
  }
  release() {
    if (!this.#closed) {
      this.#release();
      this.#sourceRead?.then((read) => read.release()).catch((_) => {
      });
      this.#closed = true;
    }
  }
  get closed() {
    return this.#closed;
  }
  _getSourceRead() {
    if (!this.#sourceRead) {
      this.#sourceRead = this._sourceStore.read();
    }
    return this.#sourceRead;
  }
};
var LazyWrite = class extends LazyRead {
  #refCounts;
  #refs;
  #chunkHasher;
  _pendingHeadChanges = /* @__PURE__ */ new Map();
  _pendingMemOnlyChunks = /* @__PURE__ */ new Map();
  _pendingCachedChunks = /* @__PURE__ */ new Map();
  #createdChunks = /* @__PURE__ */ new Set();
  constructor(heads, memOnlyChunks, sourceChunksCache, sourceStore, refCounts, refs, release, chunkHasher, assertValidHash) {
    super(
      heads,
      memOnlyChunks,
      sourceChunksCache,
      sourceStore,
      release,
      assertValidHash
    );
    this.#refCounts = refCounts;
    this.#refs = refs;
    this.#chunkHasher = chunkHasher;
  }
  createChunk = (data, refs) => {
    const chunk = createChunk(data, refs, this.#chunkHasher);
    this.#createdChunks.add(chunk.hash);
    return chunk;
  };
  putChunk(c, size) {
    const { hash, meta } = c;
    this.assertValidHash(hash);
    if (meta.length > 0) {
      for (const h of meta) {
        this.assertValidHash(h);
      }
    }
    if (this.#createdChunks.has(hash) || this.isMemOnlyChunkHash(hash)) {
      this._pendingMemOnlyChunks.set(hash, c);
    } else {
      this._pendingCachedChunks.set(hash, { chunk: c, size: size ?? -1 });
    }
    return promiseVoid;
  }
  async setHead(name, hash) {
    await this.#setHead(name, hash);
  }
  async removeHead(name) {
    await this.#setHead(name, void 0);
  }
  async #setHead(name, hash) {
    const oldHash = await this.getHead(name);
    const v2 = this._pendingHeadChanges.get(name);
    if (v2 === void 0) {
      this._pendingHeadChanges.set(name, { new: hash, old: oldHash });
    } else {
      v2.new = hash;
    }
  }
  isMemOnlyChunkHash(hash) {
    return this._pendingMemOnlyChunks.has(hash) || super.isMemOnlyChunkHash(hash);
  }
  async getChunk(hash) {
    const pendingMemOnlyChunk = this._pendingMemOnlyChunks.get(hash);
    if (pendingMemOnlyChunk !== void 0) {
      return pendingMemOnlyChunk;
    }
    const memOnlyChunk = this._memOnlyChunks.get(hash);
    if (memOnlyChunk !== void 0) {
      return memOnlyChunk;
    }
    const pendingCachedChunk = this._pendingCachedChunks.get(hash);
    if (pendingCachedChunk !== void 0) {
      return pendingCachedChunk.chunk;
    }
    let chunk = this._sourceChunksCache.get(hash);
    if (chunk === void 0) {
      chunk = await (await this._getSourceRead()).getChunk(hash);
      if (chunk !== void 0) {
        this._pendingCachedChunks.set(chunk.hash, { chunk, size: -1 });
      }
    }
    return chunk;
  }
  getHead(name) {
    const headChange = this._pendingHeadChanges.get(name);
    if (headChange) {
      return Promise.resolve(headChange.new);
    }
    return super.getHead(name);
  }
  async commit() {
    const pendingChunks = new Set(
      joinIterables(
        this._pendingMemOnlyChunks.keys(),
        this._pendingCachedChunks.keys()
      )
    );
    const refCountUpdates = await computeRefCountUpdates(
      this._pendingHeadChanges.values(),
      pendingChunks,
      this
    );
    for (const [hash, count] of refCountUpdates) {
      if (this.isMemOnlyChunkHash(hash)) {
        if (count === 0) {
          this.#refCounts.delete(hash);
          this._memOnlyChunks.delete(hash);
          this.#refs.delete(hash);
        } else {
          this.#refCounts.set(hash, count);
          const chunk = this._pendingMemOnlyChunks.get(hash);
          if (chunk) {
            this.#refs.set(hash, chunk.meta);
            this._memOnlyChunks.set(hash, chunk);
          }
        }
        refCountUpdates.delete(hash);
      }
    }
    this._sourceChunksCache.updateForCommit(
      this._pendingCachedChunks,
      refCountUpdates
    );
    for (const [name, headChange] of this._pendingHeadChanges) {
      if (headChange.new) {
        this._heads.set(name, headChange.new);
      } else {
        this._heads.delete(name);
      }
    }
    this._pendingMemOnlyChunks.clear();
    this._pendingCachedChunks.clear();
    this._pendingHeadChanges.clear();
    this.release();
  }
  getRefCount(hash) {
    return this.#refCounts.get(hash);
  }
  getRefs(hash) {
    const pendingMemOnlyChunk = this._pendingMemOnlyChunks.get(hash);
    if (pendingMemOnlyChunk) {
      return pendingMemOnlyChunk.meta;
    }
    const memOnlyChunk = this._memOnlyChunks.get(hash);
    if (memOnlyChunk) {
      return memOnlyChunk.meta;
    }
    const pendingCachedChunk = this._pendingCachedChunks.get(hash);
    if (pendingCachedChunk !== void 0) {
      return pendingCachedChunk.chunk.meta;
    }
    return this.#refs.get(hash);
  }
  areRefsCounted(hash) {
    return this.#refs.has(hash);
  }
  chunksPersisted(chunkHashes) {
    const chunksToCache = [];
    for (const chunkHash of chunkHashes) {
      const chunk = this._memOnlyChunks.get(chunkHash);
      if (chunk) {
        this._memOnlyChunks.delete(chunkHash);
        chunksToCache.push(chunk);
      }
    }
    this._sourceChunksCache.persisted(chunksToCache);
  }
};
var ChunksCache = class {
  #cacheSizeLimit;
  #getSizeOfChunk;
  #refCounts;
  #refs;
  #size = 0;
  #evictsAndDeletesSuspended = false;
  #suspendedDeletes = [];
  /**
   * Iteration order is from least to most recently used.
   *
   * Public so that testing subclass can access.
   */
  cacheEntries = /* @__PURE__ */ new Map();
  constructor(cacheSizeLimit, getSizeOfChunk, refCounts, refs) {
    this.#cacheSizeLimit = cacheSizeLimit;
    this.#getSizeOfChunk = getSizeOfChunk;
    this.#refCounts = refCounts;
    this.#refs = refs;
  }
  get(hash) {
    const cacheEntry = this.cacheEntries.get(hash);
    if (cacheEntry) {
      this.cacheEntries.delete(hash);
      this.cacheEntries.set(hash, cacheEntry);
    }
    return cacheEntry?.chunk;
  }
  getWithoutUpdatingLRU(hash) {
    return this.cacheEntries.get(hash)?.chunk;
  }
  put(chunk) {
    const { hash } = chunk;
    const oldCacheEntry = this.cacheEntries.get(hash);
    if (oldCacheEntry) {
      this.cacheEntries.delete(hash);
      this.cacheEntries.set(hash, oldCacheEntry);
      return;
    }
    const refCount = this.#refCounts.get(hash);
    if (refCount === void 0 || refCount < 1) {
      return;
    }
    if (!this.#cacheChunk(chunk)) {
      return;
    }
    if (!this.#refs.has(hash)) {
      for (const refHash of chunk.meta) {
        this.#refCounts.set(refHash, (this.#refCounts.get(refHash) || 0) + 1);
      }
      this.#refs.set(hash, chunk.meta);
    }
    this.#ensureCacheSizeLimit();
  }
  #ensureCacheSizeLimit() {
    if (this.#evictsAndDeletesSuspended) {
      return;
    }
    for (const entry of this.cacheEntries.values()) {
      if (this.#size <= this.#cacheSizeLimit) {
        break;
      }
      this.#evict(entry);
    }
  }
  #cacheChunk(chunk, size) {
    const chunkSize = size ?? this.#getSizeOfChunk(chunk);
    if (chunkSize > this.#cacheSizeLimit) {
      return false;
    }
    this.#size += chunkSize;
    this.cacheEntries.set(chunk.hash, { chunk, size: chunkSize });
    return true;
  }
  #evict(cacheEntry) {
    const { hash } = cacheEntry.chunk;
    this.#size -= cacheEntry.size;
    this.cacheEntries.delete(hash);
  }
  #deleteEntryByHash(hash) {
    this.#refCounts.delete(hash);
    this.#refs.delete(hash);
    const cacheEntry = this.cacheEntries.get(hash);
    if (cacheEntry) {
      this.#size -= cacheEntry.size;
      this.cacheEntries.delete(hash);
    }
  }
  updateForCommit(chunksToPut, refCountUpdates) {
    for (const [hash, count] of refCountUpdates) {
      if (count === 0) {
        if (!this.#evictsAndDeletesSuspended) {
          this.#deleteEntryByHash(hash);
        } else {
          this.#refCounts.set(hash, 0);
          this.#suspendedDeletes.push(hash);
        }
      } else {
        this.#refCounts.set(hash, count);
        const chunkAndSize = chunksToPut.get(hash);
        if (chunkAndSize) {
          const { chunk, size } = chunkAndSize;
          const oldCacheEntry = this.cacheEntries.get(hash);
          if (oldCacheEntry) {
            this.cacheEntries.delete(hash);
            this.cacheEntries.set(hash, oldCacheEntry);
          } else {
            this.#cacheChunk(chunk, size !== -1 ? size : void 0);
            this.#refs.set(hash, chunk.meta);
          }
        }
      }
    }
    this.#ensureCacheSizeLimit();
  }
  persisted(chunks) {
    for (const chunk of chunks) {
      this.#cacheChunk(chunk);
    }
    this.#ensureCacheSizeLimit();
  }
  async withSuspendedEvictsAndDeletes(fn) {
    this.#evictsAndDeletesSuspended = true;
    try {
      return await fn();
    } finally {
      this.#evictsAndDeletesSuspended = false;
      for (const hash of this.#suspendedDeletes) {
        if (this.#refCounts.get(hash) === 0) {
          this.#deleteEntryByHash(hash);
        }
      }
      this.#ensureCacheSizeLimit();
    }
  }
};

// src/scan-options.ts
function isScanIndexOptions(options) {
  return options.indexName !== void 0;
}
function normalizeScanOptionIndexedStartKey(startKey) {
  if (typeof startKey === "string") {
    return [startKey];
  }
  return startKey;
}
function toDbScanOptions(options) {
  if (!options) {
    return {};
  }
  let key;
  let exclusive;
  let primary;
  let secondary;
  if (options.start) {
    ({ key, exclusive } = options.start);
    if (options.indexName) {
      if (typeof key === "string") {
        secondary = key;
      } else {
        secondary = key[0];
        primary = key[1];
      }
    } else {
      primary = key;
    }
  }
  return {
    prefix: options.prefix,
    startSecondaryKey: secondary,
    startKey: primary,
    startExclusive: exclusive,
    limit: options.limit,
    indexName: options.indexName
  };
}

// src/transaction-closed-error.ts
var TransactionClosedError = class extends Error {
  constructor() {
    super("Transaction is closed");
  }
};
function throwIfClosed(tx) {
  if (tx.closed) {
    throw new TransactionClosedError();
  }
}
function rejectIfClosed(tx) {
  return tx.closed ? Promise.reject(new TransactionClosedError()) : void 0;
}

// src/scan-iterator.ts
var ScanResultImpl = class {
  #iter;
  #options;
  #dbDelegateOptions;
  #onLimitKey;
  constructor(iter, options, dbDelegateOptions, onLimitKey) {
    this.#iter = iter;
    this.#options = options;
    this.#dbDelegateOptions = dbDelegateOptions;
    this.#onLimitKey = onLimitKey;
  }
  /** The default AsyncIterable. This is the same as {@link values}. */
  [Symbol.asyncIterator]() {
    return this.values();
  }
  /** Async iterator over the values of the {@link ReadTransaction.scan | scan} call. */
  values() {
    return new AsyncIterableIteratorToArrayWrapperImpl(
      this.#newIterator((e) => e[1])
    );
  }
  /**
   * Async iterator over the keys of the {@link ReadTransaction.scan | scan}
   * call. If the {@link ReadTransaction.scan | scan} is over an index the key
   * is a tuple of `[secondaryKey: string, primaryKey]`
   */
  keys() {
    return new AsyncIterableIteratorToArrayWrapperImpl(
      this.#newIterator((e) => e[0])
    );
  }
  /**
   * Async iterator over the entries of the {@link ReadTransaction.scan | scan}
   * call. An entry is a tuple of key values. If the
   * {@link ReadTransaction.scan | scan} is over an index the key is a tuple of
   * `[secondaryKey: string, primaryKey]`
   */
  entries() {
    return new AsyncIterableIteratorToArrayWrapperImpl(
      this.#newIterator((e) => [e[0], e[1]])
    );
  }
  /** Returns all the values as an array. Same as `values().toArray()` */
  toArray() {
    return this.values().toArray();
  }
  #newIterator(toValue) {
    return scanIterator(
      toValue,
      this.#iter,
      this.#options,
      this.#dbDelegateOptions,
      this.#onLimitKey
    );
  }
};
var AsyncIterableIteratorToArrayWrapperImpl = class {
  #it;
  constructor(it) {
    this.#it = it;
  }
  next() {
    return this.#it.next();
  }
  [Symbol.asyncIterator]() {
    return this.#it[Symbol.asyncIterator]();
  }
  toArray() {
    return asyncIterableToArray(this.#it);
  }
};
async function* scanIterator(toValue, iter, options, closed, onLimitKey) {
  throwIfClosed(closed);
  let { limit = Infinity } = options;
  const { prefix = "" } = options;
  let exclusive = options.start?.exclusive;
  const isIndexScan = isScanIndexOptions(options);
  for await (const entry of iter) {
    const key = entry[0];
    const keyToMatch = isIndexScan ? key[0] : key;
    if (!keyToMatch.startsWith(prefix)) {
      return;
    }
    if (exclusive) {
      exclusive = true;
      if (isIndexScan) {
        if (shouldSkipIndexScan(key, options.start.key)) {
          continue;
        }
      } else {
        if (shouldSkipNonIndexScan(key, options.start.key)) {
          continue;
        }
      }
    }
    yield toValue(entry);
    if (--limit === 0) {
      if (!isIndexScan) {
        onLimitKey(key);
      }
      return;
    }
  }
}
function shouldSkipIndexScan(key, startKey) {
  const [secondaryStartKey, primaryStartKey] = normalizeScanOptionIndexedStartKey(startKey);
  const [secondaryKey, primaryKey] = normalizeScanOptionIndexedStartKey(key);
  if (secondaryKey !== secondaryStartKey) {
    return false;
  }
  if (primaryStartKey === void 0) {
    return true;
  }
  return primaryKey === primaryStartKey;
}
function shouldSkipNonIndexScan(key, startKey) {
  return key === startKey;
}
function makeScanResult(options, getScanIterator2) {
  if (isScanIndexOptions(options)) {
    const [fromSecondaryKey, fromPrimaryKey] = fromKeyForIndexScan(options);
    return new ScanResultImpl(
      getScanIterator2(
        options.indexName,
        fromSecondaryKey,
        fromPrimaryKey
      ),
      options,
      { closed: false },
      (_) => {
      }
    );
  }
  const fromKey = fromKeyForNonIndexScan(options);
  return new ScanResultImpl(
    getScanIterator2(fromKey),
    options,
    { closed: false },
    (_) => {
    }
  );
}
function fromKeyForIndexScan(options) {
  const { prefix, start } = options;
  const prefixNormalized = [
    prefix ?? "",
    void 0
  ];
  if (!start) {
    return prefixNormalized;
  }
  const startKeyNormalized = normalizeScanOptionIndexedStartKey(start.key);
  if (greaterThan(startKeyNormalized[0], prefixNormalized[0])) {
    return startKeyNormalized;
  }
  if (startKeyNormalized[0] === prefixNormalized[0] && startKeyNormalized[1] !== void 0) {
    return startKeyNormalized;
  }
  return prefixNormalized;
}
function fromKeyForIndexScanInternal(options) {
  const { prefix, start } = options;
  let prefix2 = "";
  if (prefix !== void 0) {
    prefix2 = encodeIndexScanKey(prefix, void 0);
  }
  if (!start) {
    return prefix2;
  }
  const { key } = start;
  const [secondary, primary] = normalizeScanOptionIndexedStartKey(key);
  const startKey = encodeIndexScanKey(secondary, primary);
  if (greaterThan(startKey, prefix2)) {
    return startKey;
  }
  return prefix2;
}

// src/transactions.ts
var transactionIDCounter = 0;
var ReadTransactionImpl = class {
  clientID;
  dbtx;
  _lc;
  /**
   * The location in which this transaction is being used. This is either `client` or `server`.
   */
  location;
  /** @deprecated Use {@link ReadTransaction.location} instead. */
  environment;
  constructor(clientID, dbRead, lc, rpcName = "openReadTransaction") {
    this.clientID = clientID;
    this.dbtx = dbRead;
    this._lc = lc.withContext(rpcName).withContext("txid", transactionIDCounter++);
    this.environment = "client";
    this.location = "client";
  }
  get(key) {
    return rejectIfClosed(this.dbtx) || this.dbtx.get(key);
  }
  // eslint-disable-next-line require-await
  async has(key) {
    throwIfClosed(this.dbtx);
    return this.dbtx.has(key);
  }
  // eslint-disable-next-line require-await
  async isEmpty() {
    throwIfClosed(this.dbtx);
    return this.dbtx.isEmpty();
  }
  scan(options) {
    return scan(options, this.dbtx, noop);
  }
};
function noop(_) {
}
function scan(options, dbRead, onLimitKey) {
  const iter = getScanIterator(dbRead, options);
  return makeScanResultFromScanIteratorInternal(
    iter,
    options ?? {},
    dbRead,
    onLimitKey
  );
}
var SubscriptionTransactionWrapper = class {
  #keys = /* @__PURE__ */ new Set();
  #scans = [];
  #tx;
  constructor(tx) {
    this.#tx = tx;
  }
  get environment() {
    return this.#tx.location;
  }
  get location() {
    return this.#tx.location;
  }
  get clientID() {
    return this.#tx.clientID;
  }
  isEmpty() {
    this.#scans.push({ options: {} });
    return this.#tx.isEmpty();
  }
  get(key) {
    this.#keys.add(key);
    return this.#tx.get(key);
  }
  has(key) {
    this.#keys.add(key);
    return this.#tx.has(key);
  }
  scan(options) {
    const scanInfo = {
      options: toDbScanOptions(options),
      inclusiveLimitKey: void 0
    };
    this.#scans.push(scanInfo);
    return scan(options, this.#tx.dbtx, (inclusiveLimitKey) => {
      scanInfo.inclusiveLimitKey = inclusiveLimitKey;
    });
  }
  get keys() {
    return this.#keys;
  }
  get scans() {
    return this.#scans;
  }
};
var WriteTransactionImpl = class extends ReadTransactionImpl {
  reason;
  mutationID;
  constructor(clientID, mutationID, reason, dbWrite, lc, rpcName = "openWriteTransaction") {
    super(clientID, dbWrite, lc, rpcName);
    this.mutationID = mutationID;
    this.reason = reason;
  }
  put(key, value) {
    return this.set(key, value);
  }
  async set(key, value) {
    throwIfClosed(this.dbtx);
    await this.dbtx.put(this._lc, key, deepFreeze(value));
  }
  del(key) {
    return rejectIfClosed(this.dbtx) ?? this.dbtx.del(this._lc, key);
  }
};
function getScanIterator(dbRead, options) {
  if (options && isScanIndexOptions(options)) {
    return getScanIteratorForIndexMap(dbRead, options);
  }
  return dbRead.map.scan(fromKeyForNonIndexScan(options));
}
function fromKeyForNonIndexScan(options) {
  if (!options) {
    return "";
  }
  const { prefix = "", start } = options;
  if (start && greaterThan(start.key, prefix)) {
    return start.key;
  }
  return prefix;
}
function makeScanResultFromScanIteratorInternal(iter, options, dbRead, onLimitKey) {
  return new ScanResultImpl(iter, options, dbRead, onLimitKey);
}
async function* getScanIteratorForIndexMap(dbRead, options) {
  const map = dbRead.getMapForIndex(options.indexName);
  for await (const entry of map.scan(fromKeyForIndexScanInternal(options))) {
    yield [decodeIndexKey(entry[0]), entry[1]];
  }
}

// src/db/rebase.ts
async function rebaseMutation(mutation, dagWrite, basisHash, mutators, lc, mutationClientID, formatVersion) {
  const localMeta = mutation.meta;
  const name = localMeta.mutatorName;
  if (isLocalMetaDD31(localMeta)) {
    assert(
      localMeta.clientID === mutationClientID,
      "mutationClientID must match clientID of LocalMeta"
    );
  }
  const maybeMutatorImpl = mutators[name];
  if (!maybeMutatorImpl) {
    lc.error?.(`Cannot rebase unknown mutator ${name}`);
  }
  const mutatorImpl = maybeMutatorImpl || (async () => {
  });
  const args = localMeta.mutatorArgsJSON;
  const basisCommit = await commitFromHash(basisHash, dagWrite);
  const nextMutationID = await basisCommit.getNextMutationID(
    mutationClientID,
    dagWrite
  );
  if (nextMutationID !== localMeta.mutationID) {
    throw new Error(
      `Inconsistent mutation ID: original: ${localMeta.mutationID}, next: ${nextMutationID} - mutationClientID: ${mutationClientID} mutatorName: ${name}`
    );
  }
  if (formatVersion >= 5 /* DD31 */) {
    assertLocalMetaDD31(localMeta);
  }
  const dbWrite = await newWriteLocal(
    basisHash,
    name,
    args,
    mutation.chunk.hash,
    dagWrite,
    localMeta.timestamp,
    mutationClientID,
    formatVersion
  );
  const tx = new WriteTransactionImpl(
    mutationClientID,
    await dbWrite.getMutationID(),
    "rebase",
    dbWrite,
    lc
  );
  await mutatorImpl(tx, args);
  return dbWrite;
}
async function rebaseMutationAndPutCommit(mutation, dagWrite, basis, mutators, lc, mutationClientID, formatVersion) {
  const tx = await rebaseMutation(
    mutation,
    dagWrite,
    basis,
    mutators,
    lc,
    mutationClientID,
    formatVersion
  );
  return tx.putCommit();
}
async function rebaseMutationAndCommit(mutation, dagWrite, basis, headName, mutators, lc, mutationClientID, formatVersion) {
  const dbWrite = await rebaseMutation(
    mutation,
    dagWrite,
    basis,
    mutators,
    lc,
    mutationClientID,
    formatVersion
  );
  return dbWrite.commit(headName);
}

// src/get-default-pusher.ts
function getDefaultPusher(rep) {
  async function pusher(requestBody, requestID) {
    const [response, httpRequestInfo] = await callDefaultFetch(
      rep.pushURL,
      rep.auth,
      requestID,
      requestBody
    );
    if (!response) {
      return { httpRequestInfo };
    }
    const rv = {
      httpRequestInfo
    };
    let result;
    try {
      result = await response.json();
    } catch {
      return rv;
    }
    if (isClientStateNotFoundResponse(result) || isVersionNotSupportedResponse(result)) {
      rv.response = result;
    }
    return rv;
  }
  defaultPushers.add(pusher);
  return pusher;
}
var defaultPushers = /* @__PURE__ */ new WeakSet();
function isDefaultPusher(pusher) {
  return defaultPushers.has(pusher);
}

// src/log-options.ts
import {
  consoleLogSink,
  TeeLogSink,
  LogContext
} from "@rocicorp/logger";
function createLogContext(logLevel = "info", logSinks = [consoleLogSink], context) {
  const logSink = logSinks.length === 1 ? logSinks[0] : new TeeLogSink(logSinks);
  return new LogContext(logLevel, context, logSink);
}

// src/to-error.ts
function toError(e) {
  if (e instanceof Error) {
    return e;
  }
  return new Error(String(e));
}

// src/sync/patch.ts
async function apply(lc, dbWrite, patch) {
  for (const p of patch) {
    switch (p.op) {
      case "put": {
        await dbWrite.put(lc, p.key, deepFreeze(p.value));
        break;
      }
      case "update": {
        const existing = await dbWrite.get(p.key);
        const entries = [];
        const addToEntries = (toAdd) => {
          for (const [key, value] of Object.entries(toAdd)) {
            if (!p.constrain || p.constrain.length === 0 || p.constrain.indexOf(key) > -1) {
              entries.push([key, value]);
            }
          }
        };
        if (existing !== void 0) {
          assertObject2(existing);
          addToEntries(existing);
        }
        if (p.merge) {
          addToEntries(p.merge);
        }
        await dbWrite.put(lc, p.key, deepFreeze(Object.fromEntries(entries)));
        break;
      }
      case "del":
        await dbWrite.del(lc, p.key);
        break;
      case "clear":
        await dbWrite.clear();
        break;
    }
  }
}

// src/sync/pull-error.ts
var PullError = class extends Error {
  name = "PullError";
  // causedBy is used instead of cause, because while cause has been proposed as a
  // JavaScript language standard for this purpose (see
  // https://github.com/tc39/proposal-error-cause) current browser behavior is
  // inconsistent.
  causedBy;
  constructor(causedBy) {
    super("Failed to pull");
    this.causedBy = causedBy;
  }
};

// src/sync/sync-head-name.ts
var SYNC_HEAD_NAME = "sync";

// src/sync/pull.ts
var PULL_VERSION_SDD = 0;
var PULL_VERSION_DD31 = 1;
function isPullRequestV1(pr) {
  return pr.pullVersion === PULL_VERSION_DD31;
}
async function beginPullV0(profileID, clientID, schemaVersion, puller, requestID, store, formatVersion, lc, createSyncBranch = true) {
  const [lastMutationID, baseCookie] = await withRead(store, async (dagRead) => {
    const mainHeadHash = await dagRead.getHead(DEFAULT_HEAD_NAME);
    if (!mainHeadHash) {
      throw new Error("Internal no main head found");
    }
    const baseSnapshot = await baseSnapshotFromHash(mainHeadHash, dagRead);
    const baseSnapshotMeta = baseSnapshot.meta;
    const baseCookie2 = baseSnapshotMeta.cookieJSON;
    const lastMutationID2 = await baseSnapshot.getMutationID(clientID, dagRead);
    return [lastMutationID2, baseCookie2];
  });
  const pullReq = {
    profileID,
    clientID,
    cookie: baseCookie,
    lastMutationID,
    pullVersion: PULL_VERSION_SDD,
    schemaVersion
  };
  const { response, httpRequestInfo } = await callPuller(
    lc,
    puller,
    pullReq,
    requestID
  );
  if (!response) {
    return {
      httpRequestInfo,
      syncHead: emptyHash
    };
  }
  if (!createSyncBranch || isErrorResponse(response)) {
    return {
      httpRequestInfo,
      pullResponse: response,
      syncHead: emptyHash
    };
  }
  const result = await handlePullResponseV0(
    lc,
    store,
    baseCookie,
    response,
    clientID,
    formatVersion
  );
  if (result.type === 2 /* CookieMismatch */) {
    throw new Error("Overlapping sync");
  }
  return {
    httpRequestInfo,
    pullResponse: response,
    syncHead: result.type === 0 /* Applied */ ? result.syncHead : emptyHash
  };
}
async function beginPullV1(profileID, clientID, clientGroupID, schemaVersion, puller, requestID, store, formatVersion, lc, createSyncBranch = true) {
  const baseCookie = await withRead(store, async (dagRead) => {
    const mainHeadHash = await dagRead.getHead(DEFAULT_HEAD_NAME);
    if (!mainHeadHash) {
      throw new Error("Internal no main head found");
    }
    const baseSnapshot = await baseSnapshotFromHash(mainHeadHash, dagRead);
    const baseSnapshotMeta = baseSnapshot.meta;
    assertSnapshotMetaDD31(baseSnapshotMeta);
    return baseSnapshotMeta.cookieJSON;
  });
  const pullReq = {
    profileID,
    clientGroupID,
    cookie: baseCookie,
    pullVersion: PULL_VERSION_DD31,
    schemaVersion
  };
  const { response, httpRequestInfo } = await callPuller(
    lc,
    puller,
    pullReq,
    requestID
  );
  if (!response) {
    return {
      httpRequestInfo,
      syncHead: emptyHash
    };
  }
  if (!createSyncBranch || isErrorResponse(response)) {
    return {
      httpRequestInfo,
      pullResponse: response,
      syncHead: emptyHash
    };
  }
  const result = await handlePullResponseV1(
    lc,
    store,
    baseCookie,
    response,
    clientID,
    formatVersion
  );
  return {
    httpRequestInfo,
    pullResponse: response,
    syncHead: result.type === 0 /* Applied */ ? result.syncHead : emptyHash
  };
}
async function callPuller(lc, puller, pullReq, requestID) {
  lc.debug?.("Starting pull...");
  const pullStart = Date.now();
  let pullerResult;
  try {
    pullerResult = await puller(pullReq, requestID);
    lc.debug?.(
      `...Pull ${pullerResult.response ? "complete" : "failed"} in `,
      Date.now() - pullStart,
      "ms"
    );
  } catch (e) {
    throw new PullError(toError(e));
  }
  try {
    if (isPullRequestV1(pullReq)) {
      assertPullerResultV1(pullerResult);
    } else {
      assertPullerResultV0(pullerResult);
    }
    return pullerResult;
  } catch (e) {
    throw new ReportError("Invalid puller result", toError(e));
  }
}
function handlePullResponseV0(lc, store, expectedBaseCookie, response, clientID, formatVersion) {
  return withWriteNoImplicitCommit(store, async (dagWrite) => {
    assert(formatVersion <= 4 /* SDD */);
    const dagRead = dagWrite;
    const mainHead = await dagRead.getHead(DEFAULT_HEAD_NAME);
    if (mainHead === void 0) {
      throw new Error("Main head disappeared");
    }
    const baseSnapshot = await baseSnapshotFromHash(mainHead, dagRead);
    const [baseLastMutationID, baseCookie] = snapshotMetaParts(
      baseSnapshot,
      clientID
    );
    if (!deepEqual(expectedBaseCookie, baseCookie)) {
      return {
        type: 2 /* CookieMismatch */
      };
    }
    if (response.lastMutationID < baseLastMutationID) {
      throw new Error(
        badOrderMessage(
          `lastMutationID`,
          String(response.lastMutationID),
          String(baseLastMutationID)
        )
      );
    }
    const frozenCookie = deepFreeze(response.cookie ?? null);
    if (deepEqual(frozenCookie, baseCookie)) {
      if (response.patch.length > 0) {
        lc.error?.(
          `handlePullResponse: cookie ${JSON.stringify(
            baseCookie
          )} did not change, but patch is not empty`
        );
      }
      if (response.lastMutationID !== baseLastMutationID) {
        lc.error?.(
          `handlePullResponse: cookie ${JSON.stringify(
            baseCookie
          )} did not change, but lastMutationID did change`
        );
      }
      return {
        type: 1 /* NoOp */
      };
    }
    const chain = await commitChain(mainHead, dagRead);
    let lastIntegrated;
    for (const commit of chain) {
      if (await commit.getMutationID(clientID, dagRead) <= response.lastMutationID) {
        lastIntegrated = commit;
        break;
      }
    }
    if (!lastIntegrated) {
      throw new Error("Internal invalid chain");
    }
    const dbWrite = await newWriteSnapshotSDD(
      baseSnapshot.chunk.hash,
      response.lastMutationID,
      frozenCookie,
      dagWrite,
      readIndexesForWrite(lastIntegrated, dagWrite, formatVersion),
      clientID,
      formatVersion
    );
    await apply(lc, dbWrite, response.patch);
    const lastIntegratedMap = new BTreeRead(
      dagRead,
      formatVersion,
      lastIntegrated.valueHash
    );
    for await (const change of dbWrite.map.diff(lastIntegratedMap)) {
      await updateIndexes(
        lc,
        dbWrite.indexes,
        change.key,
        () => Promise.resolve(change.oldValue),
        change.newValue
      );
    }
    return {
      type: 0 /* Applied */,
      syncHead: await dbWrite.commit(SYNC_HEAD_NAME)
    };
  });
}
function badOrderMessage(name, receivedValue, lastSnapshotValue) {
  return `Received ${name} ${receivedValue} is < than last snapshot ${name} ${lastSnapshotValue}; ignoring client view`;
}
function handlePullResponseV1(lc, store, expectedBaseCookie, response, clientID, formatVersion) {
  return withWriteNoImplicitCommit(store, async (dagWrite) => {
    const dagRead = dagWrite;
    const mainHead = await dagRead.getHead(DEFAULT_HEAD_NAME);
    if (mainHead === void 0) {
      throw new Error("Main head disappeared");
    }
    const baseSnapshot = await baseSnapshotFromHash(mainHead, dagRead);
    const baseSnapshotMeta = baseSnapshot.meta;
    assertSnapshotMetaDD31(baseSnapshotMeta);
    const baseCookie = baseSnapshotMeta.cookieJSON;
    if (!deepEqual(expectedBaseCookie, baseCookie)) {
      lc.debug?.(
        "handlePullResponse: cookie mismatch, response is not applicable"
      );
      return {
        type: 2 /* CookieMismatch */
      };
    }
    for (const [clientID2, lmidChange] of Object.entries(
      response.lastMutationIDChanges
    )) {
      const lastMutationID = baseSnapshotMeta.lastMutationIDs[clientID2];
      if (lastMutationID !== void 0 && lmidChange < lastMutationID) {
        throw new Error(
          badOrderMessage(
            `${clientID2} lastMutationID`,
            String(lmidChange),
            String(lastMutationID)
          )
        );
      }
    }
    const frozenResponseCookie = deepFreeze(response.cookie);
    if (compareCookies(frozenResponseCookie, baseCookie) < 0) {
      throw new Error(
        badOrderMessage(
          "cookie",
          JSON.stringify(frozenResponseCookie),
          JSON.stringify(baseCookie)
        )
      );
    }
    if (deepEqual(frozenResponseCookie, baseCookie)) {
      if (response.patch.length > 0) {
        lc.error?.(
          `handlePullResponse: cookie ${JSON.stringify(
            baseCookie
          )} did not change, but patch is not empty`
        );
      }
      if (Object.keys(response.lastMutationIDChanges).length > 0) {
        console.log(response.lastMutationIDChanges);
        lc.error?.(
          `handlePullResponse: cookie ${JSON.stringify(
            baseCookie
          )} did not change, but lastMutationIDChanges is not empty`
        );
      }
      return {
        type: 1 /* NoOp */
      };
    }
    const dbWrite = await newWriteSnapshotDD31(
      baseSnapshot.chunk.hash,
      { ...baseSnapshotMeta.lastMutationIDs, ...response.lastMutationIDChanges },
      frozenResponseCookie,
      dagWrite,
      clientID,
      formatVersion
    );
    await apply(lc, dbWrite, response.patch);
    return {
      type: 0 /* Applied */,
      syncHead: await dbWrite.commit(SYNC_HEAD_NAME)
    };
  });
}
function maybeEndPull(store, lc, expectedSyncHead, clientID, diffConfig, formatVersion) {
  return withWriteNoImplicitCommit(store, async (dagWrite) => {
    const dagRead = dagWrite;
    const syncHeadHash = await dagRead.getHead(SYNC_HEAD_NAME);
    if (syncHeadHash === void 0) {
      throw new Error("Missing sync head");
    }
    if (syncHeadHash !== expectedSyncHead) {
      lc.error?.(
        "maybeEndPull, Wrong sync head. Expecting:",
        expectedSyncHead,
        "got:",
        syncHeadHash
      );
      throw new Error("Wrong sync head");
    }
    const syncSnapshot = await baseSnapshotFromHash(syncHeadHash, dagRead);
    const mainHeadHash = await dagRead.getHead(DEFAULT_HEAD_NAME);
    if (mainHeadHash === void 0) {
      throw new Error("Missing main head");
    }
    const mainSnapshot = await baseSnapshotFromHash(mainHeadHash, dagRead);
    const { meta } = syncSnapshot;
    const syncSnapshotBasis = meta.basisHash;
    if (syncSnapshot === null) {
      throw new Error("Sync snapshot with no basis");
    }
    if (syncSnapshotBasis !== mainSnapshot.chunk.hash) {
      throw new Error("Overlapping syncs");
    }
    const syncHead = await commitFromHash(syncHeadHash, dagRead);
    const pending = [];
    const localMutations2 = await localMutations(mainHeadHash, dagRead);
    for (const commit of localMutations2) {
      let cid = clientID;
      if (commitIsLocalDD31(commit)) {
        cid = commit.meta.clientID;
      }
      if (await commit.getMutationID(cid, dagRead) > await syncHead.getMutationID(cid, dagRead)) {
        pending.push(commit);
      }
    }
    pending.reverse();
    const diffsMap = new DiffsMap();
    if (pending.length > 0) {
      return {
        syncHead: syncHeadHash,
        replayMutations: pending,
        // The changed keys are not reported when further replays are
        // needed. The diffs will be reported at the end when there
        // are no more mutations to be replay and then it will be reported
        // relative to DEFAULT_HEAD_NAME.
        diffs: diffsMap
      };
    }
    const mainHead = await commitFromHash(mainHeadHash, dagRead);
    if (diffConfig.shouldComputeDiffs()) {
      const mainHeadMap = new BTreeRead(
        dagRead,
        formatVersion,
        mainHead.valueHash
      );
      const syncHeadMap = new BTreeRead(
        dagRead,
        formatVersion,
        syncHead.valueHash
      );
      const valueDiff = await diff(mainHeadMap, syncHeadMap);
      diffsMap.set("", valueDiff);
      await addDiffsForIndexes(
        mainHead,
        syncHead,
        dagRead,
        diffsMap,
        diffConfig,
        formatVersion
      );
    }
    await Promise.all([
      dagWrite.setHead(DEFAULT_HEAD_NAME, syncHeadHash),
      dagWrite.removeHead(SYNC_HEAD_NAME)
    ]);
    await dagWrite.commit();
    if (lc.debug) {
      const [oldLastMutationID, oldCookie] = snapshotMetaParts(
        mainSnapshot,
        clientID
      );
      const [newLastMutationID, newCookie] = snapshotMetaParts(
        syncSnapshot,
        clientID
      );
      lc.debug(
        `Successfully pulled new snapshot with lastMutationID:`,
        newLastMutationID,
        `(prev:`,
        oldLastMutationID,
        `), cookie: `,
        newCookie,
        `(prev:`,
        oldCookie,
        `), sync head hash:`,
        syncHeadHash,
        ", main head hash:",
        mainHeadHash,
        `, valueHash:`,
        syncHead.valueHash,
        `(prev:`,
        mainSnapshot.valueHash
      );
    }
    return {
      syncHead: syncHeadHash,
      replayMutations: [],
      diffs: diffsMap
    };
  });
}

// ../shared/src/json-schema.ts
import * as valita from "@badrap/valita";
var path = [];
var jsonSchema = valita_exports.unknown().chain((v2) => {
  if (isProd) {
    return valita.ok(v2);
  }
  const rv = isJSONValue(v2, path) ? valita.ok(v2) : valita.err({
    message: `Not a JSON value`,
    path: path.slice()
  });
  path.length = 0;
  return rv;
});
var jsonObjectSchema = valita_exports.unknown().chain((v2) => {
  if (isProd) {
    return valita.ok(v2);
  }
  const rv = isJSONObject(v2, path) ? valita.ok(v2) : valita.err({
    message: `Not a JSON object`,
    path: path.slice()
  });
  path.length = 0;
  return rv;
});

// src/pusher.ts
function assertPusherResult(v2) {
  assertObject2(v2);
  assertHTTPRequestInfo(v2.httpRequestInfo);
  if (v2.response !== void 0) {
    assertPushResponse(v2.response);
  }
}
function assertPushResponse(v2) {
  if (isClientStateNotFoundResponse(v2)) {
    return;
  }
  assertVersionNotSupportedResponse(v2);
}
var PushError = class extends Error {
  name = "PushError";
  // causedBy is used instead of cause, because while cause has been proposed as a
  // JavaScript language standard for this purpose (see
  // https://github.com/tc39/proposal-error-cause) current browser behavior is
  // inconsistent.
  causedBy;
  constructor(causedBy) {
    super("Failed to push");
    this.causedBy = causedBy;
  }
};

// src/sync/push.ts
var PUSH_VERSION_SDD = 0;
var PUSH_VERSION_DD31 = 1;
var mutationV0Schema = readonlyObject({
  id: valita_exports.number(),
  name: valita_exports.string(),
  args: jsonSchema,
  timestamp: valita_exports.number()
});
var mutationV1Schema = readonlyObject({
  id: valita_exports.number(),
  name: valita_exports.string(),
  args: jsonSchema,
  timestamp: valita_exports.number(),
  clientID: clientIDSchema
});
var pushRequestV0Schema = valita_exports.object({
  pushVersion: valita_exports.literal(0),
  schemaVersion: valita_exports.string(),
  profileID: valita_exports.string(),
  clientID: clientIDSchema,
  mutations: valita_exports.array(mutationV0Schema)
});
var pushRequestV1Schema = valita_exports.object({
  pushVersion: valita_exports.literal(1),
  schemaVersion: valita_exports.string(),
  profileID: valita_exports.string(),
  clientGroupID: clientGroupIDSchema,
  mutations: valita_exports.array(mutationV1Schema)
});
function convertSDD(lm) {
  return {
    id: lm.mutationID,
    name: lm.mutatorName,
    args: lm.mutatorArgsJSON,
    timestamp: lm.timestamp
  };
}
function convertDD31(lm) {
  return {
    id: lm.mutationID,
    name: lm.mutatorName,
    args: lm.mutatorArgsJSON,
    timestamp: lm.timestamp,
    clientID: lm.clientID
  };
}
async function push(requestID, store, lc, profileID, clientGroupID, clientID, pusher, schemaVersion, pushVersion) {
  const pending = await withRead(store, async (dagRead) => {
    const mainHeadHash = await dagRead.getHead(DEFAULT_HEAD_NAME);
    if (!mainHeadHash) {
      throw new Error("Internal no main head");
    }
    return localMutations(mainHeadHash, dagRead);
  });
  if (pending.length === 0) {
    return void 0;
  }
  pending.reverse();
  let pushReq;
  if (pushVersion === PUSH_VERSION_DD31) {
    const pushMutations = [];
    for (const commit of pending) {
      if (commitIsLocalDD31(commit)) {
        pushMutations.push(convertDD31(commit.meta));
      } else {
        throw new Error("Internal non local pending commit");
      }
    }
    assert(clientGroupID);
    const r = {
      profileID,
      clientGroupID,
      mutations: pushMutations,
      pushVersion: PUSH_VERSION_DD31,
      schemaVersion
    };
    pushReq = r;
  } else {
    assert(pushVersion === PUSH_VERSION_SDD);
    const pushMutations = [];
    for (const commit of pending) {
      if (commitIsLocalSDD(commit)) {
        pushMutations.push(convertSDD(commit.meta));
      } else {
        throw new Error("Internal non local pending commit");
      }
    }
    pushReq = {
      profileID,
      clientID,
      mutations: pushMutations,
      pushVersion: PUSH_VERSION_SDD,
      schemaVersion
    };
  }
  lc.debug?.("Starting push...");
  const pushStart = Date.now();
  const pusherResult = await callPusher(pusher, pushReq, requestID);
  lc.debug?.("...Push complete in ", Date.now() - pushStart, "ms");
  return pusherResult;
}
async function callPusher(pusher, body, requestID) {
  let pusherResult;
  try {
    pusherResult = await pusher(body, requestID);
  } catch (e) {
    throw new PushError(toError(e));
  }
  try {
    assertPusherResult(pusherResult);
    return pusherResult;
  } catch (e) {
    throw new ReportError("Invalid pusher result", toError(e));
  }
}

// src/mutation-recovery.ts
var MUTATION_RECOVERY_LAZY_STORE_SOURCE_CHUNK_CACHE_SIZE_LIMIT = 10 * 2 ** 20;
var MutationRecovery = class {
  #recoveringMutations = false;
  #options;
  constructor(options) {
    this.#options = options;
  }
  async recoverMutations(preReadClientMap, ready, perdag, idbDatabase, idbDatabases, createStore) {
    const { lc, enableMutationRecovery, isPushDisabled, delegate } = this.#options;
    if (!enableMutationRecovery || this.#recoveringMutations || !delegate.online || delegate.closed || isPushDisabled()) {
      return false;
    }
    const stepDescription = "Recovering mutations.";
    lc.debug?.("Start:", stepDescription);
    try {
      this.#recoveringMutations = true;
      await ready;
      await recoverMutationsFromPerdag(
        idbDatabase,
        this.#options,
        perdag,
        preReadClientMap
      );
      for (const database of Object.values(await idbDatabases.getDatabases())) {
        if (delegate.closed) {
          lc.debug?.("Exiting early due to close:", stepDescription);
          return true;
        }
        if (database.replicacheName === delegate.name && database.name !== delegate.idbName) {
          switch (database.replicacheFormatVersion) {
            case 4 /* SDD */:
            case 5 /* DD31 */:
            case 6 /* V6 */:
            case 7 /* V7 */:
              await recoverMutationsWithNewPerdag(
                database,
                this.#options,
                void 0,
                createStore
              );
          }
        }
      }
    } catch (e) {
      logMutationRecoveryError(e, lc, stepDescription, delegate);
    } finally {
      lc.debug?.("End:", stepDescription);
      this.#recoveringMutations = false;
    }
    return true;
  }
};
function logMutationRecoveryError(e, lc, stepDescription, closedDelegate) {
  if (closedDelegate.closed) {
    lc.debug?.(
      `Mutation recovery error likely due to close during:
${stepDescription}
Error:
`,
      e
    );
  } else {
    lc.error?.(
      `Mutation recovery error during:
${stepDescription}
Error:
`,
      e
    );
  }
}
async function recoverMutationsOfClientV4(client, clientID, perdag, database, options, formatVersion) {
  assert(database.replicacheFormatVersion === 4 /* SDD */);
  assertClientV4(client);
  const {
    delegate,
    lc,
    wrapInOnlineCheck,
    wrapInReauthRetries,
    isPushDisabled,
    isPullDisabled
  } = options;
  const selfClientID = delegate.clientID;
  if (selfClientID === clientID) {
    return;
  }
  if (client.lastServerAckdMutationID >= client.mutationID) {
    return;
  }
  const stepDescription = `Recovering mutations for ${clientID}.`;
  lc.debug?.("Start:", stepDescription);
  const lazyDagForOtherClient = new LazyStore(
    perdag,
    MUTATION_RECOVERY_LAZY_STORE_SOURCE_CHUNK_CACHE_SIZE_LIMIT,
    throwChunkHasher,
    assertHash
  );
  try {
    await withWrite(
      lazyDagForOtherClient,
      (write) => write.setHead(DEFAULT_HEAD_NAME, client.headHash)
    );
    if (isPushDisabled()) {
      lc.debug?.(
        `Cannot recover mutations for client ${clientID} because push is disabled.`
      );
      return;
    }
    const { pusher } = delegate;
    const pushDescription = "recoveringMutationsPush";
    const pushSucceeded = await wrapInOnlineCheck(async () => {
      const { result: pusherResult } = await wrapInReauthRetries(
        async (requestID, requestLc) => {
          assertNotUndefined(lazyDagForOtherClient);
          const pusherResult2 = await push(
            requestID,
            lazyDagForOtherClient,
            requestLc,
            await delegate.profileID,
            void 0,
            clientID,
            pusher,
            database.schemaVersion,
            PUSH_VERSION_SDD
          );
          return {
            result: pusherResult2,
            httpRequestInfo: pusherResult2?.httpRequestInfo
          };
        },
        pushDescription,
        lc
      );
      return !!pusherResult && pusherResult.httpRequestInfo.httpStatusCode === 200;
    }, pushDescription);
    if (!pushSucceeded) {
      lc.debug?.(
        `Failed to recover mutations for client ${clientID} due to a push error.`
      );
      return;
    }
    if (isPullDisabled()) {
      lc.debug?.(
        `Cannot confirm mutations were recovered for client ${clientID} because pull is disabled.`
      );
      return;
    }
    const { puller } = delegate;
    const pullDescription = "recoveringMutationsPull";
    let pullResponse;
    const pullSucceeded = await wrapInOnlineCheck(async () => {
      const { result: beginPullResponse } = await wrapInReauthRetries(
        async (requestID, requestLc) => {
          const beginPullResponse2 = await beginPullV0(
            await delegate.profileID,
            clientID,
            database.schemaVersion,
            puller,
            requestID,
            lazyDagForOtherClient,
            formatVersion,
            requestLc,
            false
          );
          return {
            result: beginPullResponse2,
            httpRequestInfo: beginPullResponse2.httpRequestInfo
          };
        },
        pullDescription,
        lc
      );
      ({ pullResponse } = beginPullResponse);
      return !!pullResponse && beginPullResponse.httpRequestInfo.httpStatusCode === 200;
    }, pullDescription);
    if (!pullSucceeded) {
      lc.debug?.(
        `Failed to recover mutations for client ${clientID} due to a pull error.`
      );
      return;
    }
    if (lc.debug && pullResponse) {
      if (isClientStateNotFoundResponse(pullResponse)) {
        lc.debug?.(
          `Client ${selfClientID} cannot recover mutations for client ${clientID}. The client no longer exists on the server.`
        );
      } else if (isVersionNotSupportedResponse(pullResponse)) {
        lc.debug?.(
          `Version is not supported on the server. versionType: ${pullResponse.versionType}. Cannot recover mutations for client ${clientID}.`
        );
      } else {
        lc.debug?.(
          `Client ${selfClientID} recovered mutations for client ${clientID}.  Details`,
          {
            mutationID: client.mutationID,
            lastServerAckdMutationID: client.lastServerAckdMutationID,
            lastMutationID: pullResponse.lastMutationID
          }
        );
      }
    }
    return await withWrite(perdag, async (dagWrite) => {
      const clients = await getClients(dagWrite);
      const clientToUpdate = clients.get(clientID);
      if (!clientToUpdate) {
        return clients;
      }
      assertClientV4(clientToUpdate);
      const setNewClients = async (newClients2) => {
        await setClients(newClients2, dagWrite);
        return newClients2;
      };
      if (isClientStateNotFoundResponse(pullResponse) || // Even though SDD did not have VersionNotSupported we can still get
      // this if the server was upgraded to handle this. It seems better to
      // delete the client at this point.
      isVersionNotSupportedResponse(pullResponse)) {
        const newClients2 = new Map(clients);
        newClients2.delete(clientID);
        return setNewClients(newClients2);
      }
      assert(pullResponse);
      if (clientToUpdate.lastServerAckdMutationID >= pullResponse.lastMutationID) {
        return clients;
      }
      const newClients = new Map(clients).set(clientID, {
        ...clientToUpdate,
        lastServerAckdMutationID: pullResponse.lastMutationID
      });
      return setNewClients(newClients);
    });
  } catch (e) {
    logMutationRecoveryError(e, lc, stepDescription, delegate);
  } finally {
    await lazyDagForOtherClient.close();
    lc.debug?.("End:", stepDescription);
  }
  return;
}
async function recoverMutationsWithNewPerdag(database, options, preReadClientMap, createStore) {
  const perKvStore = createStore(database.name);
  const perdag = new StoreImpl(perKvStore, newUUIDHash, assertHash);
  try {
    await recoverMutationsFromPerdag(
      database,
      options,
      perdag,
      preReadClientMap
    );
  } finally {
    await perdag.close();
  }
}
function recoverMutationsFromPerdag(database, options, perdag, preReadClientMap) {
  if (database.replicacheFormatVersion >= 5 /* DD31 */) {
    return recoverMutationsFromPerdagDD31(database, options, perdag);
  }
  return recoverMutationsFromPerdagSDD(
    database,
    options,
    perdag,
    preReadClientMap
  );
}
async function recoverMutationsFromPerdagSDD(database, options, perdag, preReadClientMap) {
  const { delegate, lc } = options;
  const stepDescription = `Recovering mutations from db ${database.name}.`;
  lc.debug?.("Start:", stepDescription);
  try {
    const formatVersion = parseReplicacheFormatVersion(database.replicacheFormatVersion);
    let clientMap = preReadClientMap || await withRead(perdag, (read) => getClients(read));
    const clientIDsVisited = /* @__PURE__ */ new Set();
    while (clientMap) {
      let newClientMap;
      for (const [clientID, client] of clientMap) {
        if (delegate.closed) {
          lc.debug?.("Exiting early due to close:", stepDescription);
          return;
        }
        if (!clientIDsVisited.has(clientID)) {
          clientIDsVisited.add(clientID);
          newClientMap = await recoverMutationsOfClientV4(
            client,
            clientID,
            perdag,
            database,
            options,
            formatVersion
          );
          if (newClientMap) {
            break;
          }
        }
      }
      clientMap = newClientMap;
    }
  } catch (e) {
    logMutationRecoveryError(e, lc, stepDescription, delegate);
  }
  lc.debug?.("End:", stepDescription);
}
async function recoverMutationsFromPerdagDD31(database, options, perdag) {
  const { delegate, lc } = options;
  const stepDescription = `Recovering mutations from db ${database.name}.`;
  lc.debug?.("Start:", stepDescription);
  try {
    const formatVersion = parseReplicacheFormatVersion(database.replicacheFormatVersion);
    let clientGroups = await withRead(
      perdag,
      (read) => getClientGroups(read)
    );
    const clientGroupIDsVisited = /* @__PURE__ */ new Set();
    while (clientGroups) {
      let newClientGroups;
      for (const [clientGroupID, clientGroup] of clientGroups) {
        if (delegate.closed) {
          lc.debug?.("Exiting early due to close:", stepDescription);
          return;
        }
        if (!clientGroupIDsVisited.has(clientGroupID)) {
          clientGroupIDsVisited.add(clientGroupID);
          newClientGroups = await recoverMutationsOfClientGroupDD31(
            clientGroup,
            clientGroupID,
            perdag,
            database,
            options,
            formatVersion
          );
          if (newClientGroups) {
            break;
          }
        }
      }
      clientGroups = newClientGroups;
    }
  } catch (e) {
    logMutationRecoveryError(e, lc, stepDescription, delegate);
  }
  lc.debug?.("End:", stepDescription);
}
function isResponseThatShouldDisableClientGroup(response) {
  return isClientStateNotFoundResponse(response) || isVersionNotSupportedResponse(response);
}
async function disableClientGroup2(lc, selfClientGroupID, clientGroupID, response, perdag) {
  if (isClientStateNotFoundResponse(response)) {
    lc.debug?.(
      `Client group ${selfClientGroupID} cannot recover mutations for client group ${clientGroupID}. The client group is unknown on the server. Marking it as disabled.`
    );
  } else if (isVersionNotSupportedResponse(response)) {
    lc.debug?.(
      `Client group ${selfClientGroupID} cannot recover mutations for client group ${clientGroupID}. The client group's version is not supported on the server. versionType: ${response.versionType}. Marking it as disabled.`
    );
  }
  await withWrite(
    perdag,
    (perdagWrite) => disableClientGroup(clientGroupID, perdagWrite)
  );
}
async function recoverMutationsOfClientGroupDD31(clientGroup, clientGroupID, perdag, database, options, formatVersion) {
  assert(database.replicacheFormatVersion >= 5 /* DD31 */);
  const {
    delegate,
    lc,
    wrapInOnlineCheck,
    wrapInReauthRetries,
    isPushDisabled,
    isPullDisabled
  } = options;
  const selfClientGroupID = await options.clientGroupIDPromise;
  assertNotUndefined(selfClientGroupID);
  if (selfClientGroupID === clientGroupID) {
    return;
  }
  let clientID;
  let allAckd = true;
  for (const [cid, mutationID] of Object.entries(clientGroup.mutationIDs)) {
    if (!clientGroup.lastServerAckdMutationIDs[cid] || clientGroup.lastServerAckdMutationIDs[cid] < mutationID) {
      clientID = cid;
      allAckd = false;
      break;
    }
  }
  if (allAckd) {
    return;
  }
  if (clientGroup.disabled) {
    lc.debug?.(
      `Not recovering mutations for client group ${clientGroupID} because group is disabled.`
    );
    return;
  }
  const stepDescription = `Recovering mutations for client group ${clientGroupID}.`;
  lc.debug?.("Start:", stepDescription);
  const lazyDagForOtherClientGroup = new LazyStore(
    perdag,
    MUTATION_RECOVERY_LAZY_STORE_SOURCE_CHUNK_CACHE_SIZE_LIMIT,
    throwChunkHasher,
    assertHash
  );
  try {
    await withWrite(
      lazyDagForOtherClientGroup,
      (write) => write.setHead(DEFAULT_HEAD_NAME, clientGroup.headHash)
    );
    if (isPushDisabled()) {
      lc.debug?.(
        `Cannot recover mutations for client group ${clientGroupID} because push is disabled.`
      );
      return;
    }
    const { pusher } = delegate;
    const pushDescription = "recoveringMutationsPush";
    const pushSucceeded = await wrapInOnlineCheck(async () => {
      const { result: pusherResult } = await wrapInReauthRetries(
        async (requestID, requestLc) => {
          assert(clientID);
          assert(lazyDagForOtherClientGroup);
          const pusherResult2 = await push(
            requestID,
            lazyDagForOtherClientGroup,
            requestLc,
            await delegate.profileID,
            clientGroupID,
            // TODO(DD31): clientID is not needed in DD31. It is currently kept for debugging purpose.
            clientID,
            pusher,
            database.schemaVersion,
            PUSH_VERSION_DD31
          );
          return {
            result: pusherResult2,
            httpRequestInfo: pusherResult2?.httpRequestInfo
          };
        },
        pushDescription,
        lc
      );
      if (!pusherResult) {
        return false;
      }
      const pusherResponse = pusherResult.response;
      if (isResponseThatShouldDisableClientGroup(pusherResponse)) {
        await disableClientGroup2(
          lc,
          selfClientGroupID,
          clientGroupID,
          pusherResponse,
          perdag
        );
        return false;
      }
      return pusherResult.httpRequestInfo.httpStatusCode === 200;
    }, pushDescription);
    if (!pushSucceeded) {
      lc.debug?.(
        `Failed to recover mutations for client ${clientGroupID} due to a push error.`
      );
      return;
    }
    if (isPullDisabled()) {
      lc.debug?.(
        `Cannot confirm mutations were recovered for client ${clientGroupID} because pull is disabled.`
      );
      return;
    }
    const { puller } = delegate;
    const pullDescription = "recoveringMutationsPull";
    let okPullResponse;
    const pullSucceeded = await wrapInOnlineCheck(async () => {
      const { result: beginPullResponse } = await wrapInReauthRetries(
        async (requestID, requestLc) => {
          assert(clientID);
          const beginPullResponse2 = await beginPullV1(
            await delegate.profileID,
            clientID,
            clientGroupID,
            database.schemaVersion,
            puller,
            requestID,
            lazyDagForOtherClientGroup,
            formatVersion,
            requestLc,
            false
          );
          return {
            result: beginPullResponse2,
            httpRequestInfo: beginPullResponse2.httpRequestInfo
          };
        },
        pullDescription,
        lc
      );
      const { pullResponse } = beginPullResponse;
      if (isResponseThatShouldDisableClientGroup(pullResponse)) {
        await disableClientGroup2(
          lc,
          selfClientGroupID,
          clientGroupID,
          pullResponse,
          perdag
        );
        return false;
      }
      if (!pullResponse || beginPullResponse.httpRequestInfo.httpStatusCode !== 200) {
        return false;
      }
      okPullResponse = pullResponse;
      return true;
    }, pullDescription);
    if (!pullSucceeded) {
      lc.debug?.(
        `Failed to recover mutations for client ${clientGroupID} due to a pull error.`
      );
      return;
    }
    assert(okPullResponse);
    lc.debug?.(
      `Client group ${selfClientGroupID} recovered mutations for client group ${clientGroupID}.  Details`,
      {
        mutationIDs: clientGroup.mutationIDs,
        lastServerAckdMutationIDs: clientGroup.lastServerAckdMutationIDs,
        lastMutationIDChanges: okPullResponse.lastMutationIDChanges
      }
    );
    return await withWrite(perdag, async (dagWrite) => {
      const clientGroups = await getClientGroups(dagWrite);
      const clientGroupToUpdate = clientGroups.get(clientGroupID);
      if (!clientGroupToUpdate) {
        return clientGroups;
      }
      assert(okPullResponse);
      const lastServerAckdMutationIDsUpdates = {};
      let anyMutationIDsUpdated = false;
      for (const [clientID2, lastMutationIDChange] of Object.entries(
        okPullResponse.lastMutationIDChanges
      )) {
        if ((clientGroupToUpdate.lastServerAckdMutationIDs[clientID2] ?? 0) < lastMutationIDChange) {
          lastServerAckdMutationIDsUpdates[clientID2] = lastMutationIDChange;
          anyMutationIDsUpdated = true;
        }
      }
      if (!anyMutationIDsUpdated) {
        return clientGroups;
      }
      const newClientGroups = new Map(clientGroups).set(clientGroupID, {
        ...clientGroupToUpdate,
        lastServerAckdMutationIDs: {
          ...clientGroupToUpdate.lastServerAckdMutationIDs,
          ...lastServerAckdMutationIDsUpdates
        }
      });
      await setClientGroups(newClientGroups, dagWrite);
      return newClientGroups;
    });
  } catch (e) {
    logMutationRecoveryError(e, lc, stepDescription, delegate);
  } finally {
    await lazyDagForOtherClientGroup.close();
    lc.debug?.("End:", stepDescription);
  }
  return;
}

// src/broadcast-channel.ts
var NoopBroadcastChannel = class {
  name;
  onmessage = null;
  onmessageerror = null;
  constructor(name) {
    this.name = name;
  }
  addEventListener() {
  }
  removeEventListener() {
  }
  dispatchEvent() {
    return false;
  }
  close() {
  }
  postMessage() {
  }
};
var bc = typeof BroadcastChannel === "undefined" ? NoopBroadcastChannel : BroadcastChannel;

// src/new-client-channel.ts
function makeChannelNameV0(replicacheName) {
  return `replicache-new-client-group:${replicacheName}`;
}
function makeChannelNameV1(replicacheName) {
  return `replicache-new-client-group-v1:${replicacheName}`;
}
function isNewClientChannelMessageV1(message) {
  return typeof message === "object" && typeof message.clientGroupID === "string" && typeof message.idbName === "string";
}
function initNewClientChannel(replicacheName, idbName, signal, clientGroupID, isNewClientGroup, onUpdateNeeded, perdag) {
  if (signal.aborted) {
    return;
  }
  const channelV1 = new bc(makeChannelNameV1(replicacheName));
  if (isNewClientGroup) {
    channelV1.postMessage({ clientGroupID, idbName });
    const channelV0 = new bc(makeChannelNameV0(replicacheName));
    channelV0.postMessage([clientGroupID]);
    channelV0.close();
  }
  channelV1.onmessage = async (e) => {
    const { data } = e;
    if (isNewClientChannelMessageV1(data)) {
      const { clientGroupID: newClientGroupID, idbName: newClientIDBName } = data;
      if (newClientGroupID !== clientGroupID) {
        if (newClientIDBName === idbName) {
          const updateNeeded = await withRead(
            perdag,
            async (perdagRead) => await getClientGroup(newClientGroupID, perdagRead) !== void 0
          );
          if (updateNeeded) {
            onUpdateNeeded();
          }
        } else {
          onUpdateNeeded();
          return;
        }
      }
    }
  };
  signal.addEventListener("abort", () => channelV1.close());
}

// src/on-persist-channel.ts
function makeChannelName(replicacheName) {
  return `replicache-on-persist:${replicacheName}`;
}
function assertPersistInfo(value) {
  assertObject2(value);
  assertString2(value.clientGroupID);
  assertString2(value.clientID);
}
function initOnPersistChannel(replicacheName, signal, handlePersist) {
  if (signal.aborted) {
    return () => void 0;
  }
  const channel = new bc(makeChannelName(replicacheName));
  channel.onmessage = (e) => {
    const { data } = e;
    assertPersistInfo(data);
    handlePersist({
      clientGroupID: data.clientGroupID,
      clientID: data.clientID
    });
  };
  signal.addEventListener("abort", () => {
    channel.close();
  });
  return (persistInfo) => {
    if (signal.aborted) {
      return;
    }
    channel.postMessage(persistInfo);
    handlePersist(persistInfo);
  };
}

// src/pending-mutations.ts
async function pendingMutationsForAPI(dagRead) {
  const mainHeadHash = await mustGetHeadHash(DEFAULT_HEAD_NAME, dagRead);
  const pending = await localMutationsDD31(mainHeadHash, dagRead);
  return pending.map((p) => ({
    id: p.meta.mutationID,
    name: p.meta.mutatorName,
    args: p.meta.mutatorArgsJSON,
    clientID: p.meta.clientID
  })).reverse();
}

// src/persist/client-gc.ts
var CLIENT_MAX_INACTIVE_IN_MS = 7 * 24 * 60 * 60 * 1e3;
var GC_INTERVAL_MS = 5 * 60 * 1e3;
var latestGCUpdate;
function initClientGC(clientID, dagStore, lc, signal) {
  initBgIntervalProcess(
    "ClientGC",
    () => {
      latestGCUpdate = gcClients(clientID, dagStore);
      return latestGCUpdate;
    },
    () => GC_INTERVAL_MS,
    lc,
    signal
  );
}
function gcClients(clientID, dagStore) {
  return withWrite(dagStore, async (dagWrite) => {
    const now = Date.now();
    const clients = await getClients(dagWrite);
    const clientsAfterGC = Array.from(clients).filter(
      ([id, client]) => id === clientID || now - client.heartbeatTimestampMs <= CLIENT_MAX_INACTIVE_IN_MS
    );
    if (clientsAfterGC.length === clients.size) {
      return clients;
    }
    const newClients = new Map(clientsAfterGC);
    await setClients(newClients, dagWrite);
    return newClients;
  });
}

// src/persist/client-group-gc.ts
var GC_INTERVAL_MS2 = 5 * 60 * 1e3;
var latestGCUpdate2;
function initClientGroupGC(dagStore, lc, signal) {
  initBgIntervalProcess(
    "ClientGroupGC",
    () => {
      latestGCUpdate2 = gcClientGroups(dagStore);
      return latestGCUpdate2;
    },
    () => GC_INTERVAL_MS2,
    lc,
    signal
  );
}
function gcClientGroups(dagStore) {
  return withWrite(dagStore, async (tx) => {
    const clients = await getClients(tx);
    const clientGroupIDs = /* @__PURE__ */ new Set();
    for (const client of clients.values()) {
      assertClientV6(client);
      clientGroupIDs.add(client.clientGroupID);
    }
    const clientGroups = /* @__PURE__ */ new Map();
    for (const [clientGroupID, clientGroup] of await getClientGroups(tx)) {
      if (clientGroupIDs.has(clientGroupID) || clientGroupHasPendingMutations(clientGroup)) {
        clientGroups.set(clientGroupID, clientGroup);
      }
    }
    await setClientGroups(clientGroups, tx);
    return clientGroups;
  });
}

// src/persist/heartbeat.ts
var HEARTBEAT_INTERVAL_MS = 60 * 1e3;
var latestHeartbeatUpdate;
function startHeartbeats(clientID, dagStore, onClientStateNotFound, lc, signal) {
  initBgIntervalProcess(
    "Heartbeat",
    async () => {
      latestHeartbeatUpdate = writeHeartbeat(clientID, dagStore);
      try {
        return await latestHeartbeatUpdate;
      } catch (e) {
        if (e instanceof ClientStateNotFoundError) {
          onClientStateNotFound();
          return;
        }
        throw e;
      }
    },
    () => HEARTBEAT_INTERVAL_MS,
    lc,
    signal
  );
}
function writeHeartbeat(clientID, dagStore) {
  return withWrite(dagStore, async (dagWrite) => {
    const clients = await getClients(dagWrite);
    const client = clients.get(clientID);
    if (!client) {
      throw new ClientStateNotFoundError(clientID);
    }
    const newClient = {
      ...client,
      heartbeatTimestampMs: Date.now()
    };
    const newClients = new Map(clients).set(clientID, newClient);
    await setClients(newClients, dagWrite);
    return newClients;
  });
}

// src/dag/visitor.ts
var Visitor = class {
  #seen = /* @__PURE__ */ new Set();
  #dagRead;
  constructor(dagRead) {
    this.#dagRead = dagRead;
  }
  async visit(h) {
    if (this.#seen.has(h)) {
      return;
    }
    this.#seen.add(h);
    const chunk = await this.#dagRead.mustGetChunk(h);
    await this.visitChunk(chunk);
  }
  async visitChunk(chunk) {
    await Promise.all(chunk.meta.map((ref) => this.visit(ref)));
  }
};

// src/persist/gather-mem-only-visitor.ts
var GatherMemoryOnlyVisitor = class extends Visitor {
  #gatheredChunks = /* @__PURE__ */ new Map();
  #lazyRead;
  constructor(dagRead) {
    super(dagRead);
    this.#lazyRead = dagRead;
  }
  get gatheredChunks() {
    return this.#gatheredChunks;
  }
  visit(h) {
    if (!this.#lazyRead.isMemOnlyChunkHash(h)) {
      return promiseVoid;
    }
    return super.visit(h);
  }
  visitChunk(chunk) {
    this.#gatheredChunks.set(chunk.hash, chunk);
    return super.visitChunk(chunk);
  }
};

// src/persist/persist.ts
async function persistDD31(lc, clientID, memdag, perdag, mutators, closed, formatVersion, onGatherMemOnlyChunksForTest = () => Promise.resolve()) {
  if (closed()) {
    return;
  }
  const [perdagLMID, perdagBaseSnapshot, mainClientGroupID] = await withRead(
    perdag,
    async (perdagRead) => {
      await assertHasClientState(clientID, perdagRead);
      const mainClientGroupID2 = await getClientGroupIDForClient(
        clientID,
        perdagRead
      );
      assert(
        mainClientGroupID2,
        `No main client group for clientID: ${clientID}`
      );
      const [, perdagMainClientGroupHeadCommit] = await getClientGroupInfo(
        perdagRead,
        mainClientGroupID2
      );
      const perdagLMID2 = await perdagMainClientGroupHeadCommit.getMutationID(
        clientID,
        perdagRead
      );
      const perdagBaseSnapshot2 = await baseSnapshotFromCommit(
        perdagMainClientGroupHeadCommit,
        perdagRead
      );
      assertSnapshotCommitDD31(perdagBaseSnapshot2);
      return [perdagLMID2, perdagBaseSnapshot2, mainClientGroupID2];
    }
  );
  if (closed()) {
    return;
  }
  const [newMemdagMutations, memdagBaseSnapshot, gatheredChunks] = await withRead(memdag, async (memdagRead) => {
    const memdagHeadCommit = await commitFromHead(
      DEFAULT_HEAD_NAME,
      memdagRead
    );
    const newMutations = await localMutationsGreaterThan(
      memdagHeadCommit,
      { [clientID]: perdagLMID || 0 },
      memdagRead
    );
    const memdagBaseSnapshot2 = await baseSnapshotFromCommit(
      memdagHeadCommit,
      memdagRead
    );
    assertSnapshotCommitDD31(memdagBaseSnapshot2);
    let gatheredChunks2;
    if (compareCookiesForSnapshots(memdagBaseSnapshot2, perdagBaseSnapshot) > 0) {
      await onGatherMemOnlyChunksForTest();
      const memdagBaseSnapshotHash = memdagBaseSnapshot2.chunk.hash;
      const visitor = new GatherMemoryOnlyVisitor(memdagRead);
      await visitor.visit(memdagBaseSnapshotHash);
      gatheredChunks2 = visitor.gatheredChunks;
    }
    return [newMutations, memdagBaseSnapshot2, gatheredChunks2];
  });
  if (closed()) {
    return;
  }
  let memdagBaseSnapshotPersisted = false;
  await withWrite(perdag, async (perdagWrite) => {
    const [mainClientGroup, latestPerdagMainClientGroupHeadCommit] = await getClientGroupInfo(perdagWrite, mainClientGroupID);
    let newMainClientGroupHeadHash = latestPerdagMainClientGroupHeadCommit.chunk.hash;
    let mutationIDs = {
      ...mainClientGroup.mutationIDs
    };
    let { lastServerAckdMutationIDs } = mainClientGroup;
    if (gatheredChunks) {
      const client = await mustGetClient(clientID, perdagWrite);
      assertClientV6(client);
      const latestPerdagBaseSnapshot = await baseSnapshotFromCommit(
        latestPerdagMainClientGroupHeadCommit,
        perdagWrite
      );
      assertSnapshotCommitDD31(latestPerdagBaseSnapshot);
      if (compareCookiesForSnapshots(
        memdagBaseSnapshot,
        latestPerdagBaseSnapshot
      ) > 0) {
        memdagBaseSnapshotPersisted = true;
        await Promise.all(
          Array.from(gatheredChunks.values(), (c) => perdagWrite.putChunk(c))
        );
        await setClient(
          clientID,
          {
            ...client,
            persistHash: memdagBaseSnapshot.chunk.hash
          },
          perdagWrite
        );
        newMainClientGroupHeadHash = memdagBaseSnapshot.chunk.hash;
        const mainClientGroupLocalMutations = await localMutationsDD31(
          mainClientGroup.headHash,
          perdagWrite
        );
        lastServerAckdMutationIDs = memdagBaseSnapshot.meta.lastMutationIDs;
        mutationIDs = { ...lastServerAckdMutationIDs };
        newMainClientGroupHeadHash = await rebase(
          mainClientGroupLocalMutations,
          newMainClientGroupHeadHash,
          perdagWrite,
          mutators,
          mutationIDs,
          lc,
          formatVersion
        );
      }
    }
    newMainClientGroupHeadHash = await rebase(
      newMemdagMutations,
      newMainClientGroupHeadHash,
      perdagWrite,
      mutators,
      mutationIDs,
      lc,
      formatVersion
    );
    const newMainClientGroup = {
      ...mainClientGroup,
      headHash: newMainClientGroupHeadHash,
      mutationIDs,
      lastServerAckdMutationIDs
    };
    await setClientGroup(mainClientGroupID, newMainClientGroup, perdagWrite);
  });
  if (gatheredChunks && memdagBaseSnapshotPersisted) {
    await withWrite(
      memdag,
      (memdagWrite) => memdagWrite.chunksPersisted([...gatheredChunks.keys()])
    );
  }
}
async function getClientGroupInfo(perdagRead, clientGroupID) {
  const clientGroup = await getClientGroup(clientGroupID, perdagRead);
  assert(clientGroup, `No client group for clientGroupID: ${clientGroupID}`);
  return [clientGroup, await commitFromHash(clientGroup.headHash, perdagRead)];
}
async function rebase(mutations, basis, write, mutators, mutationIDs, lc, formatVersion) {
  for (let i = mutations.length - 1; i >= 0; i--) {
    const mutationCommit = mutations[i];
    const { meta } = mutationCommit;
    const newMainHead = await commitFromHash(basis, write);
    if (await mutationCommit.getMutationID(meta.clientID, write) > await newMainHead.getMutationID(meta.clientID, write)) {
      mutationIDs[meta.clientID] = meta.mutationID;
      basis = (await rebaseMutationAndPutCommit(
        mutationCommit,
        write,
        basis,
        mutators,
        lc,
        meta.clientID,
        formatVersion
      )).chunk.hash;
    }
  }
  return basis;
}

// src/persist/gather-not-cached-visitor.ts
var GatherNotCachedVisitor = class extends Visitor {
  #gatheredChunks = /* @__PURE__ */ new Map();
  #gatheredChunksTotalSize = 0;
  #lazyStore;
  #gatherSizeLimit;
  #getSizeOfChunk;
  constructor(dagRead, lazyStore, gatherSizeLimit, getSizeOfChunk = getSizeOfValue) {
    super(dagRead);
    this.#lazyStore = lazyStore;
    this.#gatherSizeLimit = gatherSizeLimit;
    this.#getSizeOfChunk = getSizeOfChunk;
  }
  get gatheredChunks() {
    return this.#gatheredChunks;
  }
  visit(h) {
    if (this.#gatheredChunksTotalSize >= this.#gatherSizeLimit || this.#lazyStore.isCached(h)) {
      return promiseVoid;
    }
    return super.visit(h);
  }
  visitChunk(chunk) {
    if (this.#gatheredChunksTotalSize < this.#gatherSizeLimit) {
      const size = this.#getSizeOfChunk(chunk);
      this.#gatheredChunks.set(chunk.hash, { chunk, size });
      this.#gatheredChunksTotalSize += size;
    }
    return super.visitChunk(chunk);
  }
};

// src/persist/refresh.ts
var GATHER_SIZE_LIMIT = 5 * 2 ** 20;
var DELAY_MS = 300;
async function refresh(lc, memdag, perdag, clientID, mutators, diffConfig, closed, formatVersion) {
  if (closed()) {
    return;
  }
  const memdagBaseSnapshot = await withRead(
    memdag,
    (memdagRead) => baseSnapshotFromHead(DEFAULT_HEAD_NAME, memdagRead)
  );
  assertSnapshotCommitDD31(memdagBaseSnapshot);
  const result = await memdag.withSuspendedSourceCacheEvictsAndDeletes(async () => {
    const perdagWriteResult = await withWrite(
      perdag,
      async (perdagWrite) => {
        const clientGroup = await getClientGroupForClient(
          clientID,
          perdagWrite
        );
        if (!clientGroup) {
          throw new ClientStateNotFoundError(clientID);
        }
        const perdagClientGroupHeadHash2 = clientGroup.headHash;
        const perdagClientGroupHeadCommit = await commitFromHash(
          perdagClientGroupHeadHash2,
          perdagWrite
        );
        const perdagLmid2 = await perdagClientGroupHeadCommit.getMutationID(
          clientID,
          perdagWrite
        );
        const client = await mustGetClient(clientID, perdagWrite);
        assertClientV6(client);
        const perdagClientGroupBaseSnapshot2 = await baseSnapshotFromHash(
          perdagClientGroupHeadHash2,
          perdagWrite
        );
        assertSnapshotCommitDD31(perdagClientGroupBaseSnapshot2);
        if (shouldAbortRefresh(
          memdagBaseSnapshot,
          perdagClientGroupBaseSnapshot2,
          perdagClientGroupHeadHash2
        )) {
          return void 0;
        }
        const visitor = new GatherNotCachedVisitor(
          perdagWrite,
          memdag,
          GATHER_SIZE_LIMIT
        );
        await visitor.visit(perdagClientGroupHeadHash2);
        const { gatheredChunks: gatheredChunks2 } = visitor;
        const refreshHashesSet = new Set(client.refreshHashes);
        refreshHashesSet.add(perdagClientGroupHeadHash2);
        const newClient = {
          ...client,
          refreshHashes: [...refreshHashesSet]
        };
        await setClient(clientID, newClient, perdagWrite);
        return [
          perdagClientGroupHeadHash2,
          perdagClientGroupBaseSnapshot2,
          perdagLmid2,
          gatheredChunks2,
          client.refreshHashes
        ];
      }
    );
    if (closed() || !perdagWriteResult) {
      return {
        type: "aborted"
      };
    }
    await sleep(DELAY_MS);
    if (closed()) {
      return {
        type: "aborted"
      };
    }
    const [
      perdagClientGroupHeadHash,
      perdagClientGroupBaseSnapshot,
      perdagLmid,
      gatheredChunks,
      refreshHashesForRevert
    ] = perdagWriteResult;
    return withWrite(memdag, async (memdagWrite) => {
      const memdagHeadCommit = await commitFromHead(
        DEFAULT_HEAD_NAME,
        memdagWrite
      );
      const memdagBaseSnapshot2 = await baseSnapshotFromCommit(
        memdagHeadCommit,
        memdagWrite
      );
      assertSnapshotCommitDD31(memdagBaseSnapshot2);
      if (shouldAbortRefresh(
        memdagBaseSnapshot2,
        perdagClientGroupBaseSnapshot,
        perdagClientGroupHeadHash
      )) {
        return {
          type: "aborted",
          refreshHashesForRevert
        };
      }
      const newMemdagMutations = await localMutationsGreaterThan(
        memdagHeadCommit,
        { [clientID]: perdagLmid },
        memdagWrite
      );
      const ps = [];
      for (const { chunk, size } of gatheredChunks.values()) {
        ps.push(memdagWrite.putChunk(chunk, size));
      }
      await Promise.all(ps);
      let newMemdagHeadHash = perdagClientGroupHeadHash;
      for (let i = newMemdagMutations.length - 1; i >= 0; i--) {
        newMemdagHeadHash = (await rebaseMutationAndPutCommit(
          newMemdagMutations[i],
          memdagWrite,
          newMemdagHeadHash,
          mutators,
          lc,
          newMemdagMutations[i].meta.clientID,
          formatVersion
        )).chunk.hash;
      }
      const newMemdagHeadCommit = await commitFromHash(
        newMemdagHeadHash,
        memdagWrite
      );
      const diffs = await diffCommits(
        memdagHeadCommit,
        newMemdagHeadCommit,
        memdagWrite,
        diffConfig,
        formatVersion
      );
      await memdagWrite.setHead(DEFAULT_HEAD_NAME, newMemdagHeadHash);
      return {
        type: "complete",
        diffs,
        newPerdagClientHeadHash: perdagClientGroupHeadHash
      };
    });
  });
  if (closed()) {
    return;
  }
  const setRefreshHashes = (refreshHashes) => withWrite(perdag, async (perdagWrite) => {
    const client = await mustGetClient(clientID, perdagWrite);
    const newClient = {
      ...client,
      refreshHashes
    };
    await setClient(clientID, newClient, perdagWrite);
  });
  if (result.type === "aborted") {
    if (result.refreshHashesForRevert) {
      await setRefreshHashes(result.refreshHashesForRevert);
    }
    return void 0;
  }
  await setRefreshHashes([result.newPerdagClientHeadHash]);
  return result.diffs;
}
function shouldAbortRefresh(memdagBaseSnapshot, perdagClientGroupBaseSnapshot, perdagClientGroupHeadHash) {
  const baseSnapshotCookieCompareResult = compareCookiesForSnapshots(
    memdagBaseSnapshot,
    perdagClientGroupBaseSnapshot
  );
  return baseSnapshotCookieCompareResult > 0 || baseSnapshotCookieCompareResult === 0 && perdagClientGroupHeadHash === perdagClientGroupBaseSnapshot.chunk.hash;
}

// src/process-scheduler.ts
import { resolver as resolver5 } from "@rocicorp/resolver";

// src/request-idle.ts
function requestIdle(timeout) {
  return new Promise((resolve) => {
    if (typeof requestIdleCallback === "function") {
      requestIdleCallback(() => resolve(), { timeout });
    } else {
      setTimeout(() => resolve(), timeout);
    }
  });
}

// src/process-scheduler.ts
var ProcessScheduler = class {
  #process;
  #idleTimeoutMs;
  #throttleMs;
  #abortSignal;
  #requestIdle;
  #scheduledResolver = void 0;
  #runResolver = void 0;
  #runPromise = Promise.resolve();
  #throttlePromise = Promise.resolve();
  /**
   * Supports scheduling a `process` to be run with certain constraints.
   *  - Process runs are never concurrent.
   *  - Multiple calls to schedule will be fulfilled by a single process
   *    run started after the call to schedule.  A call is never fulfilled by an
   *    already running process run.  This can be thought of as debouncing.
   *  - Process runs are throttled so that the process runs at most once every
   *    `throttleMs`.
   *  - Process runs try to run during an idle period, but will delay at most
   *    `idleTimeoutMs`.
   *  - Scheduled runs which have not completed when `abortSignal` is aborted
   *    will reject with an `AbortError`.
   */
  constructor(process2, idleTimeoutMs, throttleMs, abortSignal, requestIdle2 = requestIdle) {
    this.#process = process2;
    this.#idleTimeoutMs = idleTimeoutMs;
    this.#throttleMs = throttleMs;
    this.#abortSignal = abortSignal;
    this.#requestIdle = requestIdle2;
    this.#abortSignal.addEventListener("abort", () => {
      const abortError = new AbortError("Aborted");
      this.#runResolver?.reject(abortError);
      this.#scheduledResolver?.reject(abortError);
      this.#runResolver = void 0;
      this.#scheduledResolver = void 0;
    });
  }
  schedule() {
    if (this.#abortSignal.aborted) {
      return Promise.reject(new AbortError("Aborted"));
    }
    if (this.#scheduledResolver) {
      return this.#scheduledResolver.promise;
    }
    this.#scheduledResolver = resolver5();
    void this.#scheduleInternal();
    return this.#scheduledResolver.promise;
  }
  async #scheduleInternal() {
    try {
      await this.#runPromise;
    } catch (e) {
    }
    await this.#throttlePromise;
    if (!this.#scheduledResolver) {
      return;
    }
    await this.#requestIdle(this.#idleTimeoutMs);
    if (!this.#scheduledResolver) {
      return;
    }
    this.#throttlePromise = throttle(this.#throttleMs, this.#abortSignal);
    this.#runResolver = this.#scheduledResolver;
    this.#scheduledResolver = void 0;
    try {
      this.#runPromise = this.#process();
      await this.#runPromise;
      this.#runResolver?.resolve();
    } catch (e) {
      this.#runResolver?.reject(e);
    }
    this.#runResolver = void 0;
  }
};
async function throttle(timeMs, abortSignal) {
  try {
    await sleep(timeMs, abortSignal);
  } catch (e) {
    assert(e instanceof AbortError);
  }
}

// src/set-interval-with-signal.ts
function setIntervalWithSignal(fn, ms, signal) {
  const interval = setInterval(fn, ms);
  signal.addEventListener("abort", () => {
    clearInterval(interval);
  });
}

// src/simple-fetch.ts
async function mustSimpleFetch(method, url, body, headers) {
  const resp = await fetch(url, { method, body, headers });
  if (!resp.ok) {
    throw new Error(`Got ${resp.status} fetching ${url}: ${await resp.text()}`);
  }
  return resp;
}

// src/subscriptions.ts
var emptySet = /* @__PURE__ */ new Set();
var unitializedLastValue = Symbol();
var SubscriptionImpl = class {
  #body;
  #onData;
  #lastValue = unitializedLastValue;
  #keys = emptySet;
  #scans = [];
  onError;
  onDone;
  #isEqual;
  constructor(body, onData, onError, onDone, isEqual = deepEqual) {
    this.#body = body;
    this.#onData = onData;
    this.onError = onError;
    this.onDone = onDone;
    this.#isEqual = isEqual;
  }
  hasIndexSubscription(indexName) {
    for (const scan2 of this.#scans) {
      if (scan2.options.indexName === indexName) {
        return true;
      }
    }
    return false;
  }
  invoke(tx, _kind, _diffs) {
    return this.#body(tx);
  }
  matches(diffs) {
    for (const [indexName, diff2] of diffs) {
      if (diffMatchesSubscription(this.#keys, this.#scans, indexName, diff2)) {
        return true;
      }
    }
    return false;
  }
  updateDeps(keys, scans) {
    this.#keys = keys;
    this.#scans = scans;
  }
  onData(result) {
    if (this.#lastValue === unitializedLastValue || !this.#isEqual(this.#lastValue, result)) {
      this.#lastValue = result;
      this.#onData(result);
    }
  }
};
var WatchSubscription = class {
  #callback;
  #prefix;
  #indexName;
  #initialValuesInFirstDiff;
  onError = void 0;
  onDone = void 0;
  constructor(callback, options) {
    this.#callback = callback;
    this.#prefix = options?.prefix ?? "";
    this.#indexName = options?.indexName;
    this.#initialValuesInFirstDiff = options?.initialValuesInFirstDiff ?? false;
  }
  hasIndexSubscription(indexName) {
    return this.#indexName === indexName;
  }
  onData(result) {
    if (result !== void 0) {
      this.#callback(result);
    }
  }
  invoke(tx, kind, diffs) {
    const invoke = async (indexName, prefix, compareKey, convertInternalDiff) => {
      let diff2;
      if (kind === 0 /* InitialRun */) {
        if (!this.#initialValuesInFirstDiff) {
          return void 0;
        }
        assert(diffs === void 0);
        const newDiff2 = [];
        for await (const entry of tx.scan({ prefix, indexName }).entries()) {
          newDiff2.push({
            op: "add",
            key: entry[0],
            newValue: entry[1]
          });
        }
        diff2 = newDiff2;
      } else {
        assert(diffs);
        const maybeDiff = diffs.get(indexName ?? "") ?? [];
        diff2 = convertInternalDiff(maybeDiff);
      }
      const newDiff = [];
      const { length } = diff2;
      for (let i = diffBinarySearch(diff2, prefix, compareKey); i < length; i++) {
        if (compareKey(diff2[i]).startsWith(prefix)) {
          newDiff.push(diff2[i]);
        } else {
          break;
        }
      }
      return kind === 0 /* InitialRun */ || newDiff.length > 0 ? newDiff : void 0;
    };
    if (this.#indexName) {
      return invoke(
        this.#indexName,
        this.#prefix,
        (diff2) => diff2.key[0],
        (internalDiff) => convertDiffValues(internalDiff, decodeIndexKey)
      );
    }
    return invoke(
      void 0,
      this.#prefix,
      (diff2) => diff2.key,
      (internalDiff) => convertDiffValues(internalDiff, (k) => k)
    );
  }
  matches(diffs) {
    const diff2 = diffs.get(this.#indexName ?? "");
    if (diff2 === void 0) {
      return false;
    }
    return watcherMatchesDiff(diff2, this.#prefix, this.#indexName);
  }
  updateDeps(_keys, _scans) {
  }
};
function convertDiffValues(diff2, convertKey) {
  return diff2.map((op) => {
    const key = convertKey(op.key);
    switch (op.op) {
      case "add":
        return {
          op: "add",
          key,
          newValue: op.newValue
        };
      case "change":
        return {
          op: "change",
          key,
          oldValue: op.oldValue,
          newValue: op.newValue
        };
      case "del":
        return {
          op: "del",
          key,
          oldValue: op.oldValue
        };
    }
  });
}
var SubscriptionsManagerImpl = class {
  #subscriptions = /* @__PURE__ */ new Set();
  #pendingSubscriptions = /* @__PURE__ */ new Set();
  #queryInternal;
  #lc;
  hasPendingSubscriptionRuns = false;
  constructor(queryInternal, lc) {
    this.#queryInternal = queryInternal;
    this.#lc = lc;
  }
  add(subscription) {
    this.#subscriptions.add(subscription);
    void this.#scheduleInitialSubscriptionRun(
      subscription
    );
    return () => this.#subscriptions.delete(subscription);
  }
  clear() {
    for (const subscription of this.#subscriptions) {
      subscription.onDone?.();
    }
    this.#subscriptions.clear();
  }
  async fire(diffs) {
    const subscriptions = subscriptionsForDiffs(this.#subscriptions, diffs);
    await this.#fireSubscriptions(subscriptions, 1 /* Regular */, diffs);
  }
  async #fireSubscriptions(subscriptions, kind, diffs) {
    const subs = [...subscriptions];
    if (subs.length === 0) {
      return;
    }
    const results = await this.#queryInternal(
      (tx) => Promise.allSettled(
        subs.map(async (s) => {
          const stx = new SubscriptionTransactionWrapper(tx);
          try {
            return await s.invoke(stx, kind, diffs);
          } finally {
            s.updateDeps(stx.keys, stx.scans);
          }
        })
      )
    );
    this.callCallbacks(subs, results);
  }
  // Public method so that ZQL can wrap it in a transaction.
  callCallbacks(subs, results) {
    for (let i = 0; i < subs.length; i++) {
      const s = subs[i];
      const result = results[i];
      if (result.status === "fulfilled") {
        s.onData(result.value);
      } else {
        if (s.onError) {
          s.onError(result.reason);
        } else {
          this.#lc.error?.("Error in subscription body:", result.reason);
        }
      }
    }
  }
  async #scheduleInitialSubscriptionRun(s) {
    this.#pendingSubscriptions.add(s);
    if (!this.hasPendingSubscriptionRuns) {
      this.hasPendingSubscriptionRuns = true;
      await Promise.resolve();
      this.hasPendingSubscriptionRuns = false;
      const subscriptions = [...this.#pendingSubscriptions];
      this.#pendingSubscriptions.clear();
      await this.#fireSubscriptions(
        subscriptions,
        0 /* InitialRun */,
        void 0
      );
    }
  }
  shouldComputeDiffs() {
    return this.#subscriptions.size > 0;
  }
  shouldComputeDiffsForIndex(indexName) {
    for (const s of this.#subscriptions) {
      if (s.hasIndexSubscription(indexName)) {
        return true;
      }
    }
    return false;
  }
};
function diffMatchesSubscription(keys, scans, indexName, diff2) {
  if (indexName === "") {
    for (const diffEntry of diff2) {
      if (keys.has(diffEntry.key)) {
        return true;
      }
    }
  }
  for (const scanInfo of scans) {
    if (scanInfoMatchesDiff(scanInfo, indexName, diff2)) {
      return true;
    }
  }
  return false;
}
function scanInfoMatchesDiff(scanInfo, changeIndexName, diff2) {
  for (const diffEntry of diff2) {
    if (scanInfoMatchesKey(scanInfo, changeIndexName, diffEntry.key)) {
      return true;
    }
  }
  return false;
}
function scanInfoMatchesKey(scanInfo, changeIndexName, changedKey) {
  const {
    indexName = "",
    limit,
    prefix,
    startKey,
    startExclusive,
    startSecondaryKey
  } = scanInfo.options;
  if (changeIndexName !== indexName) {
    return false;
  }
  if (!indexName) {
    if (limit !== void 0 && limit <= 0) {
      return false;
    }
    if (!prefix && !startKey) {
      return true;
    }
    if (prefix && (!changedKey.startsWith(prefix) || isKeyPastInclusiveLimit(scanInfo, changedKey))) {
      return false;
    }
    if (startKey && (startExclusive && lessThanEq(changedKey, startKey) || lessThan(changedKey, startKey) || isKeyPastInclusiveLimit(scanInfo, changedKey))) {
      return false;
    }
    return true;
  }
  if (!prefix && !startKey && !startSecondaryKey) {
    return true;
  }
  const [changedKeySecondary, changedKeyPrimary] = decodeIndexKey(changedKey);
  if (prefix) {
    if (!changedKeySecondary.startsWith(prefix)) {
      return false;
    }
  }
  if (startSecondaryKey && (startExclusive && lessThanEq(changedKeySecondary, startSecondaryKey) || lessThan(changedKeySecondary, startSecondaryKey))) {
    return false;
  }
  if (startKey && (startExclusive && lessThanEq(changedKeyPrimary, startKey) || lessThan(changedKeyPrimary, startKey))) {
    return false;
  }
  return true;
}
function isKeyPastInclusiveLimit(scanInfo, changedKey) {
  const { inclusiveLimitKey } = scanInfo;
  return scanInfo.options.limit !== void 0 && inclusiveLimitKey !== void 0 && greaterThan(changedKey, inclusiveLimitKey);
}
function* subscriptionsForDiffs(subscriptions, diffs) {
  for (const subscription of subscriptions) {
    if (subscription.matches(diffs)) {
      yield subscription;
    }
  }
}
function watcherMatchesDiff(diff2, prefix, indexName) {
  if (prefix === "") {
    return true;
  }
  const compareKey = indexName ? (diffOp) => decodeIndexKey(diffOp.key)[0] : (diffOp) => diffOp.key;
  const i = diffBinarySearch(diff2, prefix, compareKey);
  return i < diff2.length && compareKey(diff2[i]).startsWith(prefix);
}
function diffBinarySearch(diff2, prefix, compareKey) {
  return binarySearch(
    diff2.length,
    (i) => compareUTF8(prefix, compareKey(diff2[i]))
  );
}

// src/sync/request-id.ts
var sessionID = "";
function getSessionID() {
  if (sessionID === "") {
    const buf = new Uint8Array(4);
    crypto.getRandomValues(buf);
    sessionID = Array.from(buf, (x) => x.toString(16)).join("");
  }
  return sessionID;
}
var REQUEST_COUNTERS = /* @__PURE__ */ new Map();
function newRequestID(clientID) {
  let counter = REQUEST_COUNTERS.get(clientID);
  if (!counter) {
    REQUEST_COUNTERS.set(clientID, 0);
    counter = 0;
  } else {
    counter++;
    REQUEST_COUNTERS.set(clientID, counter);
  }
  return `${clientID}-${getSessionID()}-${counter}`;
}

// src/version.ts
var version = "15.0.1";

// src/replicache-impl.ts
var MAX_REAUTH_TRIES = 8;
var PERSIST_IDLE_TIMEOUT_MS = 1e3;
var REFRESH_IDLE_TIMEOUT_MS = 1e3;
var PERSIST_THROTTLE_MS = 500;
var REFRESH_THROTTLE_MS = 500;
var LAZY_STORE_SOURCE_CHUNK_CACHE_SIZE_LIMIT = 100 * 2 ** 20;
var RECOVER_MUTATIONS_INTERVAL_MS = 5 * 60 * 1e3;
var LICENSE_ACTIVE_INTERVAL_MS = 24 * 60 * 60 * 1e3;
var TEST_LICENSE_KEY_TTL_MS = 5 * 60 * 1e3;
var noop2 = () => {
};
var updateNeededReasonNewClientGroup = {
  type: "NewClientGroup"
};
var defaultMakeSubscriptionsManager = (queryInternal, lc) => new SubscriptionsManagerImpl(queryInternal, lc);
var ReplicacheImpl = class {
  /** The URL to use when doing a pull request. */
  pullURL;
  /** The URL to use when doing a push request. */
  pushURL;
  /** The authorization token used when doing a push request. */
  auth;
  /** The name of the Replicache database. Populated by {@link ReplicacheOptions#name}. */
  name;
  subscriptions;
  #mutationRecovery;
  /**
   * Client groups gets disabled when the server does not know about it.
   * A disabled client group prevents the client from pushing and pulling.
   */
  isClientGroupDisabled = false;
  #kvStoreProvider;
  lastMutationID = 0;
  /**
   * This is the name Replicache uses for the IndexedDB database where data is
   * stored.
   */
  get idbName() {
    return makeIDBName(this.name, this.schemaVersion);
  }
  /** The schema version of the data understood by this application. */
  schemaVersion;
  get #idbDatabase() {
    return {
      name: this.idbName,
      replicacheName: this.name,
      replicacheFormatVersion: 7 /* Latest */,
      schemaVersion: this.schemaVersion
    };
  }
  #closed = false;
  #online = true;
  #clientID = uuid();
  #ready;
  #profileIDPromise;
  #clientGroupIDPromise;
  licenseCheckPromise;
  /* The license is active if we have sent at least one license active ping
   * (and we will continue to). We do not send license active pings when
   * for the TEST_LICENSE_KEY.
   */
  licenseActivePromise;
  #testLicenseKeyTimeout = null;
  #mutatorRegistry = {};
  /**
   * The mutators that was registered in the constructor.
   */
  mutate;
  // Number of pushes/pulls at the moment.
  #pushCounter = 0;
  #pullCounter = 0;
  #pullConnectionLoop;
  #pushConnectionLoop;
  /**
   * The duration between each periodic {@link pull}. Setting this to `null`
   * disables periodic pull completely. Pull will still happen if you call
   * {@link pull} manually.
   */
  pullInterval;
  /**
   * The delay between when a change is made to Replicache and when Replicache
   * attempts to push that change.
   */
  pushDelay;
  #requestOptions;
  /**
   * The function to use to pull data from the server.
   */
  puller;
  /**
   * The function to use to push data to the server.
   */
  pusher;
  #licenseKey;
  memdag;
  perdag;
  #idbDatabases;
  #lc;
  #closeAbortController = new AbortController();
  #persistIsRunning = false;
  #enableScheduledPersist;
  #enableScheduledRefresh;
  #enablePullAndPushInOpen;
  #persistScheduler = new ProcessScheduler(
    () => this.persist(),
    PERSIST_IDLE_TIMEOUT_MS,
    PERSIST_THROTTLE_MS,
    this.#closeAbortController.signal
  );
  #onPersist;
  #refreshScheduler = new ProcessScheduler(
    () => this.refresh(),
    REFRESH_IDLE_TIMEOUT_MS,
    REFRESH_THROTTLE_MS,
    this.#closeAbortController.signal
  );
  #enableLicensing;
  /**
   * The options used to control the {@link pull} and push request behavior. This
   * object is live so changes to it will affect the next pull or push call.
   */
  get requestOptions() {
    return this.#requestOptions;
  }
  /**
   * `onSync(true)` is called when Replicache transitions from no push or pull
   * happening to at least one happening. `onSync(false)` is called in the
   * opposite case: when Replicache transitions from at least one push or pull
   * happening to none happening.
   *
   * This can be used in a React like app by doing something like the following:
   *
   * ```js
   * const [syncing, setSyncing] = useState(false);
   * useEffect(() => {
   *   rep.onSync = setSyncing;
   * }, [rep]);
   * ```
   */
  onSync = null;
  /**
   * `onClientStateNotFound` is called when the persistent client has been
   * garbage collected. This can happen if the client has no pending mutations
   * and has not been used for a while.
   *
   * The default behavior is to reload the page (using `location.reload()`). Set
   * this to `null` or provide your own function to prevent the page from
   * reloading automatically.
   */
  onClientStateNotFound = reload;
  /**
   * `onUpdateNeeded` is called when a code update is needed.
   *
   * A code update can be needed because:
   * - the server no longer supports the {@link pushVersion},
   *   {@link pullVersion} or {@link schemaVersion} of the current code.
   * - a new Replicache client has created a new client group, because its code
   *   has different mutators, indexes, schema version and/or format version
   *   from this Replicache client. This is likely due to the new client having
   *   newer code. A code update is needed to be able to locally sync with this
   *   new Replicache client (i.e. to sync while offline, the clients can can
   *   still sync with each other via the server).
   *
   * The default behavior is to reload the page (using `location.reload()`). Set
   * this to `null` or provide your own function to prevent the page from
   * reloading automatically. You may want to provide your own function to
   * display a toast to inform the end user there is a new version of your app
   * available and prompting them to refresh.
   */
  onUpdateNeeded = reload;
  /**
   * This gets called when we get an HTTP unauthorized (401) response from the
   * push or pull endpoint. Set this to a function that will ask your user to
   * reauthenticate.
   */
  getAuth = null;
  // These three are used for testing
  onPushInvoked = () => void 0;
  onBeginPull = () => void 0;
  onRecoverMutations = (r) => r;
  constructor(options, implOptions = {}) {
    const {
      name,
      logLevel = "info",
      logSinks = [consoleLogSink2],
      pullURL = "",
      auth,
      pushDelay = 10,
      pushURL = "",
      schemaVersion = "",
      pullInterval = 6e4,
      mutators = {},
      requestOptions = {},
      puller,
      pusher,
      licenseKey,
      indexes = {}
    } = options;
    const {
      enableMutationRecovery = true,
      enableLicensing = true,
      enableScheduledPersist = true,
      enableScheduledRefresh = true,
      enablePullAndPushInOpen = true,
      makeSubscriptionsManager = defaultMakeSubscriptionsManager,
      enableClientGroupForking = true
    } = implOptions;
    this.auth = auth ?? "";
    this.pullURL = pullURL;
    this.pushURL = pushURL;
    if (typeof name !== "string" || !name) {
      throw new TypeError("name is required and must be non-empty");
    }
    this.name = name;
    this.schemaVersion = schemaVersion;
    this.pullInterval = pullInterval;
    this.pushDelay = pushDelay;
    this.puller = puller ?? getDefaultPuller(this);
    this.pusher = pusher ?? getDefaultPusher(this);
    this.#enableLicensing = enableLicensing;
    this.#enableScheduledPersist = enableScheduledPersist;
    this.#enableScheduledRefresh = enableScheduledRefresh;
    this.#enablePullAndPushInOpen = enablePullAndPushInOpen;
    this.#lc = createLogContext(logLevel, logSinks, { name });
    this.#lc.debug?.("Constructing Replicache", {
      name,
      "replicache version": version
    });
    this.subscriptions = makeSubscriptionsManager(
      this.#queryInternal,
      this.#lc
    );
    const kvStoreProvider = getKVStoreProvider(this.#lc, options.kvStore);
    this.#kvStoreProvider = kvStoreProvider;
    const perKVStore = kvStoreProvider.create(this.idbName);
    this.#idbDatabases = new IDBDatabasesStore(kvStoreProvider.create);
    this.perdag = new StoreImpl(perKVStore, newUUIDHash, assertHash);
    this.memdag = new LazyStore(
      this.perdag,
      LAZY_STORE_SOURCE_CHUNK_CACHE_SIZE_LIMIT,
      newUUIDHash,
      assertHash
    );
    const readyResolver = resolver6();
    this.#ready = readyResolver.promise;
    this.#licenseKey = licenseKey;
    const licenseCheckResolver = resolver6();
    this.licenseCheckPromise = licenseCheckResolver.promise;
    const licenseActiveResolver = resolver6();
    this.licenseActivePromise = licenseActiveResolver.promise;
    const { minDelayMs = MIN_DELAY_MS, maxDelayMs = MAX_DELAY_MS } = requestOptions;
    this.#requestOptions = { maxDelayMs, minDelayMs };
    const visibilityWatcher = getDocumentVisibilityWatcher(
      getDocument(),
      0,
      this.#closeAbortController.signal
    );
    this.#pullConnectionLoop = new ConnectionLoop(
      this.#lc.withContext("PULL"),
      new PullDelegate(this, () => this.#invokePull()),
      visibilityWatcher
    );
    this.#pushConnectionLoop = new ConnectionLoop(
      this.#lc.withContext("PUSH"),
      new PushDelegate(this, () => this.#invokePush())
    );
    this.mutate = this.#registerMutators(mutators);
    const profileIDResolver = resolver6();
    this.#profileIDPromise = profileIDResolver.promise;
    const clientGroupIDResolver = resolver6();
    this.#clientGroupIDPromise = clientGroupIDResolver.promise;
    this.#mutationRecovery = new MutationRecovery({
      delegate: this,
      lc: this.#lc,
      enableMutationRecovery,
      wrapInOnlineCheck: this.#wrapInOnlineCheck.bind(this),
      wrapInReauthRetries: this.#wrapInReauthRetries.bind(this),
      isPullDisabled: this.#isPullDisabled.bind(this),
      isPushDisabled: this.#isPushDisabled.bind(this),
      clientGroupIDPromise: this.#clientGroupIDPromise
    });
    this.#onPersist = initOnPersistChannel(
      this.name,
      this.#closeAbortController.signal,
      (persistInfo) => {
        void this.#handlePersist(persistInfo);
      }
    );
    void this.#open(
      indexes,
      enableClientGroupForking,
      profileIDResolver.resolve,
      clientGroupIDResolver.resolve,
      readyResolver.resolve,
      licenseCheckResolver.resolve,
      licenseActiveResolver.resolve
    );
  }
  async #open(indexes, enableClientGroupForking, profileIDResolver, resolveClientGroupID, resolveReady, resolveLicenseCheck, resolveLicenseActive) {
    const { clientID } = this;
    await closingInstances.get(this.name);
    await this.#idbDatabases.getProfileID().then(profileIDResolver);
    await this.#idbDatabases.putDatabase(this.#idbDatabase);
    const [client, headHash, clients, isNewClientGroup] = await initClientV6(
      clientID,
      this.#lc,
      this.perdag,
      Object.keys(this.#mutatorRegistry),
      indexes,
      7 /* Latest */,
      enableClientGroupForking
    );
    resolveClientGroupID(client.clientGroupID);
    await withWrite(
      this.memdag,
      (write) => write.setHead(DEFAULT_HEAD_NAME, headHash)
    );
    resolveReady();
    await this.#licenseCheck(resolveLicenseCheck);
    if (this.#enablePullAndPushInOpen) {
      void this.pull().catch(noop2);
      void this.push().catch(noop2);
    }
    const { signal } = this.#closeAbortController;
    startHeartbeats(
      clientID,
      this.perdag,
      () => {
        this.#clientStateNotFoundOnClient(clientID);
      },
      this.#lc,
      signal
    );
    initClientGC(clientID, this.perdag, this.#lc, signal);
    initCollectIDBDatabases(
      this.#idbDatabases,
      this.#lc,
      signal,
      this.#kvStoreProvider.drop
    );
    initClientGroupGC(this.perdag, this.#lc, signal);
    initNewClientChannel(
      this.name,
      this.idbName,
      signal,
      client.clientGroupID,
      isNewClientGroup,
      () => {
        this.#fireOnUpdateNeeded(updateNeededReasonNewClientGroup);
      },
      this.perdag
    );
    setIntervalWithSignal(
      () => this.recoverMutations(),
      RECOVER_MUTATIONS_INTERVAL_MS,
      signal
    );
    void this.recoverMutations(clients);
    getDocument()?.addEventListener(
      "visibilitychange",
      this.#onVisibilityChange
    );
    await this.#startLicenseActive(resolveLicenseActive, this.#lc, signal);
  }
  #onVisibilityChange = async () => {
    if (this.#closed) {
      return;
    }
    if (getDocument()?.visibilityState !== "visible") {
      return;
    }
    await this.#checkForClientStateNotFoundAndCallHandler();
  };
  async #checkForClientStateNotFoundAndCallHandler() {
    const { clientID } = this;
    const hasClientState2 = await withRead(
      this.perdag,
      (read) => hasClientState(clientID, read)
    );
    if (!hasClientState2) {
      this.#clientStateNotFoundOnClient(clientID);
    }
    return !hasClientState2;
  }
  async #licenseCheck(resolveLicenseCheck) {
    if (!this.#enableLicensing) {
      resolveLicenseCheck(true);
      return;
    }
    if (!this.#licenseKey) {
      await this.#licenseInvalid(
        this.#lc,
        `license key ReplicacheOptions.licenseKey is not set`,
        true,
        resolveLicenseCheck
      );
      return;
    }
    this.#lc.debug?.(`Replicache license key: ${this.#licenseKey}`);
    if (this.#licenseKey === TEST_LICENSE_KEY) {
      this.#lc.info?.(
        `Skipping license check for TEST_LICENSE_KEY. You may ONLY use this key for automated (e.g., unit/CI) testing. See https://replicache.dev for more information.`
      );
      resolveLicenseCheck(true);
      this.#testLicenseKeyTimeout = setTimeout(async () => {
        await this.#licenseInvalid(
          this.#lc,
          "Test key expired",
          true,
          resolveLicenseCheck
        );
      }, TEST_LICENSE_KEY_TTL_MS);
      return;
    }
    try {
      const resp = await getLicenseStatus(
        mustSimpleFetch,
        PROD_LICENSE_SERVER_URL2,
        this.#licenseKey,
        this.#lc
      );
      if (resp.pleaseUpdate) {
        this.#lc.error?.(
          `You are using an old version of Replicache that uses deprecated licensing features. Please update Replicache else it may stop working.`
        );
      }
      if (resp.status === "VALID" /* Valid */) {
        this.#lc.debug?.(`License is valid.`);
      } else {
        await this.#licenseInvalid(
          this.#lc,
          `status: ${resp.status}`,
          resp.disable,
          resolveLicenseCheck
        );
        return;
      }
    } catch (err2) {
      this.#lc.error?.(`Error checking license: ${err2}`);
    }
    resolveLicenseCheck(true);
  }
  async #licenseInvalid(lc, reason, disable, resolveLicenseCheck) {
    lc.error?.(
      `** REPLICACHE LICENSE NOT VALID ** Replicache license key '${this.#licenseKey}' is not valid (${reason}). Please run 'npx replicache get-license' to get a license key or contact hello@replicache.dev for help.`
    );
    if (disable) {
      await this.close();
      lc.error?.(`** REPLICACHE DISABLED **`);
    }
    resolveLicenseCheck(false);
    return;
  }
  async #startLicenseActive(resolveLicenseActive, lc, signal) {
    if (!this.#enableLicensing || !this.#licenseKey || this.#licenseKey === TEST_LICENSE_KEY) {
      resolveLicenseActive(false);
      return;
    }
    const markActive = async () => {
      try {
        await licenseActive(
          mustSimpleFetch,
          PROD_LICENSE_SERVER_URL2,
          this.#licenseKey,
          await this.profileID,
          lc
        );
      } catch (err2) {
        this.#lc.info?.(`Error sending license active ping: ${err2}`);
      }
    };
    await markActive();
    resolveLicenseActive(true);
    initBgIntervalProcess(
      "LicenseActive",
      markActive,
      () => LICENSE_ACTIVE_INTERVAL_MS,
      lc,
      signal
    );
  }
  /**
   * The browser profile ID for this browser profile. Every instance of Replicache
   * browser-profile-wide shares the same profile ID.
   */
  get profileID() {
    return this.#profileIDPromise;
  }
  /**
   * The client ID for this instance of Replicache. Each instance of Replicache
   * gets a unique client ID.
   */
  get clientID() {
    return this.#clientID;
  }
  /**
   * The client group ID for this instance of Replicache. Instances of
   * Replicache will have the same client group ID if and only if they have
   * the same name, mutators, indexes, schema version, format version, and
   * browser profile.
   */
  get clientGroupID() {
    return this.#clientGroupIDPromise;
  }
  /**
   * `onOnlineChange` is called when the {@link online} property changes. See
   * {@link online} for more details.
   */
  onOnlineChange = null;
  /**
   * A rough heuristic for whether the client is currently online. Note that
   * there is no way to know for certain whether a client is online - the next
   * request can always fail. This property returns true if the last sync attempt succeeded,
   * and false otherwise.
   */
  get online() {
    return this.#online;
  }
  /**
   * Whether the Replicache database has been closed. Once Replicache has been
   * closed it no longer syncs and you can no longer read or write data out of
   * it. After it has been closed it is pretty much useless and should not be
   * used any more.
   */
  get closed() {
    return this.#closed;
  }
  /**
   * Closes this Replicache instance.
   *
   * When closed all subscriptions end and no more read or writes are allowed.
   */
  async close() {
    this.#closed = true;
    const { promise, resolve } = resolver6();
    closingInstances.set(this.name, promise);
    this.#closeAbortController.abort();
    getDocument()?.removeEventListener(
      "visibilitychange",
      this.#onVisibilityChange
    );
    await this.#ready;
    const closingPromises = [
      this.memdag.close(),
      this.perdag.close(),
      this.#idbDatabases.close()
    ];
    this.#pullConnectionLoop.close();
    this.#pushConnectionLoop.close();
    this.subscriptions.clear();
    if (this.#testLicenseKeyTimeout) {
      clearTimeout(this.#testLicenseKeyTimeout);
    }
    await Promise.all(closingPromises);
    closingInstances.delete(this.name);
    resolve();
  }
  async maybeEndPull(syncHead, requestID) {
    for (; ; ) {
      if (this.#closed) {
        return;
      }
      await this.#ready;
      const { clientID } = this;
      const lc = this.#lc.withContext("maybeEndPull").withContext("requestID", requestID);
      const { replayMutations, diffs } = await maybeEndPull(
        this.memdag,
        lc,
        syncHead,
        clientID,
        this.subscriptions,
        7 /* Latest */
      );
      if (!replayMutations || replayMutations.length === 0) {
        await this.subscriptions.fire(diffs);
        void this.#schedulePersist();
        return;
      }
      for (const mutation of replayMutations) {
        if (this.subscriptions.hasPendingSubscriptionRuns) {
          await Promise.resolve();
        }
        const { meta } = mutation;
        syncHead = await withWriteNoImplicitCommit(
          this.memdag,
          (dagWrite) => rebaseMutationAndCommit(
            mutation,
            dagWrite,
            syncHead,
            SYNC_HEAD_NAME,
            this.#mutatorRegistry,
            lc,
            isLocalMetaDD31(meta) ? meta.clientID : clientID,
            7 /* Latest */
          )
        );
      }
    }
  }
  #invokePull() {
    if (this.#isPullDisabled()) {
      return Promise.resolve(true);
    }
    return this.#wrapInOnlineCheck(async () => {
      try {
        this.#changeSyncCounters(0, 1);
        const { syncHead, requestID, ok: ok2 } = await this.beginPull();
        if (!ok2) {
          return false;
        }
        if (syncHead !== emptyHash) {
          await this.maybeEndPull(syncHead, requestID);
        }
      } catch (e) {
        throw await this.#convertToClientStateNotFoundError(e);
      } finally {
        this.#changeSyncCounters(0, -1);
      }
      return true;
    }, "Pull");
  }
  #isPullDisabled() {
    return this.isClientGroupDisabled || this.pullURL === "" && isDefaultPuller(this.puller);
  }
  async #wrapInOnlineCheck(f, name) {
    let online = true;
    try {
      return await f();
    } catch (e) {
      if (e instanceof PushError || e instanceof PullError) {
        online = false;
        this.#lc.debug?.(`${name} threw:
`, e, "\nwith cause:\n", e.causedBy);
      } else if (e instanceof ReportError) {
        this.#lc.error?.(e);
      } else {
        this.#lc.info?.(`${name} threw:
`, e);
      }
      return false;
    } finally {
      if (this.#online !== online) {
        this.#online = online;
        this.onOnlineChange?.(online);
        if (online) {
          void this.recoverMutations();
        }
      }
    }
  }
  async #wrapInReauthRetries(f, verb, lc, preAuth = noop2, postAuth = noop2) {
    const { clientID } = this;
    let reauthAttempts = 0;
    let lastResult;
    lc = lc.withContext(verb);
    do {
      const requestID = newRequestID(clientID);
      const requestLc = lc.withContext("requestID", requestID);
      const { httpRequestInfo, result } = await f(requestID, requestLc);
      lastResult = result;
      if (!httpRequestInfo) {
        return {
          result,
          authFailure: false
        };
      }
      const { errorMessage, httpStatusCode } = httpRequestInfo;
      if (errorMessage || httpStatusCode !== 200) {
        requestLc.error?.(
          `Got a non 200 response doing ${verb}: ${httpStatusCode}` + (errorMessage ? `: ${errorMessage}` : "")
        );
      }
      if (httpStatusCode !== httpStatusUnauthorized) {
        return {
          result,
          authFailure: false
        };
      }
      if (!this.getAuth) {
        return {
          result,
          authFailure: true
        };
      }
      let auth;
      try {
        await preAuth();
        auth = await this.getAuth();
      } finally {
        await postAuth();
      }
      if (auth === null || auth === void 0) {
        return {
          result,
          authFailure: true
        };
      }
      this.auth = auth;
      reauthAttempts++;
    } while (reauthAttempts < MAX_REAUTH_TRIES);
    lc.info?.("Tried to reauthenticate too many times");
    return {
      result: lastResult,
      authFailure: true
    };
  }
  #isPushDisabled() {
    return this.isClientGroupDisabled || this.pushURL === "" && isDefaultPusher(this.pusher);
  }
  async #invokePush() {
    if (false) {
      this.onPushInvoked();
    }
    if (this.#isPushDisabled()) {
      return true;
    }
    await this.#ready;
    const profileID = await this.#profileIDPromise;
    const { clientID } = this;
    const clientGroupID = await this.#clientGroupIDPromise;
    return this.#wrapInOnlineCheck(async () => {
      const { result: pusherResult } = await this.#wrapInReauthRetries(
        async (requestID, requestLc) => {
          try {
            this.#changeSyncCounters(1, 0);
            const pusherResult2 = await push(
              requestID,
              this.memdag,
              requestLc,
              profileID,
              clientGroupID,
              clientID,
              this.pusher,
              this.schemaVersion,
              PUSH_VERSION_DD31
            );
            return {
              result: pusherResult2,
              httpRequestInfo: pusherResult2?.httpRequestInfo
            };
          } finally {
            this.#changeSyncCounters(-1, 0);
          }
        },
        "push",
        this.#lc
      );
      if (pusherResult === void 0) {
        return true;
      }
      const { response, httpRequestInfo } = pusherResult;
      if (isVersionNotSupportedResponse(response)) {
        this.#handleVersionNotSupportedResponse(response);
      } else if (isClientStateNotFoundResponse(response)) {
        await this.#clientStateNotFoundOnServer();
      }
      return httpRequestInfo.httpStatusCode === 200;
    }, "Push");
  }
  #handleVersionNotSupportedResponse(response) {
    const reason = {
      type: response.error
    };
    if (response.versionType) {
      reason.versionType = response.versionType;
    }
    this.#fireOnUpdateNeeded(reason);
  }
  /**
   * Push pushes pending changes to the {@link pushURL}.
   *
   * You do not usually need to manually call push. If {@link pushDelay} is
   * non-zero (which it is by default) pushes happen automatically shortly after
   * mutations.
   *
   * If the server endpoint fails push will be continuously retried with an
   * exponential backoff.
   *
   * @param [now=false] If true, push will happen immediately and ignore
   *   {@link pushDelay}, {@link RequestOptions.minDelayMs} as well as the
   *   exponential backoff in case of errors.
   * @returns A promise that resolves when the next push completes. In case of
   * errors the first error will reject the returned promise. Subsequent errors
   * will not be reflected in the promise.
   */
  push({ now = false } = {}) {
    return throwIfError(this.#pushConnectionLoop.send(now));
  }
  /**
   * Pull pulls changes from the {@link pullURL}. If there are any changes local
   * changes will get replayed on top of the new server state.
   *
   * If the server endpoint fails pull will be continuously retried with an
   * exponential backoff.
   *
   * @param [now=false] If true, pull will happen immediately and ignore
   *   {@link RequestOptions.minDelayMs} as well as the exponential backoff in
   *   case of errors.
   * @returns A promise that resolves when the next pull completes. In case of
   * errors the first error will reject the returned promise. Subsequent errors
   * will not be reflected in the promise.
   */
  pull({ now = false } = {}) {
    return throwIfError(this.#pullConnectionLoop.send(now));
  }
  /**
   * Applies an update from the server to Replicache.
   * Throws an error if cookie does not match. In that case the server thinks
   * this client has a different cookie than it does; the caller should disconnect
   * from the server and re-register, which transmits the cookie the client actually
   * has.
   *
   * @experimental This method is under development and its semantics will change.
   */
  async poke(poke) {
    await this.#ready;
    const { clientID } = this;
    const requestID = newRequestID(clientID);
    const lc = this.#lc.withContext("handlePullResponse").withContext("requestID", requestID);
    const { pullResponse } = poke;
    if (isVersionNotSupportedResponse(pullResponse)) {
      this.#handleVersionNotSupportedResponse(pullResponse);
      return;
    }
    if (isClientStateNotFoundResponse(pullResponse)) {
      await this.#clientStateNotFoundOnServer();
      return;
    }
    const result = await handlePullResponseV1(
      lc,
      this.memdag,
      deepFreeze(poke.baseCookie),
      pullResponse,
      clientID,
      7 /* Latest */
    );
    switch (result.type) {
      case 0 /* Applied */:
        await this.maybeEndPull(result.syncHead, requestID);
        break;
      case 2 /* CookieMismatch */:
        throw new Error(
          "unexpected base cookie for poke: " + JSON.stringify(poke)
        );
        break;
      case 1 /* NoOp */:
        break;
    }
  }
  async beginPull() {
    if (false) {
      this.onBeginPull();
    }
    await this.#ready;
    const profileID = await this.profileID;
    const { clientID } = this;
    const clientGroupID = await this.#clientGroupIDPromise;
    const {
      result: { beginPullResponse, requestID }
    } = await this.#wrapInReauthRetries(
      async (requestID2, requestLc) => {
        const beginPullResponse2 = await beginPullV1(
          profileID,
          clientID,
          clientGroupID,
          this.schemaVersion,
          this.puller,
          requestID2,
          this.memdag,
          7 /* Latest */,
          requestLc
        );
        return {
          result: { beginPullResponse: beginPullResponse2, requestID: requestID2 },
          httpRequestInfo: beginPullResponse2.httpRequestInfo
        };
      },
      "pull",
      this.#lc,
      () => this.#changeSyncCounters(0, -1),
      () => this.#changeSyncCounters(0, 1)
    );
    const { pullResponse } = beginPullResponse;
    if (isVersionNotSupportedResponse(pullResponse)) {
      this.#handleVersionNotSupportedResponse(pullResponse);
    } else if (isClientStateNotFoundResponse(beginPullResponse.pullResponse)) {
      await this.#clientStateNotFoundOnServer();
    }
    const { syncHead, httpRequestInfo } = beginPullResponse;
    return { requestID, syncHead, ok: httpRequestInfo.httpStatusCode === 200 };
  }
  async persist() {
    assert(!this.#persistIsRunning);
    this.#persistIsRunning = true;
    try {
      const { clientID: clientID2 } = this;
      await this.#ready;
      if (this.#closed) {
        return;
      }
      try {
        await persistDD31(
          this.#lc,
          clientID2,
          this.memdag,
          this.perdag,
          this.#mutatorRegistry,
          () => this.closed,
          7 /* Latest */
        );
      } catch (e) {
        if (e instanceof ClientStateNotFoundError) {
          this.#clientStateNotFoundOnClient(clientID2);
        } else if (this.#closed) {
          this.#lc.debug?.("Exception persisting during close", e);
        } else {
          throw e;
        }
      }
    } finally {
      this.#persistIsRunning = false;
    }
    const { clientID } = this;
    const clientGroupID = await this.#clientGroupIDPromise;
    assert(clientGroupID);
    this.#onPersist({ clientID, clientGroupID });
  }
  async refresh() {
    await this.#ready;
    const { clientID } = this;
    if (this.#closed) {
      return;
    }
    let diffs;
    try {
      diffs = await refresh(
        this.#lc,
        this.memdag,
        this.perdag,
        clientID,
        this.#mutatorRegistry,
        this.subscriptions,
        () => this.closed,
        7 /* Latest */
      );
    } catch (e) {
      if (e instanceof ClientStateNotFoundError) {
        this.#clientStateNotFoundOnClient(clientID);
      } else if (this.#closed) {
        this.#lc.debug?.("Exception refreshing during close", e);
      } else {
        throw e;
      }
    }
    if (diffs !== void 0) {
      await this.subscriptions.fire(diffs);
    }
  }
  #fireOnClientStateNotFound() {
    this.onClientStateNotFound?.();
  }
  #clientStateNotFoundOnClient(clientID) {
    this.#lc.error?.(`Client state not found on client, clientID: ${clientID}`);
    this.#fireOnClientStateNotFound();
  }
  async #clientStateNotFoundOnServer() {
    const clientGroupID = await this.#clientGroupIDPromise;
    this.#lc.error?.(
      `Client state not found on server, clientGroupID: ${clientGroupID}`
    );
    await this.disableClientGroup();
    this.#fireOnClientStateNotFound();
  }
  async disableClientGroup() {
    const clientGroupID = await this.#clientGroupIDPromise;
    assert(clientGroupID);
    this.isClientGroupDisabled = true;
    await withWrite(
      this.perdag,
      (dagWrite) => disableClientGroup(clientGroupID, dagWrite)
    );
  }
  #fireOnUpdateNeeded(reason) {
    this.#lc.debug?.(`Update needed, reason: ${reason}`);
    this.onUpdateNeeded?.(reason);
  }
  async #schedulePersist() {
    if (!this.#enableScheduledPersist) {
      return;
    }
    await this.#schedule("persist", this.#persistScheduler);
  }
  async #handlePersist(persistInfo) {
    this.#lc.debug?.("Handling persist", persistInfo);
    const clientGroupID = await this.#clientGroupIDPromise;
    if (persistInfo.clientGroupID === clientGroupID) {
      void this.#scheduleRefresh();
    }
  }
  async #scheduleRefresh() {
    if (!this.#enableScheduledRefresh) {
      return;
    }
    await this.#schedule("refresh from storage", this.#refreshScheduler);
  }
  async #schedule(name, scheduler) {
    try {
      await scheduler.schedule();
    } catch (e) {
      if (e instanceof AbortError) {
        this.#lc.debug?.(`Scheduled ${name} did not complete before close.`);
      } else {
        this.#lc.error?.(`Error during ${name}`, e);
      }
    }
  }
  #changeSyncCounters(pushDelta, pullDelta) {
    this.#pushCounter += pushDelta;
    this.#pullCounter += pullDelta;
    const delta = pushDelta + pullDelta;
    const counter = this.#pushCounter + this.#pullCounter;
    if (delta === 1 && counter === 1 || counter === 0) {
      const syncing = counter > 0;
      Promise.resolve().then(() => this.onSync?.(syncing));
    }
  }
  /**
   * Subscribe to the result of a {@link query}. The `body` function is
   * evaluated once and its results are returned via `onData`.
   *
   * Thereafter, each time the the result of `body` changes, `onData` is fired
   * again with the new result.
   *
   * `subscribe()` goes to significant effort to avoid extraneous work
   * re-evaluating subscriptions:
   *
   * 1. subscribe tracks the keys that `body` accesses each time it runs. `body`
   *    is only re-evaluated when those keys change.
   * 2. subscribe only re-fires `onData` in the case that a result changes by
   *    way of the `isEqual` option which defaults to doing a deep JSON value
   *    equality check.
   *
   * Because of (1), `body` must be a pure function of the data in Replicache.
   * `body` must not access anything other than the `tx` parameter passed to it.
   *
   * Although subscribe is as efficient as it can be, it is somewhat constrained
   * by the goal of returning an arbitrary computation of the cache. For even
   * better performance (but worse dx), see {@link experimentalWatch}.
   *
   * If an error occurs in the `body` the `onError` function is called if
   * present. Otherwise, the error is logged at log level 'error'.
   *
   * To cancel the subscription, call the returned function.
   *
   * @param body The function to evaluate to get the value to pass into
   *    `onData`.
   * @param options Options is either a function or an object. If it is a
   *    function it is equivalent to passing it as the `onData` property of an
   *    object.
   */
  subscribe(body, options) {
    if (typeof options === "function") {
      options = { onData: options };
    }
    const { onData, onError, onDone, isEqual } = options;
    return this.subscriptions.add(
      new SubscriptionImpl(body, onData, onError, onDone, isEqual)
    );
  }
  experimentalWatch(callback, options) {
    return this.subscriptions.add(
      new WatchSubscription(callback, options)
    );
  }
  /**
   * Query is used for read transactions. It is recommended to use transactions
   * to ensure you get a consistent view across multiple calls to `get`, `has`
   * and `scan`.
   */
  query(body) {
    return this.#queryInternal(body);
  }
  get cookie() {
    return this.#ready.then(
      () => withRead(this.memdag, async (dagRead) => {
        const mainHeadHash = await dagRead.getHead(DEFAULT_HEAD_NAME);
        if (!mainHeadHash) {
          throw new Error("Internal no main head found");
        }
        const baseSnapshot = await baseSnapshotFromHash(mainHeadHash, dagRead);
        const baseSnapshotMeta = baseSnapshot.meta;
        const cookie = baseSnapshotMeta.cookieJSON;
        assertCookie(cookie);
        return cookie;
      })
    );
  }
  #queryInternal = async (body) => {
    await this.#ready;
    const { clientID } = this;
    return withRead(this.memdag, async (dagRead) => {
      try {
        const dbRead = await readFromDefaultHead(dagRead, 7 /* Latest */);
        const tx = new ReadTransactionImpl(clientID, dbRead, this.#lc);
        return await body(tx);
      } catch (ex) {
        throw await this.#convertToClientStateNotFoundError(ex);
      }
    });
  };
  #register(name, mutatorImpl) {
    this.#mutatorRegistry[name] = mutatorImpl;
    return (args) => this.#mutate(name, mutatorImpl, args, performance.now());
  }
  #registerMutators(regs) {
    const rv = /* @__PURE__ */ Object.create(null);
    for (const k in regs) {
      rv[k] = this.#register(k, regs[k]);
    }
    return rv;
  }
  async #mutate(name, mutatorImpl, args, timestamp) {
    const frozenArgs = deepFreeze(args ?? null);
    if (this.subscriptions.hasPendingSubscriptionRuns) {
      await Promise.resolve();
    }
    await this.#ready;
    const { clientID } = this;
    return withWriteNoImplicitCommit(this.memdag, async (dagWrite) => {
      try {
        const headHash = await mustGetHeadHash(DEFAULT_HEAD_NAME, dagWrite);
        const originalHash = null;
        const dbWrite = await newWriteLocal(
          headHash,
          name,
          frozenArgs,
          originalHash,
          dagWrite,
          timestamp,
          clientID,
          7 /* Latest */
        );
        const tx = new WriteTransactionImpl(
          clientID,
          await dbWrite.getMutationID(),
          "initial",
          dbWrite,
          this.#lc
        );
        const result = await mutatorImpl(tx, args);
        throwIfClosed(dbWrite);
        const lastMutationID = await dbWrite.getMutationID();
        const diffs = await dbWrite.commitWithDiffs(
          DEFAULT_HEAD_NAME,
          this.subscriptions
        );
        this.lastMutationID = lastMutationID;
        this.#pushConnectionLoop.send(false).catch(() => void 0);
        await this.subscriptions.fire(diffs);
        void this.#schedulePersist();
        return result;
      } catch (ex) {
        throw await this.#convertToClientStateNotFoundError(ex);
      }
    });
  }
  /**
   * In the case we get a ChunkNotFoundError we check if the client got garbage
   * collected and if so change the error to a ClientStateNotFoundError instead
   */
  async #convertToClientStateNotFoundError(ex) {
    if (ex instanceof ChunkNotFoundError && await this.#checkForClientStateNotFoundAndCallHandler()) {
      return new ClientStateNotFoundError(this.clientID);
    }
    return ex;
  }
  recoverMutations(preReadClientMap) {
    const result = this.#mutationRecovery.recoverMutations(
      preReadClientMap,
      this.#ready,
      this.perdag,
      this.#idbDatabase,
      this.#idbDatabases,
      this.#kvStoreProvider.create
    );
    if (false) {
      void this.onRecoverMutations(result);
    }
    return result;
  }
  /**
   * List of pending mutations. The order of this is from oldest to newest.
   *
   * Gives a list of local mutations that have `mutationID` >
   * `syncHead.mutationID` that exists on the main client group.
   *
   * @experimental This method is experimental and may change in the future.
   */
  experimentalPendingMutations() {
    return withRead(this.memdag, pendingMutationsForAPI);
  }
};
var closingInstances = /* @__PURE__ */ new Map();
async function throwIfError(p) {
  const res = await p;
  if (res) {
    throw res.error;
  }
}
function reload() {
  if (typeof location !== "undefined") {
    location.reload();
  }
}

// src/replicache.ts
var defaultMakeImpl = (options) => new ReplicacheImpl(options);
var makeImpl = defaultMakeImpl;
var httpStatusUnauthorized = 401;
function makeIDBName(name, schemaVersion) {
  return makeIDBNameInternal(name, schemaVersion, 7 /* Latest */);
}
function makeIDBNameInternal(name, schemaVersion, formatVersion) {
  const n = `rep:${name}:${formatVersion}`;
  return schemaVersion ? `${n}:${schemaVersion}` : n;
}
var Replicache = class {
  #impl;
  constructor(options) {
    this.#impl = makeImpl(options);
  }
  /** The URL to use when doing a pull request. */
  get pullURL() {
    return this.#impl.pullURL;
  }
  set pullURL(value) {
    this.#impl.pullURL = value;
  }
  /** The URL to use when doing a push request. */
  get pushURL() {
    return this.#impl.pushURL;
  }
  set pushURL(value) {
    this.#impl.pushURL = value;
  }
  /** The authorization token used when doing a push request. */
  get auth() {
    return this.#impl.auth;
  }
  set auth(value) {
    this.#impl.auth = value;
  }
  /** The name of the Replicache database. Populated by {@link ReplicacheOptions#name}. */
  get name() {
    return this.#impl.name;
  }
  /**
   * This is the name Replicache uses for the IndexedDB database where data is
   * stored.
   */
  get idbName() {
    return makeIDBName(this.name, this.schemaVersion);
  }
  /** The schema version of the data understood by this application. */
  get schemaVersion() {
    return this.#impl.schemaVersion;
  }
  /**
   * The mutators that was registered in the constructor.
   */
  get mutate() {
    return this.#impl.mutate;
  }
  /**
   * The duration between each periodic {@link pull}. Setting this to `null`
   * disables periodic pull completely. Pull will still happen if you call
   * {@link pull} manually.
   */
  get pullInterval() {
    return this.#impl.pullInterval;
  }
  set pullInterval(value) {
    this.#impl.pullInterval = value;
  }
  /**
   * The delay between when a change is made to Replicache and when Replicache
   * attempts to push that change.
   */
  get pushDelay() {
    return this.#impl.pushDelay;
  }
  set pushDelay(value) {
    this.#impl.pushDelay = value;
  }
  /**
   * The function to use to pull data from the server.
   */
  get puller() {
    return this.#impl.puller;
  }
  set puller(value) {
    this.#impl.puller = value;
  }
  /**
   * The function to use to push data to the server.
   */
  get pusher() {
    return this.#impl.pusher;
  }
  set pusher(value) {
    this.#impl.pusher = value;
  }
  /**
   * The options used to control the {@link pull} and push request behavior. This
   * object is live so changes to it will affect the next pull or push call.
   */
  get requestOptions() {
    return this.#impl.requestOptions;
  }
  /**
   * `onSync(true)` is called when Replicache transitions from no push or pull
   * happening to at least one happening. `onSync(false)` is called in the
   * opposite case: when Replicache transitions from at least one push or pull
   * happening to none happening.
   *
   * This can be used in a React like app by doing something like the following:
   *
   * ```js
   * const [syncing, setSyncing] = useState(false);
   * useEffect(() => {
   *   rep.onSync = setSyncing;
   * }, [rep]);
   * ```
   */
  get onSync() {
    return this.#impl.onSync;
  }
  set onSync(value) {
    this.#impl.onSync = value;
  }
  /**
   * `onClientStateNotFound` is called when the persistent client has been
   * garbage collected. This can happen if the client has no pending mutations
   * and has not been used for a while.
   *
   * The default behavior is to reload the page (using `location.reload()`). Set
   * this to `null` or provide your own function to prevent the page from
   * reloading automatically.
   */
  get onClientStateNotFound() {
    return this.#impl.onClientStateNotFound;
  }
  set onClientStateNotFound(value) {
    this.#impl.onClientStateNotFound = value;
  }
  /**
   * `onUpdateNeeded` is called when a code update is needed.
   *
   * A code update can be needed because:
   * - the server no longer supports the {@link pushVersion},
   *   {@link pullVersion} or {@link schemaVersion} of the current code.
   * - a new Replicache client has created a new client group, because its code
   *   has different mutators, indexes, schema version and/or format version
   *   from this Replicache client. This is likely due to the new client having
   *   newer code. A code update is needed to be able to locally sync with this
   *   new Replicache client (i.e. to sync while offline, the clients can can
   *   still sync with each other via the server).
   *
   * The default behavior is to reload the page (using `location.reload()`). Set
   * this to `null` or provide your own function to prevent the page from
   * reloading automatically. You may want to provide your own function to
   * display a toast to inform the end user there is a new version of your app
   * available and prompting them to refresh.
   */
  get onUpdateNeeded() {
    return this.#impl.onUpdateNeeded;
  }
  set onUpdateNeeded(value) {
    this.#impl.onUpdateNeeded = value;
  }
  /**
   * This gets called when we get an HTTP unauthorized (401) response from the
   * push or pull endpoint. Set this to a function that will ask your user to
   * reauthenticate.
   */
  get getAuth() {
    return this.#impl.getAuth;
  }
  set getAuth(value) {
    this.#impl.getAuth = value;
  }
  /**
   * The browser profile ID for this browser profile. Every instance of Replicache
   * browser-profile-wide shares the same profile ID.
   */
  get profileID() {
    return this.#impl.profileID;
  }
  /**
   * The client ID for this instance of Replicache. Each instance of Replicache
   * gets a unique client ID.
   */
  get clientID() {
    return this.#impl.clientID;
  }
  /**
   * The client group ID for this instance of Replicache. Instances of
   * Replicache will have the same client group ID if and only if they have
   * the same name, mutators, indexes, schema version, format version, and
   * browser profile.
   */
  get clientGroupID() {
    return this.#impl.clientGroupID;
  }
  /**
   * `onOnlineChange` is called when the {@link online} property changes. See
   * {@link online} for more details.
   */
  get onOnlineChange() {
    return this.#impl.onOnlineChange;
  }
  set onOnlineChange(value) {
    this.#impl.onOnlineChange = value;
  }
  /**
   * A rough heuristic for whether the client is currently online. Note that
   * there is no way to know for certain whether a client is online - the next
   * request can always fail. This property returns true if the last sync attempt succeeded,
   * and false otherwise.
   */
  get online() {
    return this.#impl.online;
  }
  /**
   * Whether the Replicache database has been closed. Once Replicache has been
   * closed it no longer syncs and you can no longer read or write data out of
   * it. After it has been closed it is pretty much useless and should not be
   * used any more.
   */
  get closed() {
    return this.#impl.closed;
  }
  /**
   * Closes this Replicache instance.
   *
   * When closed all subscriptions end and no more read or writes are allowed.
   */
  close() {
    return this.#impl.close();
  }
  /**
   * Push pushes pending changes to the {@link pushURLXXX}.
   *
   * You do not usually need to manually call push. If {@link pushDelay} is
   * non-zero (which it is by default) pushes happen automatically shortly after
   * mutations.
   *
   * If the server endpoint fails push will be continuously retried with an
   * exponential backoff.
   *
   * @param [now=false] If true, push will happen immediately and ignore
   *   {@link pushDelay}, {@link RequestOptions.minDelayMs} as well as the
   *   exponential backoff in case of errors.
   * @returns A promise that resolves when the next push completes. In case of
   * errors the first error will reject the returned promise. Subsequent errors
   * will not be reflected in the promise.
   */
  push({ now = false } = {}) {
    return this.#impl.push({ now });
  }
  /**
   * Pull pulls changes from the {@link pullURL}. If there are any changes local
   * changes will get replayed on top of the new server state.
   *
   * If the server endpoint fails pull will be continuously retried with an
   * exponential backoff.
   *
   * @param [now=false] If true, pull will happen immediately and ignore
   *   {@link RequestOptions.minDelayMs} as well as the exponential backoff in
   *   case of errors.
   * @returns A promise that resolves when the next pull completes. In case of
   * errors the first error will reject the returned promise. Subsequent errors
   * will not be reflected in the promise.
   */
  pull({ now = false } = {}) {
    return this.#impl.pull({ now });
  }
  /**
   * Applies an update from the server to Replicache.
   * Throws an error if cookie does not match. In that case the server thinks
   * this client has a different cookie than it does; the caller should disconnect
   * from the server and re-register, which transmits the cookie the client actually
   * has.
   *
   * @experimental This method is under development and its semantics will change.
   */
  poke(poke) {
    return this.#impl.poke(poke);
  }
  /**
   * Subscribe to the result of a {@link query}. The `body` function is
   * evaluated once and its results are returned via `onData`.
   *
   * Thereafter, each time the the result of `body` changes, `onData` is fired
   * again with the new result.
   *
   * `subscribe()` goes to significant effort to avoid extraneous work
   * re-evaluating subscriptions:
   *
   * 1. subscribe tracks the keys that `body` accesses each time it runs. `body`
   *    is only re-evaluated when those keys change.
   * 2. subscribe only re-fires `onData` in the case that a result changes by
   *    way of the `isEqual` option which defaults to doing a deep JSON value
   *    equality check.
   *
   * Because of (1), `body` must be a pure function of the data in Replicache.
   * `body` must not access anything other than the `tx` parameter passed to it.
   *
   * Although subscribe is as efficient as it can be, it is somewhat constrained
   * by the goal of returning an arbitrary computation of the cache. For even
   * better performance (but worse dx), see {@link experimentalWatch}.
   *
   * If an error occurs in the `body` the `onError` function is called if
   * present. Otherwise, the error is logged at log level 'error'.
   *
   * To cancel the subscription, call the returned function.
   *
   * @param body The function to evaluate to get the value to pass into
   *    `onData`.
   * @param options Options is either a function or an object. If it is a
   *    function it is equivalent to passing it as the `onData` property of an
   *    object.
   */
  subscribe(body, options) {
    return this.#impl.subscribe(body, options);
  }
  experimentalWatch(callback, options) {
    return this.#impl.experimentalWatch(callback, options);
  }
  /**
   * Query is used for read transactions. It is recommended to use transactions
   * to ensure you get a consistent view across multiple calls to `get`, `has`
   * and `scan`.
   */
  query(body) {
    return this.#impl.query(body);
  }
  /**
   * List of pending mutations. The order of this is from oldest to newest.
   *
   * Gives a list of local mutations that have `mutationID` >
   * `syncHead.mutationID` that exists on the main client group.
   *
   * @experimental This method is experimental and may change in the future.
   */
  experimentalPendingMutations() {
    return this.#impl.experimentalPendingMutations();
  }
};
var ReportError = class extends Error {
};
function createMemStore(name) {
  return new MemStore(name);
}
function getKVStoreProvider(lc, kvStore) {
  switch (kvStore) {
    case "idb":
    case void 0:
      return {
        create: (name) => newIDBStoreWithMemFallback(lc, name),
        drop: dropIDBStoreWithMemFallback
      };
    case "mem":
      return {
        create: createMemStore,
        drop: (name) => dropMemStore(name)
      };
    default:
      return kvStore;
  }
}

// src/persist/collect-idb-databases.ts
var COLLECT_INTERVAL_MS = 12 * 60 * 60 * 1e3;
var MAX_AGE = 30 * 24 * 60 * 60 * 1e3;
var DD31_MAX_AGE = 14 * 24 * 60 * 60 * 1e3;
var COLLECT_DELAY = 5 * 60 * 1e3;
function initCollectIDBDatabases(idbDatabasesStore, lc, signal, kvDropStore) {
  let initial = true;
  initBgIntervalProcess(
    "CollectIDBDatabases",
    async () => {
      await collectIDBDatabases(
        idbDatabasesStore,
        Date.now(),
        MAX_AGE,
        DD31_MAX_AGE,
        kvDropStore
      );
    },
    () => {
      if (initial) {
        initial = false;
        return COLLECT_DELAY;
      }
      return COLLECT_INTERVAL_MS;
    },
    lc,
    signal
  );
}
async function collectIDBDatabases(idbDatabasesStore, now, maxAge, dd31MaxAge, kvDropStore, newDagStore = defaultNewDagStore) {
  const databases = await idbDatabasesStore.getDatabases();
  const dbs = Object.values(databases);
  const canCollectResults = await Promise.all(
    dbs.map(
      async (db) => [
        db.name,
        await canCollectDatabase(db, now, maxAge, dd31MaxAge, newDagStore)
      ]
    )
  );
  const namesToRemove = canCollectResults.filter((result) => result[1]).map((result) => result[0]);
  const { errors } = await dropDatabases(
    idbDatabasesStore,
    namesToRemove,
    kvDropStore
  );
  if (errors.length) {
    throw errors[0];
  }
}
async function dropDatabaseInternal(name, idbDatabasesStore, kvDropStore) {
  await kvDropStore(name);
  await idbDatabasesStore.deleteDatabases([name]);
}
async function dropDatabases(idbDatabasesStore, namesToRemove, kvDropStore) {
  const dropStoreResults = await Promise.allSettled(
    namesToRemove.map(async (name) => {
      await dropDatabaseInternal(name, idbDatabasesStore, kvDropStore);
      return name;
    })
  );
  const dropped = [];
  const errors = [];
  for (const result of dropStoreResults) {
    if (result.status === "fulfilled") {
      dropped.push(result.value);
    } else {
      errors.push(result.reason);
    }
  }
  return { dropped, errors };
}
function defaultNewDagStore(name) {
  const perKvStore = new IDBStore(name);
  return new StoreImpl(perKvStore, newUUIDHash, assertHash);
}
async function canCollectDatabase(db, now, maxAge, dd31MaxAge, newDagStore) {
  if (db.replicacheFormatVersion > 7 /* Latest */) {
    return false;
  }
  if (db.lastOpenedTimestampMS !== void 0) {
    const isDD31 = db.replicacheFormatVersion >= 5 /* DD31 */;
    if (now - db.lastOpenedTimestampMS < (isDD31 ? dd31MaxAge : maxAge)) {
      return false;
    }
    if (!isDD31) {
      return true;
    }
    assert(
      db.replicacheFormatVersion === 5 /* DD31 */ || db.replicacheFormatVersion === 6 /* V6 */ || db.replicacheFormatVersion === 7 /* V7 */
    );
    return !await anyPendingMutationsInClientGroups(newDagStore(db.name));
  }
  const perdag = newDagStore(db.name);
  const clientMap = await withRead(perdag, getClients);
  await perdag.close();
  return allClientsOlderThan(clientMap, now, maxAge);
}
function allClientsOlderThan(clients, now, maxAge) {
  for (const client of clients.values()) {
    if (now - client.heartbeatTimestampMs < maxAge) {
      return false;
    }
  }
  return true;
}
async function dropDatabase(dbName, opts) {
  const logContext = createLogContext(opts?.logLevel, opts?.logSinks, {
    dropDatabase: void 0
  });
  const kvStoreProvider = getKVStoreProvider(logContext, opts?.kvStore);
  await dropDatabaseInternal(
    dbName,
    new IDBDatabasesStore(kvStoreProvider.create),
    kvStoreProvider.drop
  );
}
async function dropAllDatabases(opts) {
  const logContext = createLogContext(opts?.logLevel, opts?.logSinks, {
    dropAllDatabases: void 0
  });
  const kvStoreProvider = getKVStoreProvider(logContext, opts?.kvStore);
  const store = new IDBDatabasesStore(kvStoreProvider.create);
  const databases = await store.getDatabases();
  const dbNames = Object.values(databases).map((db) => db.name);
  const result = await dropDatabases(store, dbNames, kvStoreProvider.drop);
  return result;
}
function deleteAllReplicacheData(opts) {
  return dropAllDatabases(opts);
}
async function anyPendingMutationsInClientGroups(perdag) {
  const clientGroups = await withRead(perdag, getClientGroups);
  for (const clientGroup of clientGroups.values()) {
    if (clientGroupHasPendingMutations(clientGroup)) {
      return true;
    }
  }
  return false;
}
export {
  IDBNotFoundError,
  PullError,
  Replicache,
  TEST_LICENSE_KEY,
  TransactionClosedError,
  consoleLogSink3 as consoleLogSink,
  deleteAllReplicacheData,
  dropAllDatabases,
  dropDatabase,
  filterAsyncIterable,
  getDefaultPuller,
  isScanIndexOptions,
  makeIDBName,
  makeScanResult,
  mergeAsyncIterables,
  version
};
//# sourceMappingURL=replicache.js.map
